/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getViewer
// ====================================================

export interface getViewer_viewer_organization {
  __typename: "Organization";
  id: string;
  name: string;
  logoFilename: string | null;
  bccEmail: string | null;
  whoCanAssign: string | null;
  pmVisibility: string | null;
}

export interface getViewer_viewer_lists_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
}

export interface getViewer_viewer_lists {
  __typename: "ListItem";
  id: string;
  name: string;
  showsInAppList: boolean;
  scheduledUpdate: getViewer_viewer_lists_scheduledUpdate;
}

export interface getViewer_viewer_properties {
  __typename: "Property";
  id: string;
  name: string;
}

export interface getViewer_viewer_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface getViewer_viewer_logins {
  __typename: "UserLoginDetails";
  username: string;
  method: LoginMethod;
  verified: boolean;
  roles: UserRole[] | null;
}

export interface getViewer_viewer {
  __typename: "UserPostgres";
  id: string;
  roles: UserRole[];
  isClient: boolean | null;
  isAdmin: boolean;
  isSupervisor: boolean;
  isPropManager: boolean | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  organizationId: string | null;
  organization: getViewer_viewer_organization | null;
  /**
   * The waitlists a property manager user belongs to
   */
  lists: getViewer_viewer_lists[] | null;
  /**
   * The properties a property manager belongs to
   */
  properties: getViewer_viewer_properties[];
  features: getViewer_viewer_features[];
  logins: getViewer_viewer_logins[];
}

export interface getViewer {
  /**
   * Logged in user
   */
  viewer: getViewer_viewer | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createClientUser
// ====================================================

export interface createClientUser_createUser {
  __typename: "UserPostgres";
  id: string;
}

export interface createClientUser {
  /**
   * Create a user
   */
  createUser: createClientUser_createUser | null;
}

export interface createClientUserVariables {
  data: UserInput;
  requestCode?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppliedPropertyFeatures
// ====================================================

export interface AppliedPropertyFeatures_appliedPropertyFeatures {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface AppliedPropertyFeatures {
  /**
   * Returns the list of enabled feature flags for all properties the viewer has applied to
   */
  appliedPropertyFeatures: AppliedPropertyFeatures_appliedPropertyFeatures[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyFeatures
// ====================================================

export interface PropertyFeatures_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface PropertyFeatures_property {
  __typename: "Property";
  id: string;
  features: PropertyFeatures_property_features[];
}

export interface PropertyFeatures {
  /**
   * Property by it's ID
   */
  property: PropertyFeatures_property;
}

export interface PropertyFeaturesVariables {
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orgsForForm
// ====================================================

export interface orgsForForm_organizations {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface orgsForForm {
  /**
   * Fetch all organizations (admin)
   */
  organizations: orgsForForm_organizations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getInterestsLists
// ====================================================

export interface getInterestsLists_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface getInterestsLists {
  /**
   * Interest lists
   */
  interestLists: getInterestsLists_interestLists[];
}

export interface getInterestsListsVariables {
  isWaitList: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UserLoginPreflight
// ====================================================

export interface UserLoginPreflight_userLoginPreflight_login {
  __typename: "UserLoginDetails";
  username: string;
  verified: boolean;
  method: LoginMethod;
}

export interface UserLoginPreflight_userLoginPreflight {
  __typename: "UserLoginPreflightResponse";
  login: UserLoginPreflight_userLoginPreflight_login | null;
}

export interface UserLoginPreflight {
  /**
   * Begins the sign in flow by offering some details about the username.
   */
  userLoginPreflight: UserLoginPreflight_userLoginPreflight;
}

export interface UserLoginPreflightVariables {
  username: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UserLogin
// ====================================================

export interface UserLogin_userLogin {
  __typename: "UserLoginResponse";
  success: boolean | null;
  token: string | null;
  userId: string | null;
}

export interface UserLogin {
  userLogin: UserLogin_userLogin;
}

export interface UserLoginVariables {
  username: string;
  password: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UserPhoneLogin
// ====================================================

export interface UserPhoneLogin_userPhoneLogin {
  __typename: "UserLoginResponse";
  success: boolean | null;
  token: string | null;
  userId: string | null;
}

export interface UserPhoneLogin {
  userPhoneLogin: UserPhoneLogin_userPhoneLogin;
}

export interface UserPhoneLoginVariables {
  username: string;
  code: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UserGetCode
// ====================================================

export interface UserGetCode_userGetCode {
  __typename: "UserCodeResponse";
  success: boolean | null;
}

export interface UserGetCode {
  userGetCode: UserGetCode_userGetCode;
}

export interface UserGetCodeVariables {
  username: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateApplicantAccount
// ====================================================

export interface CreateApplicantAccount_createUser {
  __typename: "UserPostgres";
  id: string;
}

export interface CreateApplicantAccount {
  /**
   * Create a user
   */
  createUser: CreateApplicantAccount_createUser | null;
}

export interface CreateApplicantAccountVariables {
  data: UserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendEmailVerification
// ====================================================

export interface SendEmailVerification {
  sendEmailVerification: boolean | null;
}

export interface SendEmailVerificationVariables {
  email: string;
  redirectUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: VerifyEmail
// ====================================================

export interface VerifyEmail {
  verifyEmail: boolean | null;
}

export interface VerifyEmailVariables {
  email: string;
  code: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getInterestListById
// ====================================================

export interface getInterestListById_interestList_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface getInterestListById_interestList_property_propertyUseCases_useCase {
  __typename: "UseCase";
  friendlyName: string;
}

export interface getInterestListById_interestList_property_propertyUseCases {
  __typename: "PropertyUseCase";
  id: string;
  smsPrefix: string | null;
  active: boolean;
  useCase: getInterestListById_interestList_property_propertyUseCases_useCase;
}

export interface getInterestListById_interestList_property {
  __typename: "Property";
  id: string;
  name: string;
  respondToEmail: string | null;
  respondToEmailEnabled: boolean;
  features: getInterestListById_interestList_property_features[];
  propertyUseCases: getInterestListById_interestList_property_propertyUseCases[];
}

export interface getInterestListById_interestList {
  __typename: "InterestList";
  id: string;
  property: getInterestListById_interestList_property;
}

export interface getInterestListById {
  /**
   * Interest List
   */
  interestList: getInterestListById_interestList;
}

export interface getInterestListByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: myTemplateGroups
// ====================================================

export interface myTemplateGroups_templateGroups_templates {
  __typename: "Template";
  id: string;
  subject: string | null;
  body: string;
  type: TemplateType;
  isEmpty: boolean | null;
}

export interface myTemplateGroups_templateGroups {
  __typename: "TemplateGroup";
  id: string;
  name: string;
  userId: string | null;
  templates: myTemplateGroups_templateGroups_templates[];
}

export interface myTemplateGroups {
  /**
   * TemplateGroups for User
   */
  templateGroups: myTemplateGroups_templateGroups[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchPostgresViewer
// ====================================================

export interface FetchPostgresViewer_viewerPostgres_logins {
  __typename: "UserLoginDetails";
  username: string;
  method: LoginMethod;
  verified: boolean;
  roles: UserRole[] | null;
}

export interface FetchPostgresViewer_viewerPostgres {
  __typename: "UserPostgres";
  id: string;
  logins: FetchPostgresViewer_viewerPostgres_logins[];
}

export interface FetchPostgresViewer {
  viewerPostgres: FetchPostgresViewer_viewerPostgres | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: PropertyContractSidebarUpdated
// ====================================================

export interface PropertyContractSidebarUpdated_propertyContractSidebarUpdated {
  __typename: "PropertyContract";
  id: string;
  propertyName: string | null;
  status: string | null;
  interestListId: string | null;
}

export interface PropertyContractSidebarUpdated {
  /**
   * Emitted when a sent, signed, or cancelled contract changes — for the settings sidebar only.
   */
  propertyContractSidebarUpdated: PropertyContractSidebarUpdated_propertyContractSidebarUpdated | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: PropertyContractUpdated
// ====================================================

export interface PropertyContractUpdated_propertyContractUpdated {
  __typename: "PropertyContract";
  id: string;
  manuallyEntered: boolean | null;
  propertyId: string | null;
  interestListId: string | null;
  propertyName: string | null;
  propertyLegalName: string | null;
  unitCount: number | null;
  propertyPhone: string | null;
  propertyEmail: string | null;
  propertyAddress: string | null;
  propertyCityStateZip: string | null;
  inDevelopment: boolean | null;
  accountEmail: string | null;
  planId: string | null;
  planName: string | null;
  pricePerUnit: any | null;
  billingFrequency: string | null;
  signerName: string | null;
  signerEmail: string | null;
  signerTitle: string | null;
  signatureRequestId: string | null;
  submissionId: string | null;
  embedded: boolean | null;
  status: string | null;
  sentAt: string | null;
  signedAt: string | null;
  cancelledAt: string | null;
  contractStartDate: any | null;
  initialTermEndDate: any | null;
  hasPdf: boolean | null;
  pdfUrl: string | null;
}

export interface PropertyContractUpdated {
  /**
   * Emitted when a property contract in the viewer's organization is created or updated (status, signature, PDF, etc.).
   */
  propertyContractUpdated: PropertyContractUpdated_propertyContractUpdated | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL subscription operation: SettingsSidebarInterestListAdded
// ====================================================

export interface SettingsSidebarInterestListAdded_settingsSidebarInterestListAdded_property {
  __typename: "Property";
  id: string;
  isDraft: boolean | null;
}

export interface SettingsSidebarInterestListAdded_settingsSidebarInterestListAdded {
  __typename: "InterestList";
  id: string;
  name: string;
  property: SettingsSidebarInterestListAdded_settingsSidebarInterestListAdded_property;
}

export interface SettingsSidebarInterestListAdded {
  /**
   * Emitted when a new property interest list is created for the settings sidebar (e.g. after contract signing).
   */
  settingsSidebarInterestListAdded: SettingsSidebarInterestListAdded_settingsSidebarInterestListAdded | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createMonthlyBillings
// ====================================================

export interface createMonthlyBillings {
  createMonthlyBillings: boolean;
}

export interface createMonthlyBillingsVariables {
  month: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: invoicedTrackingQueries
// ====================================================

export interface invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_property_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_property {
  __typename: "Property";
  id: string;
  name: string;
  organization: invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_property_organization | null;
}

export interface invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface invoicedTrackingQueries_invoicedTrackings_invoicedCustomer {
  __typename: "InvoicedCustomer";
  relatedEntityType: RelatedEntityType;
  property: invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_property | null;
  organization: invoicedTrackingQueries_invoicedTrackings_invoicedCustomer_organization | null;
}

export interface invoicedTrackingQueries_invoicedTrackings {
  __typename: "InvoicedTracking";
  id: string;
  month: any;
  regularQuantity: number;
  overageQuantity: number;
  sentToInvoiced: boolean;
  invoicedSendError: string | null;
  queuedForInvoiced: boolean;
  invoicedCustomer: invoicedTrackingQueries_invoicedTrackings_invoicedCustomer;
}

export interface invoicedTrackingQueries {
  invoicedTrackings: invoicedTrackingQueries_invoicedTrackings[] | null;
}

export interface invoicedTrackingQueriesVariables {
  month: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: sendTrackingToInvoiced
// ====================================================

export interface sendTrackingToInvoiced {
  sendTrackingToInvoiced: boolean;
}

export interface sendTrackingToInvoicedVariables {
  trackingIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: letterJobQueries
// ====================================================

export interface letterJobQueries_letterJobs_interest_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface letterJobQueries_letterJobs_interest_interestList_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface letterJobQueries_letterJobs_interest_interestList {
  __typename: "InterestList";
  property: letterJobQueries_letterJobs_interest_interestList_property;
}

export interface letterJobQueries_letterJobs_interest {
  __typename: "Interest";
  id: string;
  userId: string | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  organization: letterJobQueries_letterJobs_interest_organization;
  interestList: letterJobQueries_letterJobs_interest_interestList;
}

export interface letterJobQueries_letterJobs {
  __typename: "LetterJob";
  id: string;
  insertedAt: string | null;
  pageCount: number | null;
  lobLetterId: string | null;
  interest: letterJobQueries_letterJobs_interest;
}

export interface letterJobQueries {
  letterJobs: letterJobQueries_letterJobs[];
}

export interface letterJobQueriesVariables {
  id: string;
  type: RelatedEntityType;
  startDate: any;
  endDate: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminPropertyContracts
// ====================================================

export interface AdminPropertyContracts_propertyContracts {
  __typename: "PropertyContract";
  id: string;
  manuallyEntered: boolean | null;
  propertyId: string | null;
  propertyName: string | null;
  propertyLegalName: string | null;
  unitCount: number | null;
  propertyPhone: string | null;
  propertyEmail: string | null;
  propertyAddress: string | null;
  propertyCityStateZip: string | null;
  inDevelopment: boolean | null;
  accountEmail: string | null;
  planId: string | null;
  planName: string | null;
  pricePerUnit: any | null;
  billingFrequency: string | null;
  signerName: string | null;
  signerEmail: string | null;
  status: string | null;
  sentAt: string | null;
  signedAt: string | null;
  contractStartDate: any | null;
  initialTermEndDate: any | null;
  pdfUrl: string | null;
}

export interface AdminPropertyContracts {
  /**
   * List all property contracts for the current organization (admin)
   */
  propertyContracts: AdminPropertyContracts_propertyContracts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertiesForManualContract
// ====================================================

export interface getPropertiesForManualContract_properties_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface getPropertiesForManualContract_properties_address {
  __typename: "Address";
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: any | null;
}

export interface getPropertiesForManualContract_properties {
  __typename: "Property";
  id: string;
  name: string;
  units: number | null;
  phone: string;
  email: string;
  organization: getPropertiesForManualContract_properties_organization | null;
  address: getPropertiesForManualContract_properties_address | null;
}

export interface getPropertiesForManualContract {
  /**
   * ALL properties (admin)
   */
  properties: getPropertiesForManualContract_properties[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getTeamForManualContract
// ====================================================

export interface getTeamForManualContract_organization_team {
  __typename: "UserPostgres";
  id: string;
  fullName: string | null;
  email: string | null;
  isArchived: boolean;
}

export interface getTeamForManualContract_organization {
  __typename: "Organization";
  id: string;
  team: getTeamForManualContract_organization_team[];
}

export interface getTeamForManualContract {
  /**
   * Fetch an organization by it's ID
   */
  organization: getTeamForManualContract_organization;
}

export interface getTeamForManualContractVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getOrganizationsForManualContract
// ====================================================

export interface getOrganizationsForManualContract_organizations {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface getOrganizationsForManualContract {
  /**
   * Fetch all organizations (admin)
   */
  organizations: getOrganizationsForManualContract_organizations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getSubscriptionsForManualContract
// ====================================================

export interface getSubscriptionsForManualContract_subscriptionsForProperty_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface getSubscriptionsForManualContract_subscriptionsForProperty_propertyInterestList_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface getSubscriptionsForManualContract_subscriptionsForProperty_propertyInterestList {
  __typename: "PropertyInterestListSubscription";
  id: string;
  interestList: getSubscriptionsForManualContract_subscriptionsForProperty_propertyInterestList_interestList | null;
}

export interface getSubscriptionsForManualContract_subscriptionsForProperty {
  __typename: "SubscriptionRecord";
  id: string;
  startDate: any | null;
  endDate: any | null;
  invoicedId: string | null;
  plan: getSubscriptionsForManualContract_subscriptionsForProperty_plan | null;
  propertyInterestList: getSubscriptionsForManualContract_subscriptionsForProperty_propertyInterestList | null;
}

export interface getSubscriptionsForManualContract {
  /**
   * Non-archived subscriptions scoped to a property's interest lists (manual-contract typeahead)
   */
  subscriptionsForProperty: getSubscriptionsForManualContract_subscriptionsForProperty[];
}

export interface getSubscriptionsForManualContractVariables {
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getManualContract
// ====================================================

export interface getManualContract_propertyContract_subscription_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface getManualContract_propertyContract_subscription {
  __typename: "SubscriptionRecord";
  id: string;
  startDate: any | null;
  endDate: any | null;
  invoicedId: string | null;
  plan: getManualContract_propertyContract_subscription_plan | null;
}

export interface getManualContract_propertyContract {
  __typename: "PropertyContract";
  id: string;
  manuallyEntered: boolean | null;
  propertyId: string | null;
  planId: string | null;
  unitCount: number | null;
  signedAt: string | null;
  billingFrequency: string | null;
  contractStartDate: any | null;
  initialTermEndDate: any | null;
  propertyLegalName: string | null;
  status: string | null;
  signerEmail: string | null;
  propertyPhone: string | null;
  propertyEmail: string | null;
  propertyAddress: string | null;
  hasPdf: boolean | null;
  /**
   * The subscription linked to this contract (via subscriptions.property_contract_id), if any. Admin-only; nil for other roles.
   */
  subscription: getManualContract_propertyContract_subscription | null;
}

export interface getManualContract {
  /**
   * Fetch a single property contract by id (admin)
   */
  propertyContract: getManualContract_propertyContract | null;
}

export interface getManualContractVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createManualPropertyContract
// ====================================================

export interface createManualPropertyContract_createManualPropertyContract {
  __typename: "PropertyContract";
  id: string;
}

export interface createManualPropertyContract {
  /**
   * Create a manually-entered property contract (admin)
   */
  createManualPropertyContract: createManualPropertyContract_createManualPropertyContract;
}

export interface createManualPropertyContractVariables {
  input: ManualPropertyContractInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateManualPropertyContract
// ====================================================

export interface updateManualPropertyContract_updateManualPropertyContract {
  __typename: "PropertyContract";
  id: string;
}

export interface updateManualPropertyContract {
  /**
   * Update a manually-entered property contract (admin)
   */
  updateManualPropertyContract: updateManualPropertyContract_updateManualPropertyContract;
}

export interface updateManualPropertyContractVariables {
  id: string;
  input: ManualPropertyContractInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FeatureFlagDashboard
// ====================================================

export interface FeatureFlagDashboard_featureFlags {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
  globalEnabled: boolean;
  globalDefaultEnabled: boolean;
}

export interface FeatureFlagDashboard_propertyFeatureFlags {
  __typename: "PropertyFeatureFlag";
  id: string;
  enabled: boolean;
  propertyId: string;
  featureId: string;
}

export interface FeatureFlagDashboard_properties {
  __typename: "Property";
  id: string;
  name: string;
}

export interface FeatureFlagDashboard {
  /**
   * Returns all feature flag records
   */
  featureFlags: FeatureFlagDashboard_featureFlags[] | null;
  /**
   * Returns all property specific feature flags
   */
  propertyFeatureFlags: FeatureFlagDashboard_propertyFeatureFlags[] | null;
  /**
   * ALL properties (admin)
   */
  properties: FeatureFlagDashboard_properties[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFeatureFlag
// ====================================================

export interface UpdateFeatureFlag_updateFeatureFlag {
  __typename: "FeatureFlag";
  id: string;
}

export interface UpdateFeatureFlag {
  /**
   * Update a feature flag status
   */
  updateFeatureFlag: UpdateFeatureFlag_updateFeatureFlag[] | null;
}

export interface UpdateFeatureFlagVariables {
  id: string;
  globalEnabled: boolean;
  globalDefaultEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteFeatureFlag
// ====================================================

export interface DeleteFeatureFlag {
  /**
   * Delete a feature flag
   */
  deleteFeatureFlag: string | null;
}

export interface DeleteFeatureFlagVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreatePropertyFeatureFlag
// ====================================================

export interface CreatePropertyFeatureFlag_createPropertyFeatureFlag {
  __typename: "PropertyFeatureFlag";
  id: string;
}

export interface CreatePropertyFeatureFlag {
  /**
   * Create a property feature flag
   */
  createPropertyFeatureFlag: CreatePropertyFeatureFlag_createPropertyFeatureFlag | null;
}

export interface CreatePropertyFeatureFlagVariables {
  featureId: string;
  propertyId: string;
  enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePropertyFeatureFlag
// ====================================================

export interface UpdatePropertyFeatureFlag_updatePropertyFeatureFlag {
  __typename: "PropertyFeatureFlag";
  id: string;
}

export interface UpdatePropertyFeatureFlag {
  /**
   * Update a property feature flag status
   */
  updatePropertyFeatureFlag: UpdatePropertyFeatureFlag_updatePropertyFeatureFlag | null;
}

export interface UpdatePropertyFeatureFlagVariables {
  id: string;
  enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeletePropertyFeatureFlag
// ====================================================

export interface DeletePropertyFeatureFlag_deletePropertyFeatureFlag {
  __typename: "PropertyFeatureFlag";
  id: string;
}

export interface DeletePropertyFeatureFlag {
  /**
   * Delete a property feature flag
   */
  deletePropertyFeatureFlag: DeletePropertyFeatureFlag_deletePropertyFeatureFlag | null;
}

export interface DeletePropertyFeatureFlagVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getFormNamesByQuestion
// ====================================================

export interface getFormNamesByQuestion_formsByQuestion {
  __typename: "FormName";
  formDraftId: string;
  name: string;
}

export interface getFormNamesByQuestion {
  formsByQuestion: getFormNamesByQuestion_formsByQuestion[];
}

export interface getFormNamesByQuestionVariables {
  questionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getFormQuestions
// ====================================================

export interface getFormQuestions_formQuestions {
  __typename: "FormQuestionType";
  id: string;
  name: string;
  valueType: ValueType;
  usedBy: number;
}

export interface getFormQuestions {
  /**
   * Fetch all form question types (admin)
   */
  formQuestions: getFormQuestions_formQuestions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createFormQuestionType
// ====================================================

export interface createFormQuestionType_createFormQuestion {
  __typename: "FormQuestionType";
  name: string;
  valueType: ValueType;
}

export interface createFormQuestionType {
  /**
   * Create a form quesiton (admin)
   */
  createFormQuestion: createFormQuestionType_createFormQuestion | null;
}

export interface createFormQuestionTypeVariables {
  data: FormQuestionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateFormQuestionType
// ====================================================

export interface updateFormQuestionType_updateFormQuestion {
  __typename: "FormQuestionType";
  id: string;
  name: string;
  valueType: ValueType;
}

export interface updateFormQuestionType {
  updateFormQuestion: updateFormQuestionType_updateFormQuestion | null;
}

export interface updateFormQuestionTypeVariables {
  id: string;
  data: FormQuestionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getFormQuestionVariants
// ====================================================

export interface getFormQuestionVariants_formQuestionVariants {
  __typename: "FormQuestionVariantType";
  id: string;
  questionName: string;
  valueType: ValueType;
  version: number;
  title: string;
  usedBy: number;
  rawData: string;
}

export interface getFormQuestionVariants {
  /**
   * Fetch stored form question variants (admin)
   */
  formQuestionVariants: getFormQuestionVariants_formQuestionVariants[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProperties
// ====================================================

export interface GetProperties_properties {
  __typename: "Property";
  id: string;
  name: string;
}

export interface GetProperties {
  /**
   * ALL properties (admin)
   */
  properties: GetProperties_properties[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getFormDefinitions
// ====================================================

export interface getFormDefinitions_formDefinitions_property {
  __typename: "Property";
  name: string;
}

export interface getFormDefinitions_formDefinitions_form {
  __typename: "Form";
  open: boolean;
  display: boolean;
}

export interface getFormDefinitions_formDefinitions {
  __typename: "FormDefinition";
  id: string;
  name: string;
  property: getFormDefinitions_formDefinitions_property | null;
  enabled: boolean;
  createInterest: boolean;
  skipSignature: boolean;
  formType: FormType;
  formId: string | null;
  form: getFormDefinitions_formDefinitions_form | null;
}

export interface getFormDefinitions {
  /**
   * Fetch all form definitions (admin)
   */
  formDefinitions: getFormDefinitions_formDefinitions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LoadForm
// ====================================================

export interface LoadForm_loadFormDefinition_form {
  __typename: "Form";
  id: string;
  open: boolean;
  display: boolean;
}

export interface LoadForm_loadFormDefinition {
  __typename: "FormDefinition";
  id: string;
  formId: string | null;
  form: LoadForm_loadFormDefinition_form | null;
}

export interface LoadForm {
  /**
   * Load definition to form by id (admin)
   */
  loadFormDefinition: LoadForm_loadFormDefinition | null;
}

export interface LoadFormVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createForm
// ====================================================

export interface createForm_createFormDefinition {
  __typename: "FormDefinition";
  name: string;
  content: string;
  propertyId: string;
  enabled: boolean;
  createInterest: boolean;
  formType: FormType;
  skipSignature: boolean;
  renderParagraphs: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
}

export interface createForm {
  /**
   * Create a form definition (admin)
   */
  createFormDefinition: createForm_createFormDefinition | null;
}

export interface createFormVariables {
  data: FormDefinitionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: updateFormDefinitionForm
// ====================================================

export interface updateFormDefinitionForm_formDefinition_form {
  __typename: "Form";
  id: string;
  open: boolean;
  display: boolean;
}

export interface updateFormDefinitionForm_formDefinition {
  __typename: "FormDefinition";
  id: string;
  name: string;
  content: string;
  enabled: boolean;
  createInterest: boolean;
  propertyId: string;
  formType: FormType;
  skipSignature: boolean;
  renderParagraphs: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
  formId: string | null;
  form: updateFormDefinitionForm_formDefinition_form | null;
}

export interface updateFormDefinitionForm {
  /**
   * Fetch definitions by id (admin)
   */
  formDefinition: updateFormDefinitionForm_formDefinition;
}

export interface updateFormDefinitionFormVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateFormDefinition
// ====================================================

export interface updateFormDefinition_updateFormDefinition {
  __typename: "FormDefinition";
  id: string;
  name: string;
  content: string;
  enabled: boolean;
  createInterest: boolean;
  propertyId: string;
  formType: FormType;
  skipSignature: boolean;
  renderParagraphs: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
  formId: string | null;
}

export interface updateFormDefinition {
  /**
   * Update definition by id (admin)
   */
  updateFormDefinition: updateFormDefinition_updateFormDefinition | null;
}

export interface updateFormDefinitionVariables {
  id: string;
  data: FormDefinitionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ImportListCSVMutation
// ====================================================

export interface ImportListCSVMutation_importInterestList {
  __typename: "CsvImportResults";
  success: boolean;
  /**
   * True when the import was queued to run in the background (large CSVs).
   */
  queued: boolean | null;
}

export interface ImportListCSVMutation {
  importInterestList: ImportListCSVMutation_importInterestList | null;
}

export interface ImportListCSVMutationVariables {
  id: string;
  csv: string;
  csvFileName?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestListsWithOrgQuery
// ====================================================

export interface InterestListsWithOrgQuery_interestLists_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface InterestListsWithOrgQuery_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  organization: InterestListsWithOrgQuery_interestLists_organization | null;
}

export interface InterestListsWithOrgQuery {
  /**
   * Interest lists
   */
  interestLists: InterestListsWithOrgQuery_interestLists[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ImportLotteryCSVMutation
// ====================================================

export interface ImportLotteryCSVMutation_importCsv_messages {
  __typename: "CsvImportMessages";
  row: number;
  details: any;
}

export interface ImportLotteryCSVMutation_importCsv {
  __typename: "CsvImportResults";
  success: boolean;
  messages: ImportLotteryCSVMutation_importCsv_messages[] | null;
}

export interface ImportLotteryCSVMutation {
  /**
   * Import a CSV
   */
  importCsv: ImportLotteryCSVMutation_importCsv | null;
}

export interface ImportLotteryCSVMutationVariables {
  id: string;
  csv: string;
  config: CsvImportConfigInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ImporterConfigQuery
// ====================================================

export interface ImporterConfigQuery_interestLists_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface ImporterConfigQuery_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  organization: ImporterConfigQuery_interestLists_organization | null;
}

export interface ImporterConfigQuery_csvImporterConfig {
  __typename: "CsvImportConfig";
  column: string;
  label: string;
  description: string | null;
  required: boolean | null;
}

export interface ImporterConfigQuery {
  /**
   * Interest lists
   */
  interestLists: ImporterConfigQuery_interestLists[];
  /**
   * Returns configuration to drive the CSV importer
   */
  csvImporterConfig: ImporterConfigQuery_csvImporterConfig[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminUpdateInterest
// ====================================================

export interface AdminUpdateInterest_adminUpdateInterest {
  __typename: "Interest";
  id: string;
}

export interface AdminUpdateInterest {
  /**
   * Update an interests submission date
   */
  adminUpdateInterest: AdminUpdateInterest_adminUpdateInterest | null;
}

export interface AdminUpdateInterestVariables {
  id: string;
  submittedAt?: string | null;
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: adminSearchInterests
// ====================================================

export interface adminSearchInterests_adminSearchInterests {
  __typename: "InterestSearchResult";
  applicantEmail: string | null;
  applicantPrimaryPhone: string | null;
  applicantPrimaryPhoneType: string | null;
  applicantSecondaryPhone: string | null;
  applicantSecondaryPhoneType: string | null;
  contactEmail: string | null;
  contactName: string | null;
  firstName: string | null;
  hasAccount: boolean | null;
  householdMember0Email: string | null;
  id: string;
  lastName: string | null;
  linkCode: string | null;
  loginEmail: string | null;
  loginPhone: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  organizationName: string;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  submittedAt: string | null;
  userId: string | null;
  waitlistName: string;
  waitlistStatus: string | null;
  waitlistUpdateCode: string | null;
  waitlistUpdateResponded: boolean | null;
  waitlistUpdateRespondedAt: string | null;
}

export interface adminSearchInterests {
  adminSearchInterests: adminSearchInterests_adminSearchInterests[] | null;
}

export interface adminSearchInterestsVariables {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  strict?: boolean | null;
  includeIncomplete?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestFilterDashboard
// ====================================================

export interface InterestFilterDashboard_interestList_interestFilters {
  __typename: "InterestFilter";
  id: string;
  label: string;
  name: string;
  type: string;
}

export interface InterestFilterDashboard_interestList {
  __typename: "InterestList";
  id: string;
  interestFilters: InterestFilterDashboard_interestList_interestFilters[] | null;
}

export interface InterestFilterDashboard_interestFilters {
  __typename: "InterestFilter";
  id: string;
  label: string;
  name: string;
  type: string;
}

export interface InterestFilterDashboard {
  /**
   * Interest List
   */
  interestList: InterestFilterDashboard_interestList;
  /**
   * Fetch all interest filters
   */
  interestFilters: InterestFilterDashboard_interestFilters[] | null;
}

export interface InterestFilterDashboardVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InsertInterestFilter
// ====================================================

export interface InsertInterestFilter_addFilterToInterestList {
  __typename: "InterestFilter";
  id: string;
}

export interface InsertInterestFilter {
  /**
   * Turn interest filters on/off for a given interest list
   */
  addFilterToInterestList: InsertInterestFilter_addFilterToInterestList | null;
}

export interface InsertInterestFilterVariables {
  interestListId: string;
  filterId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteInterestFilter
// ====================================================

export interface DeleteInterestFilter_deleteFilterForInterestList {
  __typename: "InterestFilter";
  id: string;
}

export interface DeleteInterestFilter {
  /**
   * Turn interest filters on/off for a given interest list
   */
  deleteFilterForInterestList: DeleteInterestFilter_deleteFilterForInterestList | null;
}

export interface DeleteInterestFilterVariables {
  interestListId: string;
  filterId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getLists
// ====================================================

export interface getLists_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  type: string | null;
  organizationId: string;
  isArchived: boolean | null;
}

export interface getLists {
  /**
   * Interest lists
   */
  interestLists: getLists_interestLists[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getOrganizations
// ====================================================

export interface getOrganizations_organizations {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface getOrganizations {
  /**
   * Fetch all organizations (admin)
   */
  organizations: getOrganizations_organizations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: newList
// ====================================================

export interface newList_createInterestList {
  __typename: "InterestList";
  id: string;
}

export interface newList {
  /**
   * Create InterestList (admin)
   */
  createInterestList: newList_createInterestList | null;
}

export interface newListVariables {
  data: InterestListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UnitDisclaimers
// ====================================================

export interface UnitDisclaimers_interestList {
  __typename: "InterestList";
  br0Statement: string | null;
  br1Statement: string | null;
  br1DenStatement: string | null;
  br2Statement: string | null;
  br3Statement: string | null;
  br4Statement: string | null;
  br5Statement: string | null;
  sharedStatement: string | null;
}

export interface UnitDisclaimers {
  /**
   * Interest List
   */
  interestList: UnitDisclaimers_interestList;
}

export interface UnitDisclaimersVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestListPageTitle
// ====================================================

export interface InterestListPageTitle_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface InterestListPageTitle {
  /**
   * Interest List
   */
  interestList: InterestListPageTitle_interestList;
}

export interface InterestListPageTitleVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyPageTitle
// ====================================================

export interface PropertyPageTitle_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface PropertyPageTitle {
  /**
   * Property by it's ID
   */
  property: PropertyPageTitle_property;
}

export interface PropertyPageTitleVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateDisclaimers
// ====================================================

export interface UpdateDisclaimers_updateInterestList {
  __typename: "InterestList";
  id: string;
}

export interface UpdateDisclaimers {
  /**
   * Update InterestList (admin)
   */
  updateInterestList: UpdateDisclaimers_updateInterestList | null;
}

export interface UpdateDisclaimersVariables {
  id: string;
  data: InterestListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getListForAdmin
// ====================================================

export interface getListForAdmin_interestList_address {
  __typename: "Address";
  name: string | null;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: any | null;
}

export interface getListForAdmin_interestList {
  __typename: "InterestList";
  id: string;
  isArchived: boolean | null;
  name: string;
  type: string | null;
  email: string | null;
  phone: string | null;
  organizationId: string;
  hasPaperDisclaimer: boolean | null;
  address: getListForAdmin_interestList_address;
}

export interface getListForAdmin {
  /**
   * Interest List
   */
  interestList: getListForAdmin_interestList;
}

export interface getListForAdminVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateList
// ====================================================

export interface updateList_updateInterestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface updateList {
  /**
   * Update InterestList (admin)
   */
  updateInterestList: updateList_updateInterestList | null;
}

export interface updateListVariables {
  id: string;
  data: InterestListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orgsList
// ====================================================

export interface orgsList_organizations {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface orgsList {
  /**
   * Fetch all organizations (admin)
   */
  organizations: orgsList_organizations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: newOrg
// ====================================================

export interface newOrg_createOrganization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface newOrg {
  /**
   * Create an organization
   */
  createOrganization: newOrg_createOrganization | null;
}

export interface newOrgVariables {
  data: OrganizationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getOrg
// ====================================================

export interface getOrg_organization_invoicedCustomer {
  __typename: "InvoicedCustomer";
  invoicedId: string | null;
  active: boolean;
}

export interface getOrg_organization {
  __typename: "Organization";
  id: string;
  name: string;
  type: string | null;
  email: string | null;
  bccEmail: string | null;
  phone: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  invoicedCustomer: getOrg_organization_invoicedCustomer | null;
}

export interface getOrg {
  /**
   * Fetch an organization by it's ID
   */
  organization: getOrg_organization;
}

export interface getOrgVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateOrg
// ====================================================

export interface updateOrg_updateOrganization_invoicedCustomer {
  __typename: "InvoicedCustomer";
  invoicedId: string | null;
  active: boolean;
}

export interface updateOrg_updateOrganization {
  __typename: "Organization";
  id: string;
  name: string;
  type: string | null;
  email: string | null;
  bccEmail: string | null;
  phone: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  invoicedCustomer: updateOrg_updateOrganization_invoicedCustomer | null;
}

export interface updateOrg {
  /**
   * Update an organization
   */
  updateOrganization: updateOrg_updateOrganization | null;
}

export interface updateOrgVariables {
  id: string;
  data: OrganizationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: plansAll
// ====================================================

export interface plansAll_plansAll_invoicedPlanIds {
  __typename: "InvoicedPlanIds";
  annually: string | null;
  quarterly: string | null;
}

export interface plansAll_plansAll_defaultPricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface plansAll_plansAll_defaultPricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface plansAll_plansAll_defaultPricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: plansAll_plansAll_defaultPricing_pricingType | null;
  thresholdType: plansAll_plansAll_defaultPricing_thresholdType | null;
}

export interface plansAll_plansAll {
  __typename: "Plan";
  id: string;
  name: string;
  description: string;
  isPublic: boolean | null;
  defaultPricingId: string | null;
  invoicedPlanIds: plansAll_plansAll_invoicedPlanIds | null;
  insertedAt: string | null;
  updatedAt: string | null;
  defaultPricing: plansAll_plansAll_defaultPricing | null;
}

export interface plansAll {
  /**
   * Fetch all plans
   */
  plansAll: plansAll_plansAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: planPricingQuote
// ====================================================

export interface planPricingQuote_planPricingQuote {
  __typename: "PlanPricingQuote";
  monthlyRecurring: any | null;
  annualEquivalentTotal: any | null;
  annualDiscountPercent: number | null;
  monthlyBeforeDiscount: any | null;
  annualPaymentDiscountAmount: any | null;
  oneTimeSetupFee: any | null;
}

export interface planPricingQuote {
  /**
   * Computed subscription pricing for a plan (uses Haven.Domain.Pricing)
   */
  planPricingQuote: planPricingQuote_planPricingQuote | null;
}

export interface planPricingQuoteVariables {
  planId: string;
  billingCycle: string;
  unitCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: plan
// ====================================================

export interface plan_plan_invoicedPlanIds {
  __typename: "InvoicedPlanIds";
  annually: string | null;
  quarterly: string | null;
}

export interface plan_plan_defaultPricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface plan_plan_defaultPricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface plan_plan_defaultPricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: plan_plan_defaultPricing_pricingType | null;
  thresholdType: plan_plan_defaultPricing_thresholdType | null;
}

export interface plan_plan {
  __typename: "Plan";
  id: string;
  name: string;
  description: string;
  isPublic: boolean | null;
  defaultPricingId: string | null;
  invoicedPlanIds: plan_plan_invoicedPlanIds | null;
  insertedAt: string | null;
  updatedAt: string | null;
  defaultPricing: plan_plan_defaultPricing | null;
}

export interface plan {
  /**
   * Fetch a plan by ID
   */
  plan: plan_plan | null;
}

export interface planVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createPlan
// ====================================================

export interface createPlan_createPlan_invoicedPlanIds {
  __typename: "InvoicedPlanIds";
  annually: string | null;
  quarterly: string | null;
}

export interface createPlan_createPlan_defaultPricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface createPlan_createPlan_defaultPricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface createPlan_createPlan_defaultPricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: createPlan_createPlan_defaultPricing_pricingType | null;
  thresholdType: createPlan_createPlan_defaultPricing_thresholdType | null;
}

export interface createPlan_createPlan {
  __typename: "Plan";
  id: string;
  name: string;
  description: string;
  isPublic: boolean | null;
  defaultPricingId: string | null;
  invoicedPlanIds: createPlan_createPlan_invoicedPlanIds | null;
  insertedAt: string | null;
  updatedAt: string | null;
  defaultPricing: createPlan_createPlan_defaultPricing | null;
}

export interface createPlan {
  /**
   * Create a plan
   */
  createPlan: createPlan_createPlan | null;
}

export interface createPlanVariables {
  data: PlanInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePlan
// ====================================================

export interface updatePlan_updatePlan_invoicedPlanIds {
  __typename: "InvoicedPlanIds";
  annually: string | null;
  quarterly: string | null;
}

export interface updatePlan_updatePlan_defaultPricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface updatePlan_updatePlan_defaultPricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface updatePlan_updatePlan_defaultPricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: updatePlan_updatePlan_defaultPricing_pricingType | null;
  thresholdType: updatePlan_updatePlan_defaultPricing_thresholdType | null;
}

export interface updatePlan_updatePlan {
  __typename: "Plan";
  id: string;
  name: string;
  description: string;
  isPublic: boolean | null;
  defaultPricingId: string | null;
  invoicedPlanIds: updatePlan_updatePlan_invoicedPlanIds | null;
  insertedAt: string | null;
  updatedAt: string | null;
  defaultPricing: updatePlan_updatePlan_defaultPricing | null;
}

export interface updatePlan {
  /**
   * Update a plan
   */
  updatePlan: updatePlan_updatePlan | null;
}

export interface updatePlanVariables {
  id: string;
  data: PlanUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deletePlan
// ====================================================

export interface deletePlan_deletePlan {
  __typename: "Plan";
  id: string;
}

export interface deletePlan {
  /**
   * Delete a plan
   */
  deletePlan: deletePlan_deletePlan | null;
}

export interface deletePlanVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingAllForPlans
// ====================================================

export interface pricingAllForPlans_pricingAll_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface pricingAllForPlans_pricingAll_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface pricingAllForPlans_pricingAll {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: pricingAllForPlans_pricingAll_pricingType | null;
  thresholdType: pricingAllForPlans_pricingAll_thresholdType | null;
}

export interface pricingAllForPlans {
  /**
   * Fetch all pricing configurations
   */
  pricingAll: pricingAllForPlans_pricingAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingAll
// ====================================================

export interface pricingAll_pricingAll_tiers {
  __typename: "PricingTier";
  id: string;
  lowerThreshold: number | null;
  monthlyPrice: any | null;
}

export interface pricingAll_pricingAll_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface pricingAll_pricingAll_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface pricingAll_pricingAll {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  tiers: pricingAll_pricingAll_tiers[];
  pricingType: pricingAll_pricingAll_pricingType | null;
  thresholdType: pricingAll_pricingAll_thresholdType | null;
}

export interface pricingAll {
  /**
   * Fetch all pricing configurations
   */
  pricingAll: pricingAll_pricingAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricing
// ====================================================

export interface pricing_pricing_tiers {
  __typename: "PricingTier";
  id: string;
  lowerThreshold: number | null;
  monthlyPrice: any | null;
}

export interface pricing_pricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface pricing_pricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface pricing_pricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  tiers: pricing_pricing_tiers[];
  pricingType: pricing_pricing_pricingType | null;
  thresholdType: pricing_pricing_thresholdType | null;
}

export interface pricing {
  /**
   * Fetch a pricing configuration by ID
   */
  pricing: pricing_pricing;
}

export interface pricingVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createPricing
// ====================================================

export interface createPricing_createPricing_tiers {
  __typename: "PricingTier";
  id: string;
  lowerThreshold: number | null;
  monthlyPrice: any | null;
}

export interface createPricing_createPricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface createPricing_createPricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface createPricing_createPricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  tiers: createPricing_createPricing_tiers[];
  pricingType: createPricing_createPricing_pricingType | null;
  thresholdType: createPricing_createPricing_thresholdType | null;
}

export interface createPricing {
  /**
   * Create a pricing configuration
   */
  createPricing: createPricing_createPricing | null;
}

export interface createPricingVariables {
  data: PricingInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePricing
// ====================================================

export interface updatePricing_updatePricing_tiers {
  __typename: "PricingTier";
  id: string;
  lowerThreshold: number | null;
  monthlyPrice: any | null;
}

export interface updatePricing_updatePricing_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface updatePricing_updatePricing_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface updatePricing_updatePricing {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  annualDiscountPercent: number | null;
  monthlyPricePerUnit: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  tiers: updatePricing_updatePricing_tiers[];
  pricingType: updatePricing_updatePricing_pricingType | null;
  thresholdType: updatePricing_updatePricing_thresholdType | null;
}

export interface updatePricing {
  /**
   * Update a pricing configuration
   */
  updatePricing: updatePricing_updatePricing | null;
}

export interface updatePricingVariables {
  id: string;
  data: PricingUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deletePricing
// ====================================================

export interface deletePricing_deletePricing {
  __typename: "Pricing";
  id: string;
}

export interface deletePricing {
  /**
   * Delete a pricing configuration
   */
  deletePricing: deletePricing_deletePricing | null;
}

export interface deletePricingVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingTypes
// ====================================================

export interface pricingTypes_pricingTypes {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface pricingTypes {
  /**
   * Fetch all pricing types
   */
  pricingTypes: pricingTypes_pricingTypes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: thresholdTypes
// ====================================================

export interface thresholdTypes_thresholdTypes {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface thresholdTypes {
  /**
   * Fetch all threshold types
   */
  thresholdTypes: thresholdTypes_thresholdTypes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingCalculator
// ====================================================

export interface pricingCalculator_pricingCalculator_lines {
  __typename: "PricingCalculatorLine";
  rate: any;
  unitCount: number;
  subtotal: any;
}

export interface pricingCalculator_pricingCalculator {
  __typename: "PricingCalculatorResult";
  grandTotal: any;
  averagePerUnit: any | null;
  minimumApplied: boolean;
  thresholdMet: boolean;
  minimumIgnored: boolean;
  lines: pricingCalculator_pricingCalculator_lines[];
}

export interface pricingCalculator {
  /**
   * Preview monthly cost breakdown for a pricing configuration and unit count
   */
  pricingCalculator: pricingCalculator_pricingCalculator;
}

export interface pricingCalculatorVariables {
  unitCount: number;
  pricing: PricingCalculatorInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getAllProperties
// ====================================================

export interface getAllProperties_properties_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface getAllProperties_properties_interestList {
  __typename: "InterestList";
  isArchived: boolean | null;
}

export interface getAllProperties_properties {
  __typename: "Property";
  id: string;
  name: string;
  units: number | null;
  organization: getAllProperties_properties_organization | null;
  interestList: getAllProperties_properties_interestList;
}

export interface getAllProperties {
  /**
   * ALL properties (admin)
   */
  properties: getAllProperties_properties[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createProperty
// ====================================================

export interface createProperty_createProperty_address {
  __typename: "Address";
  address1: string;
  city: string;
  state: string;
  zip: any | null;
}

export interface createProperty_createProperty {
  __typename: "Property";
  name: string;
  phone: string;
  phoneExt: string | null;
  email: string;
  interestListId: string | null;
  address: createProperty_createProperty_address | null;
  submissionDigestEnabled: boolean;
}

export interface createProperty {
  /**
   * Create a property (admin only)
   */
  createProperty: createProperty_createProperty | null;
}

export interface createPropertyVariables {
  data: PropertyCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TransferProperty
// ====================================================

export interface TransferProperty {
  /**
   * Transfer a property to a new organization (admin only)
   */
  transferProperty: string | null;
}

export interface TransferPropertyVariables {
  propertyId: string;
  organizationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getProperty
// ====================================================

export interface getProperty_property_address {
  __typename: "Address";
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: any | null;
}

export interface getProperty_property_invoicedCustomer {
  __typename: "InvoicedCustomer";
  invoicedId: string | null;
  active: boolean;
}

export interface getProperty_property {
  __typename: "Property";
  id: string;
  organizationId: string;
  name: string;
  phone: string;
  phoneExt: string | null;
  email: string;
  interestListId: string | null;
  address: getProperty_property_address | null;
  submissionDigestEnabled: boolean;
  units: number | null;
  invoicedCustomer: getProperty_property_invoicedCustomer | null;
}

export interface getProperty {
  /**
   * Property by it's ID
   */
  property: getProperty_property;
}

export interface getPropertyVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePropertyAdmin
// ====================================================

export interface updatePropertyAdmin_updateProperty_invoicedCustomer {
  __typename: "InvoicedCustomer";
  invoicedId: string | null;
  active: boolean;
}

export interface updatePropertyAdmin_updateProperty {
  __typename: "Property";
  id: string;
  name: string;
  invoicedCustomer: updatePropertyAdmin_updateProperty_invoicedCustomer | null;
}

export interface updatePropertyAdmin {
  /**
   * Update a property
   */
  updateProperty: updatePropertyAdmin_updateProperty | null;
}

export interface updatePropertyAdminVariables {
  id: string;
  data: PropertyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertyUseCases
// ====================================================

export interface getPropertyUseCases_property_propertyUseCases_useCase {
  __typename: "UseCase";
  friendlyName: string;
}

export interface getPropertyUseCases_property_propertyUseCases {
  __typename: "PropertyUseCase";
  id: string;
  useCaseId: number;
  propertyId: string;
  messageId: string;
  smsPrefix: string | null;
  applicationId: string | null;
  applicationIdFriendlyName: string;
  messageIdFriendlyName: string;
  active: boolean;
  useCase: getPropertyUseCases_property_propertyUseCases_useCase;
}

export interface getPropertyUseCases_property {
  __typename: "Property";
  id: string;
  name: string;
  propertyUseCases: getPropertyUseCases_property_propertyUseCases[];
}

export interface getPropertyUseCases_getUseCases {
  __typename: "UseCase";
  id: number;
  name: string;
  friendlyName: string;
  description: string;
}

export interface getPropertyUseCases_getActiveSubaccounts {
  __typename: "PropertyUseCaseLookup";
  name: string;
  id: string;
}

export interface getPropertyUseCases {
  /**
   * Property by it's ID
   */
  property: getPropertyUseCases_property;
  getUseCases: getPropertyUseCases_getUseCases[];
  getActiveSubaccounts: getPropertyUseCases_getActiveSubaccounts[];
}

export interface getPropertyUseCasesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: upsertPropertyUseCase
// ====================================================

export interface upsertPropertyUseCase_upsertPropertyUseCase_useCase {
  __typename: "UseCase";
  id: number;
  name: string;
  friendlyName: string;
  description: string;
}

export interface upsertPropertyUseCase_upsertPropertyUseCase {
  __typename: "PropertyUseCase";
  id: string;
  useCaseId: number;
  propertyId: string;
  messageId: string;
  smsPrefix: string | null;
  applicationId: string | null;
  useCase: upsertPropertyUseCase_upsertPropertyUseCase_useCase;
}

export interface upsertPropertyUseCase {
  upsertPropertyUseCase: upsertPropertyUseCase_upsertPropertyUseCase;
}

export interface upsertPropertyUseCaseVariables {
  data: PropertyUseCaseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getMessageGroups
// ====================================================

export interface getMessageGroups_getMessageGroups {
  __typename: "PropertyUseCaseLookup";
  id: string;
  name: string;
}

export interface getMessageGroups_getSmsPhoneNumbers {
  __typename: "PropertyUseCaseLookup";
  id: string;
  name: string;
}

export interface getMessageGroups {
  getMessageGroups: getMessageGroups_getMessageGroups[];
  getSmsPhoneNumbers: getMessageGroups_getSmsPhoneNumbers[];
}

export interface getMessageGroupsVariables {
  id?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCompletedApplications
// ====================================================

export interface GetCompletedApplications_completedApplicationsByMonth {
  __typename: "ApplicationCount";
  month: string;
  count: number;
}

export interface GetCompletedApplications {
  completedApplicationsByMonth: GetCompletedApplications_completedApplicationsByMonth[];
}

export interface GetCompletedApplicationsVariables {
  since: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserAccountStatistics
// ====================================================

export interface UserAccountStatistics_userAccountStatistics {
  __typename: "AdminDashboardStatistics";
  createdThisWeek: number;
  createdToday: number;
  total: number;
}

export interface UserAccountStatistics {
  /**
   * User statistics for admin dashboard
   */
  userAccountStatistics: UserAccountStatistics_userAccountStatistics;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ApplicationStatistics
// ====================================================

export interface ApplicationStatistics_applicationStatistics {
  __typename: "AdminDashboardStatistics";
  createdToday: number;
  createdThisWeek: number;
  total: number;
}

export interface ApplicationStatistics {
  /**
   * Application statistics for admin dashboard
   */
  applicationStatistics: ApplicationStatistics_applicationStatistics;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyCount
// ====================================================

export interface PropertyCount {
  propertyCount: number;
  propertyUnitsTotal: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PMUserCount
// ====================================================

export interface PMUserCount {
  pmUserCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminUserCount
// ====================================================

export interface AdminUserCount {
  adminUserCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: subscriptionsAll
// ====================================================

export interface subscriptionsAll_subscriptionsAll_propertyInterestList_property_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface subscriptionsAll_subscriptionsAll_propertyInterestList_property {
  __typename: "Property";
  id: string;
  name: string;
  units: number | null;
  organization: subscriptionsAll_subscriptionsAll_propertyInterestList_property_organization | null;
}

export interface subscriptionsAll_subscriptionsAll_propertyInterestList_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface subscriptionsAll_subscriptionsAll_propertyInterestList {
  __typename: "PropertyInterestListSubscription";
  id: string;
  propertyId: string;
  interestListId: string;
  property: subscriptionsAll_subscriptionsAll_propertyInterestList_property | null;
  interestList: subscriptionsAll_subscriptionsAll_propertyInterestList_interestList | null;
}

export interface subscriptionsAll_subscriptionsAll_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface subscriptionsAll_subscriptionsAll_pricing_pricingType {
  __typename: "PricingType";
  name: string | null;
}

export interface subscriptionsAll_subscriptionsAll_pricing {
  __typename: "Pricing";
  id: string;
  pricingType: subscriptionsAll_subscriptionsAll_pricing_pricingType | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
}

export interface subscriptionsAll_subscriptionsAll_billingFrequency {
  __typename: "Frequency";
  id: number;
  name: string | null;
}

export interface subscriptionsAll_subscriptionsAll_propertyContract {
  __typename: "PropertyContract";
  id: string;
  propertyName: string | null;
  status: string | null;
}

export interface subscriptionsAll_subscriptionsAll {
  __typename: "SubscriptionRecord";
  id: string;
  propertyInterestListId: string;
  planId: string;
  pricingId: string | null;
  billingFrequencyId: number | null;
  startDate: any | null;
  endDate: any | null;
  renewalDate: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  propertyInterestList: subscriptionsAll_subscriptionsAll_propertyInterestList | null;
  plan: subscriptionsAll_subscriptionsAll_plan | null;
  pricing: subscriptionsAll_subscriptionsAll_pricing | null;
  billingFrequency: subscriptionsAll_subscriptionsAll_billingFrequency | null;
  monthlyRecurringRevenue: any | null;
  invoicedId: string | null;
  propertyContract: subscriptionsAll_subscriptionsAll_propertyContract | null;
}

export interface subscriptionsAll {
  /**
   * Fetch all subscriptions (admin). Excludes archived by default.
   */
  subscriptionsAll: subscriptionsAll_subscriptionsAll[];
}

export interface subscriptionsAllVariables {
  includeArchived?: boolean | null;
  activeOnly?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: subscriptionById
// ====================================================

export interface subscriptionById_subscriptionById_propertyContract {
  __typename: "PropertyContract";
  id: string;
  propertyName: string | null;
  status: string | null;
}

export interface subscriptionById_subscriptionById_propertyInterestList_property_organization {
  __typename: "Organization";
  name: string;
}

export interface subscriptionById_subscriptionById_propertyInterestList_property {
  __typename: "Property";
  id: string;
  name: string;
  organization: subscriptionById_subscriptionById_propertyInterestList_property_organization | null;
}

export interface subscriptionById_subscriptionById_propertyInterestList_interestList_organization {
  __typename: "Organization";
  name: string;
}

export interface subscriptionById_subscriptionById_propertyInterestList_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  organization: subscriptionById_subscriptionById_propertyInterestList_interestList_organization | null;
}

export interface subscriptionById_subscriptionById_propertyInterestList {
  __typename: "PropertyInterestListSubscription";
  id: string;
  propertyId: string;
  interestListId: string;
  property: subscriptionById_subscriptionById_propertyInterestList_property | null;
  interestList: subscriptionById_subscriptionById_propertyInterestList_interestList | null;
}

export interface subscriptionById_subscriptionById_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface subscriptionById_subscriptionById_pricing {
  __typename: "Pricing";
  id: string;
}

export interface subscriptionById_subscriptionById_billingFrequency {
  __typename: "Frequency";
  id: number;
  name: string | null;
}

export interface subscriptionById_subscriptionById {
  __typename: "SubscriptionRecord";
  id: string;
  propertyInterestListId: string;
  planId: string;
  pricingId: string | null;
  billingFrequencyId: number | null;
  startDate: any | null;
  endDate: any | null;
  renewalDate: any | null;
  insertedAt: string | null;
  updatedAt: string | null;
  invoicedId: string | null;
  propertyContract: subscriptionById_subscriptionById_propertyContract | null;
  propertyInterestList: subscriptionById_subscriptionById_propertyInterestList | null;
  plan: subscriptionById_subscriptionById_plan | null;
  pricing: subscriptionById_subscriptionById_pricing | null;
  billingFrequency: subscriptionById_subscriptionById_billingFrequency | null;
}

export interface subscriptionById {
  /**
   * Fetch a subscription by ID
   */
  subscriptionById: subscriptionById_subscriptionById | null;
}

export interface subscriptionByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createSubscription
// ====================================================

export interface createSubscription_createSubscription_propertyInterestList_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface createSubscription_createSubscription_propertyInterestList_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface createSubscription_createSubscription_propertyInterestList {
  __typename: "PropertyInterestListSubscription";
  id: string;
  property: createSubscription_createSubscription_propertyInterestList_property | null;
  interestList: createSubscription_createSubscription_propertyInterestList_interestList | null;
}

export interface createSubscription_createSubscription_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface createSubscription_createSubscription_pricing {
  __typename: "Pricing";
  id: string;
}

export interface createSubscription_createSubscription_billingFrequency {
  __typename: "Frequency";
  id: number;
  name: string | null;
}

export interface createSubscription_createSubscription {
  __typename: "SubscriptionRecord";
  id: string;
  propertyInterestListId: string;
  planId: string;
  pricingId: string | null;
  billingFrequencyId: number | null;
  propertyInterestList: createSubscription_createSubscription_propertyInterestList | null;
  plan: createSubscription_createSubscription_plan | null;
  pricing: createSubscription_createSubscription_pricing | null;
  billingFrequency: createSubscription_createSubscription_billingFrequency | null;
}

export interface createSubscription {
  /**
   * Create a subscription (creates property_interest_list if needed)
   */
  createSubscription: createSubscription_createSubscription | null;
}

export interface createSubscriptionVariables {
  data: SubscriptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateSubscription
// ====================================================

export interface updateSubscription_updateSubscription_propertyInterestList_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface updateSubscription_updateSubscription_propertyInterestList_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface updateSubscription_updateSubscription_propertyInterestList {
  __typename: "PropertyInterestListSubscription";
  id: string;
  property: updateSubscription_updateSubscription_propertyInterestList_property | null;
  interestList: updateSubscription_updateSubscription_propertyInterestList_interestList | null;
}

export interface updateSubscription_updateSubscription_plan {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface updateSubscription_updateSubscription_pricing {
  __typename: "Pricing";
  id: string;
}

export interface updateSubscription_updateSubscription_billingFrequency {
  __typename: "Frequency";
  id: number;
  name: string | null;
}

export interface updateSubscription_updateSubscription {
  __typename: "SubscriptionRecord";
  id: string;
  propertyInterestListId: string;
  planId: string;
  pricingId: string | null;
  billingFrequencyId: number | null;
  propertyInterestList: updateSubscription_updateSubscription_propertyInterestList | null;
  plan: updateSubscription_updateSubscription_plan | null;
  pricing: updateSubscription_updateSubscription_pricing | null;
  billingFrequency: updateSubscription_updateSubscription_billingFrequency | null;
}

export interface updateSubscription {
  /**
   * Update a subscription
   */
  updateSubscription: updateSubscription_updateSubscription | null;
}

export interface updateSubscriptionVariables {
  id: string;
  data: SubscriptionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: archiveSubscription
// ====================================================

export interface archiveSubscription_archiveSubscription {
  __typename: "SubscriptionRecord";
  id: string;
}

export interface archiveSubscription {
  /**
   * Archive a subscription (soft delete)
   */
  archiveSubscription: archiveSubscription_archiveSubscription | null;
}

export interface archiveSubscriptionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setSubscriptionInvoicedId
// ====================================================

export interface setSubscriptionInvoicedId_setSubscriptionInvoicedId {
  __typename: "SubscriptionRecord";
  id: string;
  invoicedId: string | null;
}

export interface setSubscriptionInvoicedId {
  /**
   * Set a subscription's Invoiced id (admin). The id is verified against Invoiced before it is persisted; a nonexistent/unreachable id saves nothing.
   */
  setSubscriptionInvoicedId: setSubscriptionInvoicedId_setSubscriptionInvoicedId | null;
}

export interface setSubscriptionInvoicedIdVariables {
  id: string;
  invoicedId: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getAllPropertiesForSubscriptions
// ====================================================

export interface getAllPropertiesForSubscriptions_properties_organization {
  __typename: "Organization";
  name: string;
}

export interface getAllPropertiesForSubscriptions_properties {
  __typename: "Property";
  id: string;
  name: string;
  organization: getAllPropertiesForSubscriptions_properties_organization | null;
}

export interface getAllPropertiesForSubscriptions {
  /**
   * ALL properties (admin)
   */
  properties: getAllPropertiesForSubscriptions_properties[];
}

export interface getAllPropertiesForSubscriptionsVariables {
  includeArchived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getInterestListsForSubscriptions
// ====================================================

export interface getInterestListsForSubscriptions_interestLists_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface getInterestListsForSubscriptions_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  organization: getInterestListsForSubscriptions_interestLists_organization | null;
}

export interface getInterestListsForSubscriptions {
  /**
   * Interest lists
   */
  interestLists: getInterestListsForSubscriptions_interestLists[];
}

export interface getInterestListsForSubscriptionsVariables {
  includeArchived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: plansAllForSubscriptions
// ====================================================

export interface plansAllForSubscriptions_plansAll {
  __typename: "Plan";
  id: string;
  name: string;
}

export interface plansAllForSubscriptions {
  /**
   * Fetch all plans
   */
  plansAll: plansAllForSubscriptions_plansAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: pricingAllForSubscriptions
// ====================================================

export interface pricingAllForSubscriptions_pricingAll_pricingType {
  __typename: "PricingType";
  id: string;
  name: string | null;
}

export interface pricingAllForSubscriptions_pricingAll_thresholdType {
  __typename: "ThresholdType";
  id: string;
  name: string | null;
}

export interface pricingAllForSubscriptions_pricingAll {
  __typename: "Pricing";
  id: string;
  pricingTypeId: number | null;
  thresholdTypeId: number | null;
  minimumPrice: any | null;
  unitThreshold: number | null;
  monthlyPricePerUnit: any | null;
  pricingType: pricingAllForSubscriptions_pricingAll_pricingType | null;
  thresholdType: pricingAllForSubscriptions_pricingAll_thresholdType | null;
}

export interface pricingAllForSubscriptions {
  /**
   * Fetch all pricing configurations
   */
  pricingAll: pricingAllForSubscriptions_pricingAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: frequenciesAll
// ====================================================

export interface frequenciesAll_frequenciesAll {
  __typename: "Frequency";
  id: number;
  name: string | null;
}

export interface frequenciesAll {
  /**
   * Fetch all billing frequencies
   */
  frequenciesAll: frequenciesAll_frequenciesAll[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminListUsersQuery
// ====================================================

export interface AdminListUsersQuery_adminApplicants_profile {
  __typename: "Profile";
  firstName: string | null;
  lastName: string | null;
}

export interface AdminListUsersQuery_adminApplicants_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface AdminListUsersQuery_adminApplicants_interests {
  __typename: "Interest";
  id: string;
}

export interface AdminListUsersQuery_adminApplicants {
  __typename: "UserPostgres";
  id: string;
  loginEmail: string | null;
  loginPhone: string | null;
  isArchived: boolean;
  profile: AdminListUsersQuery_adminApplicants_profile;
  organization: AdminListUsersQuery_adminApplicants_organization | null;
  interests: AdminListUsersQuery_adminApplicants_interests[];
}

export interface AdminListUsersQuery {
  adminApplicants: AdminListUsersQuery_adminApplicants[] | null;
}

export interface AdminListUsersQueryVariables {
  id?: string | null;
  name?: string | null;
  loginEmail?: string | null;
  loginPhone?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AdminDetailedListUsersQuery
// ====================================================

export interface AdminDetailedListUsersQuery_adminApplicants_profile {
  __typename: "Profile";
  id: string | null;
  firstName: string | null;
  lastName: string | null;
}

export interface AdminDetailedListUsersQuery_adminApplicants_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface AdminDetailedListUsersQuery_adminApplicants_userRoles {
  __typename: "UserRoles";
  role: PostgresUserRole;
}

export interface AdminDetailedListUsersQuery_adminApplicants_interests_status {
  __typename: "InterestStatus";
  name: string;
  changedAt: string | null;
}

export interface AdminDetailedListUsersQuery_adminApplicants_interests_interestList_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface AdminDetailedListUsersQuery_adminApplicants_interests_interestList_organization {
  __typename: "Organization";
  id: string;
  name: string;
}

export interface AdminDetailedListUsersQuery_adminApplicants_interests_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  property: AdminDetailedListUsersQuery_adminApplicants_interests_interestList_property;
  organization: AdminDetailedListUsersQuery_adminApplicants_interests_interestList_organization | null;
}

export interface AdminDetailedListUsersQuery_adminApplicants_interests {
  __typename: "Interest";
  id: string;
  submittedAt: number | null;
  status: AdminDetailedListUsersQuery_adminApplicants_interests_status;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  householdMember0PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  interestList: AdminDetailedListUsersQuery_adminApplicants_interests_interestList;
}

export interface AdminDetailedListUsersQuery_adminApplicants {
  __typename: "UserPostgres";
  id: string;
  loginEmail: string | null;
  loginPhone: string | null;
  emailVerified: boolean;
  phoneVerified: boolean;
  isArchived: boolean;
  profile: AdminDetailedListUsersQuery_adminApplicants_profile;
  organization: AdminDetailedListUsersQuery_adminApplicants_organization | null;
  userRoles: AdminDetailedListUsersQuery_adminApplicants_userRoles[];
  interests: AdminDetailedListUsersQuery_adminApplicants_interests[];
}

export interface AdminDetailedListUsersQuery {
  adminApplicants: AdminDetailedListUsersQuery_adminApplicants[] | null;
}

export interface AdminDetailedListUsersQueryVariables {
  id?: string | null;
  name?: string | null;
  loginEmail?: string | null;
  loginPhone?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminMergeAccountsMutation
// ====================================================

export interface AdminMergeAccountsMutation_adminMergeAccounts_profile {
  __typename: "Profile";
  firstName: string | null;
  lastName: string | null;
}

export interface AdminMergeAccountsMutation_adminMergeAccounts {
  __typename: "UserPostgres";
  id: string;
  loginEmail: string | null;
  loginPhone: string | null;
  profile: AdminMergeAccountsMutation_adminMergeAccounts_profile;
}

export interface AdminMergeAccountsMutation {
  /**
   * Merge two or more user accounts into one
   */
  adminMergeAccounts: AdminMergeAccountsMutation_adminMergeAccounts | null;
}

export interface AdminMergeAccountsMutationVariables {
  ids: string[];
  firstName?: string | null;
  lastName?: string | null;
  loginEmail?: string | null;
  loginPhone?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminArchiveAccountMutation
// ====================================================

export interface AdminArchiveAccountMutation_adminArchiveAccount {
  __typename: "UserPostgres";
  id: string;
  loginEmail: string | null;
  loginPhone: string | null;
}

export interface AdminArchiveAccountMutation {
  /**
   * Archives an account, freeing the use of the phone number and email for other accounts
   */
  adminArchiveAccount: AdminArchiveAccountMutation_adminArchiveAccount | null;
}

export interface AdminArchiveAccountMutationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminRestoreAccountMutation
// ====================================================

export interface AdminRestoreAccountMutation_adminRestoreAccount {
  __typename: "UserPostgres";
  id: string;
  loginEmail: string | null;
  loginPhone: string | null;
}

export interface AdminRestoreAccountMutation {
  /**
   * Archives an account, freeing the use of the phone number and email for other accounts
   */
  adminRestoreAccount: AdminRestoreAccountMutation_adminRestoreAccount | null;
}

export interface AdminRestoreAccountMutationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminUpdateAccountMutation
// ====================================================

export interface AdminUpdateAccountMutation_adminUpdateAccount {
  __typename: "UserPostgres";
  id: string;
}

export interface AdminUpdateAccountMutation {
  /**
   * Updates an account
   */
  adminUpdateAccount: AdminUpdateAccountMutation_adminUpdateAccount | null;
}

export interface AdminUpdateAccountMutationVariables {
  id: string;
  user: AdminUserInput;
  profile: AdminUserProfileInput;
  roles: PostgresUserRole[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AdminCreateAccountMutation
// ====================================================

export interface AdminCreateAccountMutation_adminCreateAccount {
  __typename: "UserPostgres";
  id: string;
}

export interface AdminCreateAccountMutation {
  /**
   * Creates an account
   */
  adminCreateAccount: AdminCreateAccountMutation_adminCreateAccount | null;
}

export interface AdminCreateAccountMutationVariables {
  user: AdminUserInput;
  profile: AdminUserProfileInput;
  roles: PostgresUserRole[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DocumentDetails
// ====================================================

export interface DocumentDetails_document {
  __typename: "Document";
  id: string;
  category: string;
  name: string;
  uploadedAt: string;
  downloadUrl: string;
  type: DocumentType;
  url: string;
}

export interface DocumentDetails {
  document: DocumentDetails_document | null;
}

export interface DocumentDetailsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserDocuments
// ====================================================

export interface UserDocuments_viewer_documents {
  __typename: "Document";
  id: string;
  category: string;
  name: string;
  uploadedAt: string;
  url: string;
  downloadUrl: string;
}

export interface UserDocuments_viewer {
  __typename: "UserPostgres";
  id: string;
  documents: UserDocuments_viewer_documents[];
}

export interface UserDocuments {
  /**
   * Logged in user
   */
  viewer: UserDocuments_viewer | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ApplicantSubmissions
// ====================================================

export interface ApplicantSubmissions_clientInterests_status {
  __typename: "InterestStatus";
  name: string;
  changedAt: string | null;
}

export interface ApplicantSubmissions_clientInterests_updateRequest {
  __typename: "UpdateRequest";
  code: string;
  isActive: boolean;
}

export interface ApplicantSubmissions_clientInterests_interestList_property {
  __typename: "Property";
  id: string;
  email: string;
  phone: string;
  name: string;
  reinstatementDays: number;
}

export interface ApplicantSubmissions_clientInterests_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  isArchived: boolean | null;
  property: ApplicantSubmissions_clientInterests_interestList_property;
}

export interface ApplicantSubmissions_clientInterests {
  __typename: "Interest";
  id: string;
  status: ApplicantSubmissions_clientInterests_status;
  submittedAt: number | null;
  updateRequest: ApplicantSubmissions_clientInterests_updateRequest | null;
  interestList: ApplicantSubmissions_clientInterests_interestList;
}

export interface ApplicantSubmissions {
  /**
   * Fetch all completed interests by their interest_list ID
   */
  clientInterests: ApplicantSubmissions_clientInterests[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ApplicantSubs
// ====================================================

export interface ApplicantSubs_submissions_form_property_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  isArchived: boolean | null;
}

export interface ApplicantSubs_submissions_form_property {
  __typename: "Property";
  id: string;
  email: string;
  phone: string;
  name: string;
  interestList: ApplicantSubs_submissions_form_property_interestList;
}

export interface ApplicantSubs_submissions_form {
  __typename: "Form";
  type: FormType;
  property: ApplicantSubs_submissions_form_property;
}

export interface ApplicantSubs_submissions {
  __typename: "Submission";
  id: string;
  submittedAt: string | null;
  form: ApplicantSubs_submissions_form;
}

export interface ApplicantSubs {
  submissions: ApplicantSubs_submissions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: requestReinstatement
// ====================================================

export interface requestReinstatement {
  /**
   * Allow a client user to remove themselves from a list
   */
  requestReinstatement: string | null;
}

export interface requestReinstatementVariables {
  interestId: string;
  reason: string;
  other?: string | null;
  details?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestRemovalReason
// ====================================================

export interface InterestRemovalReason {
  /**
   * Get a removal reason for the interest
   */
  interestRemovalReason: string | null;
}

export interface InterestRemovalReasonVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: removeSelfSubmission
// ====================================================

export interface removeSelfSubmission {
  /**
   * Allow a client user to remove their submission
   */
  removeSelfSubmission: boolean | null;
}

export interface removeSelfSubmissionVariables {
  submissionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: removeSelfFromList
// ====================================================

export interface removeSelfFromList {
  /**
   * Allow a client user to remove themselves from a list
   */
  removeSelfFromList: string | null;
}

export interface removeSelfFromListVariables {
  interestId: string;
  reason: string;
  waitlistCode?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getViewerInterestId
// ====================================================

export interface getViewerInterestId {
  viewerInterestId: string | null;
}

export interface getViewerInterestIdVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: formMetaData
// ====================================================

export interface formMetaData_interest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
}

export interface formMetaData_applicationFormMetadata_schema_options {
  __typename: "InputOption";
  label: string;
  value: string;
}

export interface formMetaData_applicationFormMetadata_schema {
  __typename: "SchemaObj";
  name: string | null;
  label: string | null;
  options: formMetaData_applicationFormMetadata_schema_options[] | null;
}

export interface formMetaData_applicationFormMetadata {
  __typename: "AppMetadata";
  interestListName: string;
  schema: (formMetaData_applicationFormMetadata_schema | null)[] | null;
}

export interface formMetaData {
  /**
   * Fetch a interest application by it's ID
   */
  interest: formMetaData_interest;
  /**
   * Fetch metadata for whitelabel application list
   */
  applicationFormMetadata: formMetaData_applicationFormMetadata;
}

export interface formMetaDataVariables {
  interestListID: string;
  interestID: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: interestUpdateContainer
// ====================================================

export interface interestUpdateContainer_clientUpdateCompletedInterest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
}

export interface interestUpdateContainer {
  /**
   * Update a completed interest item
   */
  clientUpdateCompletedInterest: interestUpdateContainer_clientUpdateCompletedInterest;
}

export interface interestUpdateContainerVariables {
  interestID: string;
  data: InterestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserProfile
// ====================================================

export interface UserProfile_userProfile_currentAddress {
  __typename: "UserProfileAddress";
  id: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface UserProfile_userProfile_mailingAddress {
  __typename: "UserProfileAddress";
  id: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface UserProfile_userProfile_addresses {
  __typename: "UserProfileAddress";
  id: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface UserProfile_userProfile_emails {
  __typename: "Email";
  id: string | null;
  address: string | null;
}

export interface UserProfile_userProfile_phones {
  __typename: "Phone";
  id: string | null;
  number: string | null;
}

export interface UserProfile_userProfile {
  __typename: "Profile";
  firstName: string | null;
  lastName: string | null;
  title: string | null;
  dateOfBirth: string | null;
  gender: Genders | null;
  pronouns: Pronouns | null;
  customPronouns: string | null;
  race: Races | null;
  ethnicity: Ethnicities | null;
  citizenship: Citizenships | null;
  currentAddress: UserProfile_userProfile_currentAddress | null;
  mailingAddress: UserProfile_userProfile_mailingAddress | null;
  addresses: UserProfile_userProfile_addresses[];
  emails: UserProfile_userProfile_emails[];
  phones: UserProfile_userProfile_phones[];
}

export interface UserProfile {
  /**
   * Fetch a users profile (pg backed)
   */
  userProfile: UserProfile_userProfile | null;
}

export interface UserProfileVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserProfile
// ====================================================

export interface UpdateUserProfile_updateUserProfile {
  __typename: "Profile";
  id: string | null;
}

export interface UpdateUserProfile {
  /**
   * Update a users profile (pg backed)
   */
  updateUserProfile: UpdateUserProfile_updateUserProfile | null;
}

export interface UpdateUserProfileVariables {
  id: string;
  title?: string | null;
  dateOfBirth?: string | null;
  gender?: Genders | null;
  pronouns?: Pronouns | null;
  customPronouns?: string | null;
  race?: Races | null;
  ethnicity?: Ethnicities | null;
  citizenship?: Citizenships | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddUserProfileAddress
// ====================================================

export interface AddUserProfileAddress_addUserProfileAddress {
  __typename: "UserProfileAddress";
  id: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface AddUserProfileAddress {
  addUserProfileAddress: AddUserProfileAddress_addUserProfileAddress | null;
}

export interface AddUserProfileAddressVariables {
  setAsCurrentAddress: boolean;
  setAsMailingAddress: boolean;
  address: UserProfileAddressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditUserProfileAddress
// ====================================================

export interface EditUserProfileAddress_editUserProfileAddress {
  __typename: "UserProfileAddress";
  id: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
}

export interface EditUserProfileAddress {
  editUserProfileAddress: EditUserProfileAddress_editUserProfileAddress | null;
}

export interface EditUserProfileAddressVariables {
  setAsCurrentAddress: boolean;
  setAsMailingAddress: boolean;
  address: UserProfileAddressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteUserProfileAddress
// ====================================================

export interface DeleteUserProfileAddress_deleteUserProfileAddress {
  __typename: "UserProfileAddress";
  id: string | null;
}

export interface DeleteUserProfileAddress {
  deleteUserProfileAddress: DeleteUserProfileAddress_deleteUserProfileAddress | null;
}

export interface DeleteUserProfileAddressVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAsUserProfileCurrentAddress
// ====================================================

export interface SetAsUserProfileCurrentAddress_setAsUserProfileCurrentAddress {
  __typename: "UserProfileAddress";
  id: string | null;
}

export interface SetAsUserProfileCurrentAddress {
  setAsUserProfileCurrentAddress: SetAsUserProfileCurrentAddress_setAsUserProfileCurrentAddress | null;
}

export interface SetAsUserProfileCurrentAddressVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAsUserProfileMailingAddress
// ====================================================

export interface SetAsUserProfileMailingAddress_setAsUserProfileMailingAddress {
  __typename: "UserProfileAddress";
  id: string | null;
}

export interface SetAsUserProfileMailingAddress {
  setAsUserProfileMailingAddress: SetAsUserProfileMailingAddress_setAsUserProfileMailingAddress | null;
}

export interface SetAsUserProfileMailingAddressVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getActivityFeed
// ====================================================

export interface getActivityFeed_activityFeed_message_error {
  __typename: "MessageError";
  code: string | null;
  message: string | null;
}

export interface getActivityFeed_activityFeed_message {
  __typename: "Message";
  status: string | null;
  error: getActivityFeed_activityFeed_message_error | null;
  recipientName: string | null;
  emailToAddress: string | null;
  emailCcAddress: string | null;
  body: string | null;
  mobileNumber: string | null;
}

export interface getActivityFeed_activityFeed_metadata_otherInterests {
  __typename: "ActivityOtherInterest";
  id: string | null;
  firstName: string | null;
  lastName: string | null;
}

export interface getActivityFeed_activityFeed_metadata {
  __typename: "ActivityMetadata";
  to: string | null;
  emailSubject: string | null;
  body: string | null;
  viewerName: string | null;
  updateDiff: any | null;
  errorsMap: any | null;
  reason: string | null;
  owner: string | null;
  ownerName: string | null;
  previousOwner: string | null;
  previousOwnerName: string | null;
  activityContent: string | null;
  filename: string | null;
  uploadingUserEmail: string | null;
  messageType: string | null;
  otherInterests: (getActivityFeed_activityFeed_metadata_otherInterests | null)[] | null;
}

export interface getActivityFeed_activityFeed_letterJob {
  __typename: "LetterJob";
  lobLetterId: string | null;
  status: string | null;
  errorMessage: string | null;
}

export interface getActivityFeed_activityFeed {
  __typename: "Activity";
  id: string | null;
  name: string | null;
  insertedAt: string | null;
  title: string | null;
  type: string | null;
  note: string | null;
  authorFullName: string;
  message: getActivityFeed_activityFeed_message | null;
  metadata: getActivityFeed_activityFeed_metadata | null;
  letterJob: getActivityFeed_activityFeed_letterJob | null;
}

export interface getActivityFeed {
  /**
   * Fetch a activity by it's ID
   */
  activityFeed: getActivityFeed_activityFeed[];
}

export interface getActivityFeedVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendMessagesProfile
// ====================================================

export interface SendMessagesProfile {
  /**
   * Send messages to a selection of interests
   */
  sendMessages: string | null;
}

export interface SendMessagesProfileVariables {
  interestListIds: string[];
  interestIds?: string[] | null;
  elasticQuery?: ElasticQuery | null;
  emailEnabled: boolean;
  emailBody: string;
  emailSubject: string;
  emailBccAddress?: string | null;
  emailRespondToEnabled?: boolean | null;
  letterEnabled: boolean;
  letterBody: string;
  smsEnabled: boolean;
  smsBody: string;
  smsPropertyUseCaseId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createActivityContainer
// ====================================================

export interface createActivityContainer_createActivity {
  __typename: "Activity";
  id: string | null;
  note: string | null;
}

export interface createActivityContainer {
  /**
   * Create an Activity
   */
  createActivity: createActivityContainer_createActivity;
}

export interface createActivityContainerVariables {
  data: ActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: logCall
// ====================================================

export interface logCall_logCall {
  __typename: "Activity";
  id: string | null;
  note: string | null;
}

export interface logCall {
  /**
   * Create a log call activity to an interest
   */
  logCall: logCall_logCall;
}

export interface logCallVariables {
  interestId: string;
  note?: string | null;
  outcome: string;
  reason?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: interestActivityPage
// ====================================================

export interface interestActivityPage_interest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
}

export interface interestActivityPage {
  /**
   * Fetch a interest application by it's ID
   */
  interest: interestActivityPage_interest;
}

export interface interestActivityPageVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeInterestStage
// ====================================================

export interface ChangeInterestStage {
  /**
   * Change the status of an interest
   */
  changeInterestStatus: string | null;
}

export interface ChangeInterestStageVariables {
  interest: string;
  status: string;
  reason?: string | null;
  actionDate?: string | null;
  unitNumber?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchInterestDocuments
// ====================================================

export interface FetchInterestDocuments_interest_documents {
  __typename: "Document";
  id: string;
  uploadedAt: string;
  url: string;
  downloadUrl: string;
  isPreviewable: boolean;
  isDeletable: boolean;
  name: string;
  category: string;
  type: DocumentType;
}

export interface FetchInterestDocuments_interest {
  __typename: "Interest";
  id: string;
  documents: FetchInterestDocuments_interest_documents[];
}

export interface FetchInterestDocuments {
  /**
   * Fetch a interest application by it's ID
   */
  interest: FetchInterestDocuments_interest;
}

export interface FetchInterestDocumentsVariables {
  interestID: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUploadedDocument
// ====================================================

export interface RemoveUploadedDocument_removeDocument {
  __typename: "Document";
  id: string;
}

export interface RemoveUploadedDocument {
  /**
   * Remove an uploaded document
   */
  removeDocument: RemoveUploadedDocument_removeDocument;
}

export interface RemoveUploadedDocumentVariables {
  documentId: string;
  interestId: string;
  type: DocumentType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestDocumentPreflights
// ====================================================

export interface RequestDocumentPreflights_documentPreflight_document {
  __typename: "Document";
  id: string;
}

export interface RequestDocumentPreflights_documentPreflight {
  __typename: "DocumentPreflight";
  document: RequestDocumentPreflights_documentPreflight_document;
  tempId: string;
  uploadUrl: string;
}

export interface RequestDocumentPreflights {
  /**
   * Create one or more document pre-flight requests.
   */
  documentPreflight: RequestDocumentPreflights_documentPreflight[];
}

export interface RequestDocumentPreflightsVariables {
  documents: DocumentPreflightRequest[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DocumentsUploadComplete
// ====================================================

export interface DocumentsUploadComplete_documentUploadComplete {
  __typename: "Document";
  id: string;
}

export interface DocumentsUploadComplete {
  /**
   * Mark document uploads as completed.
   */
  documentUploadComplete: DocumentsUploadComplete_documentUploadComplete[];
}

export interface DocumentsUploadCompleteVariables {
  documents: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: formData
// ====================================================

export interface formData_applicationFormMetadata_schema_options {
  __typename: "InputOption";
  label: string;
  value: string;
}

export interface formData_applicationFormMetadata_schema {
  __typename: "SchemaObj";
  name: string | null;
  label: string | null;
  options: formData_applicationFormMetadata_schema_options[] | null;
}

export interface formData_applicationFormMetadata {
  __typename: "AppMetadata";
  schema: (formData_applicationFormMetadata_schema | null)[] | null;
}

export interface formData {
  /**
   * Fetch metadata for whitelabel application list
   */
  applicationFormMetadata: formData_applicationFormMetadata;
}

export interface formDataVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createInterest
// ====================================================

export interface createInterest_createInterest {
  __typename: "Interest";
  id: string;
  manuallyEntered: boolean | null;
}

export interface createInterest {
  /**
   * Create an interest
   */
  createInterest: createInterest_createInterest | null;
}

export interface createInterestVariables {
  listId: string;
  data: InterestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getInterestListName
// ====================================================

export interface getInterestListName_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface getInterestListName {
  /**
   * Interest List
   */
  interestList: getInterestListName_interestList;
}

export interface getInterestListNameVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SlideoutApplications
// ====================================================

export interface SlideoutApplications_interest_organization_interestLists {
  __typename: "InterestList";
  id: string;
}

export interface SlideoutApplications_interest_organization {
  __typename: "Organization";
  id: string;
  interestLists: SlideoutApplications_interest_organization_interestLists[];
}

export interface SlideoutApplications_interest_interestList_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface SlideoutApplications_interest_interestList_property {
  __typename: "Property";
  features: SlideoutApplications_interest_interestList_property_features[];
}

export interface SlideoutApplications_interest_interestList {
  __typename: "InterestList";
  property: SlideoutApplications_interest_interestList_property;
}

export interface SlideoutApplications_interest_documents {
  __typename: "Document";
  id: string;
}

export interface SlideoutApplications_interest {
  __typename: "Interest";
  id: string;
  organization: SlideoutApplications_interest_organization;
  interestList: SlideoutApplications_interest_interestList;
  documents: SlideoutApplications_interest_documents[];
}

export interface SlideoutApplications_otherInterests_updateRequest {
  __typename: "UpdateRequest";
  isActive: boolean;
  updateUrl: string;
}

export interface SlideoutApplications_otherInterests {
  __typename: "OtherInterest";
  firstName: string | null;
  householdCount: number | null;
  householdGrossAnnualIncome: number | null;
  id: string;
  lastName: string | null;
  interestListName: string;
  interestListId: string;
  status: string;
  submittedAt: number;
  updateRequest: SlideoutApplications_otherInterests_updateRequest | null;
}

export interface SlideoutApplications {
  /**
   * Fetch a interest application by it's ID
   */
  interest: SlideoutApplications_interest;
  /**
   * all of the interests an applicant has applied to except the one given
   */
  otherInterests: SlideoutApplications_otherInterests[] | null;
}

export interface SlideoutApplicationsVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveInApplicants
// ====================================================

export interface MoveInApplicants {
  /**
   * Change the status of multiple interests on the same interest list
   */
  changeInterestsStatus: string[];
}

export interface MoveInApplicantsVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  moveInDate: string;
  unitNumber?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RequestFormsLookup
// ====================================================

export interface RequestFormsLookup_property_forms_formDefinition {
  __typename: "FormDefinition";
  name: string;
}

export interface RequestFormsLookup_property_forms {
  __typename: "Form";
  id: string;
  formDefinition: RequestFormsLookup_property_forms_formDefinition | null;
}

export interface RequestFormsLookup_property {
  __typename: "Property";
  id: string;
  forms: RequestFormsLookup_property_forms[];
}

export interface RequestFormsLookup {
  /**
   * Property by it's ID
   */
  property: RequestFormsLookup_property;
}

export interface RequestFormsLookupVariables {
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getUserLoginData
// ====================================================

export interface getUserLoginData_user {
  __typename: "UserPostgres";
  email: string | null;
  phone: string | null;
}

export interface getUserLoginData {
  /**
   * Fetch users by id (admin)
   */
  user: getUserLoginData_user;
}

export interface getUserLoginDataVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RelatedInterestActions
// ====================================================

export interface RelatedInterestActions_interest_status {
  __typename: "InterestStatus";
  name: string;
  changedAt: string | null;
}

export interface RelatedInterestActions_interest {
  __typename: "Interest";
  id: string;
  status: RelatedInterestActions_interest_status;
  interestListId: string | null;
  userId: string | null;
}

export interface RelatedInterestActions_interestList {
  __typename: "InterestList";
  id: string;
  waitListId: string | null;
}

export interface RelatedInterestActions_activityFeed_message_error {
  __typename: "MessageError";
  code: string | null;
  message: string | null;
}

export interface RelatedInterestActions_activityFeed_message {
  __typename: "Message";
  status: string | null;
  error: RelatedInterestActions_activityFeed_message_error | null;
  recipientName: string | null;
  body: string | null;
  mobileNumber: string | null;
}

export interface RelatedInterestActions_activityFeed_metadata {
  __typename: "ActivityMetadata";
  to: string | null;
  emailSubject: string | null;
  emailBody: string | null;
  viewerName: string | null;
  errorsMap: any | null;
  updateDiff: any | null;
  reason: string | null;
  activityContent: string | null;
}

export interface RelatedInterestActions_activityFeed_letterJob {
  __typename: "LetterJob";
  lobLetterId: string | null;
  status: string | null;
  errorMessage: string | null;
}

export interface RelatedInterestActions_activityFeed {
  __typename: "Activity";
  id: string | null;
  name: string | null;
  insertedAt: string | null;
  title: string | null;
  type: string | null;
  note: string | null;
  authorFullName: string;
  message: RelatedInterestActions_activityFeed_message | null;
  metadata: RelatedInterestActions_activityFeed_metadata | null;
  letterJob: RelatedInterestActions_activityFeed_letterJob | null;
}

export interface RelatedInterestActions {
  /**
   * Fetch a interest application by it's ID
   */
  interest: RelatedInterestActions_interest;
  /**
   * Interest List
   */
  interestList: RelatedInterestActions_interestList;
  /**
   * Fetch a activity by it's ID
   */
  activityFeed: RelatedInterestActions_activityFeed[];
}

export interface RelatedInterestActionsVariables {
  interestListID: string;
  interestID: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeInterestStatus
// ====================================================

export interface ChangeInterestStatus {
  /**
   * Change the status of an interest
   */
  changeInterestStatus: string | null;
}

export interface ChangeInterestStatusVariables {
  interestId: string;
  status: string;
  reason?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: skipInterestAction
// ====================================================

export interface skipInterestAction_skipInterest {
  __typename: "Activity";
  id: string | null;
  note: string | null;
}

export interface skipInterestAction {
  /**
   * Add a skip activity to an interest
   */
  skipInterest: skipInterestAction_skipInterest;
}

export interface skipInterestActionVariables {
  data: SkipInterestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: skipInterestsAction
// ====================================================

export interface skipInterestsAction {
  /**
   * Add a skip activity to multiple interests
   */
  skipInterests: boolean | null;
}

export interface skipInterestsActionVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
  reason: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addNoteToInterests
// ====================================================

export interface addNoteToInterests {
  /**
   * Add a note to multiple interests
   */
  addNoteToInterests: boolean | null;
}

export interface addNoteToInterestsVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
  note: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: assignableOwners
// ====================================================

export interface assignableOwners_assignableOwners_profile {
  __typename: "Profile";
  firstName: string | null;
  lastName: string | null;
  fullName: string;
}

export interface assignableOwners_assignableOwners_interestLists_property {
  __typename: "Property";
  id: string;
  name: string;
}

export interface assignableOwners_assignableOwners_interestLists {
  __typename: "InterestList";
  id: string;
  property: assignableOwners_assignableOwners_interestLists_property;
}

export interface assignableOwners_assignableOwners {
  __typename: "UserPostgres";
  id: string;
  profile: assignableOwners_assignableOwners_profile;
  interestLists: assignableOwners_assignableOwners_interestLists[] | null;
}

export interface assignableOwners {
  /**
   * Org users assignable as interest owners (admin/supervisor/prop_manager)
   */
  assignableOwners: (assignableOwners_assignableOwners | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: assignInterestOwnersBulk
// ====================================================

export interface assignInterestOwnersBulk_assignInterestOwnersBulk_failed {
  __typename: "BulkOwnerFailure";
  interestId: string;
  name: string | null;
  reason: string | null;
}

export interface assignInterestOwnersBulk_assignInterestOwnersBulk {
  __typename: "BulkOwnerResult";
  succeeded: string[];
  failed: assignInterestOwnersBulk_assignInterestOwnersBulk_failed[];
}

export interface assignInterestOwnersBulk {
  /**
   * Add owners to a bulk selection of interests, keeping existing owners
   */
  assignInterestOwnersBulk: assignInterestOwnersBulk_assignInterestOwnersBulk | null;
}

export interface assignInterestOwnersBulkVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
  userIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: removeInterestOwnersBulk
// ====================================================

export interface removeInterestOwnersBulk_removeInterestOwnersBulk_failed {
  __typename: "BulkOwnerFailure";
  interestId: string;
  name: string | null;
  reason: string | null;
}

export interface removeInterestOwnersBulk_removeInterestOwnersBulk {
  __typename: "BulkOwnerResult";
  succeeded: string[];
  failed: removeInterestOwnersBulk_removeInterestOwnersBulk_failed[];
}

export interface removeInterestOwnersBulk {
  /**
   * Remove only the given owners from a bulk selection of interests
   */
  removeInterestOwnersBulk: removeInterestOwnersBulk_removeInterestOwnersBulk | null;
}

export interface removeInterestOwnersBulkVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
  userIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: bulkSelectionOwners
// ====================================================

export interface bulkSelectionOwners_bulkSelectionOwners_profile {
  __typename: "Profile";
  firstName: string | null;
  lastName: string | null;
}

export interface bulkSelectionOwners_bulkSelectionOwners {
  __typename: "UserPostgres";
  id: string;
  profile: bulkSelectionOwners_bulkSelectionOwners_profile;
}

export interface bulkSelectionOwners {
  /**
   * Distinct owners of a bulk selection, ordered by display name; scoped exactly as removeInterestOwnersBulk
   */
  bulkSelectionOwners: bulkSelectionOwners_bulkSelectionOwners[];
}

export interface bulkSelectionOwnersVariables {
  interestIds?: string[] | null;
  interestListIds: string[];
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: addInterestOwner
// ====================================================

export interface addInterestOwner {
  /**
   * Add an owner to an interest, keeping existing owners; re-adding an owner is a no-op
   */
  addInterestOwner: string | null;
}

export interface addInterestOwnerVariables {
  interestId: string;
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: removeInterestOwner
// ====================================================

export interface removeInterestOwner {
  /**
   * Remove one owner from an interest, keeping the others; removing a non-owner is a no-op
   */
  removeInterestOwner: string | null;
}

export interface removeInterestOwnerVariables {
  interestId: string;
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: tagEligible
// ====================================================

export interface tagEligible_tagInterestAsEligible {
  __typename: "Interest";
  id: string;
}

export interface tagEligible {
  /**
   * Tag interest as eligible
   */
  tagInterestAsEligible: tagEligible_tagInterestAsEligible | null;
}

export interface tagEligibleVariables {
  interestId: string;
  isEligible: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: sendForm
// ====================================================

export interface sendForm_sendFormToInterest {
  __typename: "Submission";
  id: string;
}

export interface sendForm {
  /**
   * Send form to an interest.
   */
  sendFormToInterest: sendForm_sendFormToInterest;
}

export interface sendFormVariables {
  interestId: string;
  type: FormType;
  deadline: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: sendFormToInterests
// ====================================================

export interface sendFormToInterests_sendFormToInterests {
  __typename: "Form";
  type: FormType;
}

export interface sendFormToInterests {
  /**
   * Send form to a set of interests.
   */
  sendFormToInterests: sendFormToInterests_sendFormToInterests;
}

export interface sendFormToInterestsVariables {
  interestIds: string[];
  type: FormType;
  deadline: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: syncOneSiteGuestCard
// ====================================================

export interface syncOneSiteGuestCard_onesiteSyncGuestCard {
  __typename: "GuestCard";
  interestId: string | null;
}

export interface syncOneSiteGuestCard {
  /**
   * Sync a guest_card
   */
  onesiteSyncGuestCard: syncOneSiteGuestCard_onesiteSyncGuestCard | null;
}

export interface syncOneSiteGuestCardVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DownloadInterestPDFMeta
// ====================================================

export interface DownloadInterestPDFMeta_interest_documents {
  __typename: "Document";
  name: string;
  downloadUrl: string;
  category: string;
}

export interface DownloadInterestPDFMeta_interest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  documents: DownloadInterestPDFMeta_interest_documents[];
}

export interface DownloadInterestPDFMeta {
  /**
   * Fetch a interest application by it's ID
   */
  interest: DownloadInterestPDFMeta_interest;
}

export interface DownloadInterestPDFMetaVariables {
  interestID: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeInterestStageProfile
// ====================================================

export interface ChangeInterestStageProfile {
  /**
   * Change the status of an interest
   */
  changeInterestStatus: string | null;
}

export interface ChangeInterestStageProfileVariables {
  interestId: string;
  status: string;
  reason?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: QueryInterestProfile
// ====================================================

export interface QueryInterestProfile_interest_status {
  __typename: "InterestStatus";
  name: string;
  changedAt: string | null;
}

export interface QueryInterestProfile_interest_owners {
  __typename: "UserPostgres";
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface QueryInterestProfile_interest_updateRequest {
  __typename: "UpdateRequest";
  isActive: boolean;
  updateUrl: string;
}

export interface QueryInterestProfile_interest_user {
  __typename: "UserPostgres";
  loginEmail: string | null;
  loginPhone: string | null;
}

export interface QueryInterestProfile_interest_interestList_property_stages {
  __typename: "StageSetting";
  id: string;
  name: string;
  enabled: boolean;
  standard: boolean;
}

export interface QueryInterestProfile_interest_interestList_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface QueryInterestProfile_interest_interestList_property_propertyUseCases {
  __typename: "PropertyUseCase";
  id: string;
}

export interface QueryInterestProfile_interest_interestList_property {
  __typename: "Property";
  id: string;
  stages: QueryInterestProfile_interest_interestList_property_stages[];
  features: QueryInterestProfile_interest_interestList_property_features[];
  propertyUseCases: QueryInterestProfile_interest_interestList_property_propertyUseCases[];
}

export interface QueryInterestProfile_interest_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  defaultSorting: string | null;
  property: QueryInterestProfile_interest_interestList_property;
}

export interface QueryInterestProfile_interest {
  __typename: "Interest";
  id: string;
  userId: string | null;
  linkCode: string | null;
  updatedAt: string | null;
  submittedAt: number | null;
  status: QueryInterestProfile_interest_status;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember0Email: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdGrossAnnualIncome: number | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  householdCount: any | null;
  householdRequiresImpairmentHearing: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  contactName: string | null;
  contactRelation: string | null;
  contactEmail: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneExt: string | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantEmail: string | null;
  mailingAddressType: string | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  prefMoveInDate: string | null;
  signatureId: string | null;
  skips: number | null;
  prefLang: string | null;
  hasEligibility: boolean | null;
  positionNumber: number | null;
  /**
   * Every owner of this interest, ordered by display name.
   */
  owners: QueryInterestProfile_interest_owners[];
  updateRequest: QueryInterestProfile_interest_updateRequest | null;
  user: QueryInterestProfile_interest_user | null;
  interestList: QueryInterestProfile_interest_interestList;
}

export interface QueryInterestProfile {
  /**
   * Fetch a interest application by it's ID
   */
  interest: QueryInterestProfile_interest;
}

export interface QueryInterestProfileVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: QueryInterestFormData
// ====================================================

export interface QueryInterestFormData_applicationFormMetadata_schema_options {
  __typename: "InputOption";
  label: string;
  value: string;
}

export interface QueryInterestFormData_applicationFormMetadata_schema {
  __typename: "SchemaObj";
  name: string | null;
  label: string | null;
  options: QueryInterestFormData_applicationFormMetadata_schema_options[] | null;
}

export interface QueryInterestFormData_applicationFormMetadata {
  __typename: "AppMetadata";
  schema: (QueryInterestFormData_applicationFormMetadata_schema | null)[] | null;
}

export interface QueryInterestFormData_interest_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
}

export interface QueryInterestFormData_interest_interestList {
  __typename: "InterestList";
  id: string;
  scheduledUpdate: QueryInterestFormData_interest_interestList_scheduledUpdate;
}

export interface QueryInterestFormData_interest_updateRequestInterests_updateRequest {
  __typename: "UpdateRequest";
  isActive: boolean;
}

export interface QueryInterestFormData_interest_updateRequestInterests {
  __typename: "UpdateRequestInterest";
  respondedAt: string | null;
  updateRequest: QueryInterestFormData_interest_updateRequestInterests_updateRequest;
}

export interface QueryInterestFormData_interest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
  interestList: QueryInterestFormData_interest_interestList;
  updateRequestInterests: QueryInterestFormData_interest_updateRequestInterests[];
}

export interface QueryInterestFormData {
  /**
   * Fetch metadata for whitelabel application list
   */
  applicationFormMetadata: QueryInterestFormData_applicationFormMetadata;
  /**
   * Fetch a interest application by it's ID
   */
  interest: QueryInterestFormData_interest;
}

export interface QueryInterestFormDataVariables {
  interestId: string;
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInterestFormData
// ====================================================

export interface UpdateInterestFormData_pmUpdateCompletedInterest_interest_updateRequest {
  __typename: "UpdateRequest";
  isActive: boolean;
}

export interface UpdateInterestFormData_pmUpdateCompletedInterest_interest {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
  updateRequest: UpdateInterestFormData_pmUpdateCompletedInterest_interest_updateRequest | null;
}

export interface UpdateInterestFormData_pmUpdateCompletedInterest {
  __typename: "InterestWithStatus";
  interest: UpdateInterestFormData_pmUpdateCompletedInterest_interest;
  status: string;
}

export interface UpdateInterestFormData {
  /**
   * Update a completed interest item
   */
  pmUpdateCompletedInterest: UpdateInterestFormData_pmUpdateCompletedInterest;
}

export interface UpdateInterestFormDataVariables {
  interestId: string;
  lastUpdated: string;
  data: InterestInput;
  keepOnList?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SidebarFilters
// ====================================================

export interface SidebarFilters_interestListsById_sidebarFilters {
  __typename: "SidebarFilter";
  name: string;
  label: string;
  type: string;
}

export interface SidebarFilters_interestListsById_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface SidebarFilters_interestListsById_property_stages {
  __typename: "StageSetting";
  id: string;
  name: string;
  enabled: boolean;
  standard: boolean;
}

export interface SidebarFilters_interestListsById_property {
  __typename: "Property";
  features: SidebarFilters_interestListsById_property_features[];
  id: string;
  stages: SidebarFilters_interestListsById_property_stages[];
}

export interface SidebarFilters_interestListsById {
  __typename: "InterestList";
  id: string;
  defaultSorting: string | null;
  sidebarFilters: SidebarFilters_interestListsById_sidebarFilters[];
  property: SidebarFilters_interestListsById_property;
}

export interface SidebarFilters {
  /**
   * Interest Lists by ID
   */
  interestListsById: SidebarFilters_interestListsById[];
}

export interface SidebarFiltersVariables {
  interestListIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ApplicantSearch
// ====================================================

export interface ApplicantSearch_applicantSearch_items {
  __typename: "ElasticsearchInterestFull";
  userId: string | null;
  applicantName: string | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantPhone: string | null;
  applicantEmail: string | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  residenceCity: string | null;
  householdIncome: number | null;
  ownerNames: string[];
  ownerUserIds: string[];
  isComplete: boolean | null;
  hasPositionNumber: boolean | null;
  hasUserId: boolean | null;
  positionNumber: number | null;
  hasStar: boolean | null;
  id: string;
  interestListId: string;
  skips: number | null;
  status: string | null;
  weight: number | null;
  lastStatusChange: string | null;
  currentRemovalReason: string | null;
  submittedAt: number | null;
  hasHouseholdIncome: boolean | null;
  householdCount: number | null;
  householdGrossAnnualIncome: number | null;
  householdMember0Email: string | null;
  householdMember0Gender: string | null;
  householdMember0MiddleName: string | null;
  prefLang: string | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  isDuplicate: boolean | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
}

export interface ApplicantSearch_applicantSearch {
  __typename: "ApplicantSearchResult";
  page: number;
  pageSize: number;
  hits: number;
  items: ApplicantSearch_applicantSearch_items[];
}

export interface ApplicantSearch {
  applicantSearch: ApplicantSearch_applicantSearch;
}

export interface ApplicantSearchVariables {
  elasticQuery: ElasticQuery;
  interestListIds: string[];
  page?: number | null;
  pageSize?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestOwners
// ====================================================

export interface InterestOwners_interest_owners {
  __typename: "UserPostgres";
  id: string;
  firstName: string | null;
  lastName: string | null;
}

export interface InterestOwners_interest {
  __typename: "Interest";
  id: string;
  /**
   * Every owner of this interest, ordered by display name.
   */
  owners: InterestOwners_interest_owners[];
}

export interface InterestOwners {
  /**
   * Fetch a interest application by it's ID
   */
  interest: InterestOwners_interest;
}

export interface InterestOwnersVariables {
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestCsvFields
// ====================================================

export interface InterestCsvFields_interestCsvFields {
  __typename: "InterestCsvField";
  label: string;
  name: string;
}

export interface InterestCsvFields {
  /**
   * All available CSV fields to download
   */
  interestCsvFields: InterestCsvFields_interestCsvFields[];
}

export interface InterestCsvFieldsVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendMessages
// ====================================================

export interface SendMessages {
  /**
   * Send messages to a selection of interests
   */
  sendMessages: string | null;
}

export interface SendMessagesVariables {
  interestListIds: string[];
  interestIds?: string[] | null;
  elasticQuery?: ElasticQuery | null;
  pageFrom?: number | null;
  pageTo?: number | null;
  emailEnabled: boolean;
  emailRespondToEnabled?: boolean | null;
  emailBody: string;
  emailSubject: string;
  letterEnabled: boolean;
  letterBody: string;
  smsEnabled: boolean;
  smsBody: string;
  emailBccAddress?: string | null;
  smsPropertyUseCaseId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: changeMultipleStatuses
// ====================================================

export interface changeMultipleStatuses {
  /**
   * Change the status of multiple interests on the same interest list
   */
  changeInterestsStatus: string[];
}

export interface changeMultipleStatusesVariables {
  interestListIds: string[];
  interestIds?: string[] | null;
  elasticQuery?: ElasticQuery | null;
  status: string;
  reason?: string | null;
  pageFrom?: number | null;
  pageTo?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: messageErrors
// ====================================================

export interface messageErrors_messages {
  __typename: "Message";
  id: string | null;
  insertedAt: string | null;
  status: string | null;
  recipientName: string | null;
  interestUrl: string | null;
  subject: string | null;
  emailToAddress: string | null;
  mobileNumber: string | null;
  bodyPreview: string | null;
}

export interface messageErrors {
  /**
   * Messages
   */
  messages: (messageErrors_messages | null)[] | null;
}

export interface messageErrorsVariables {
  type?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getOrgLists
// ====================================================

export interface getOrgLists_organization_interestLists_property {
  __typename: "Property";
  id: string;
  isDraft: boolean | null;
}

export interface getOrgLists_organization_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  property: getOrgLists_organization_interestLists_property;
}

export interface getOrgLists_organization {
  __typename: "Organization";
  id: string;
  interestLists: getOrgLists_organization_interestLists[];
}

export interface getOrgLists {
  /**
   * Fetch an organization by it's ID
   */
  organization: getOrgLists_organization;
}

export interface getOrgListsVariables {
  orgId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyContractsSidebar
// ====================================================

export interface PropertyContractsSidebar_propertyContractsSidebar {
  __typename: "PropertyContract";
  id: string;
  propertyName: string | null;
  status: string | null;
  interestListId: string | null;
}

export interface PropertyContractsSidebar {
  /**
   * Sent property contracts for the settings sidebar (excludes drafts)
   */
  propertyContractsSidebar: PropertyContractsSidebar_propertyContractsSidebar[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ManagerSettingsPropertyContractsList
// ====================================================

export interface ManagerSettingsPropertyContractsList_propertyContracts {
  __typename: "PropertyContract";
  id: string;
  propertyName: string | null;
  planId: string | null;
  planName: string | null;
  unitCount: number | null;
  pricePerUnit: any | null;
  billingFrequency: string | null;
  status: string | null;
  hasPdf: boolean | null;
}

export interface ManagerSettingsPropertyContractsList {
  /**
   * List all property contracts for the current organization (admin)
   */
  propertyContracts: ManagerSettingsPropertyContractsList_propertyContracts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContractPdfDownloadUrl
// ====================================================

export interface ContractPdfDownloadUrl {
  /**
   * Fresh presigned download URL for a signed contract PDF (generated at request time); nil when no PDF exists
   */
  propertyContractPdfUrl: string | null;
}

export interface ContractPdfDownloadUrlVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyContractsShared
// ====================================================

export interface PropertyContractsShared_propertyContracts {
  __typename: "PropertyContract";
  id: string;
  interestListId: string | null;
  propertyName: string | null;
  propertyLegalName: string | null;
  signerName: string | null;
  signerEmail: string | null;
  signerTitle: string | null;
  signatureRequestId: string | null;
  submissionId: string | null;
  embedded: boolean | null;
  status: string | null;
  sentAt: string | null;
  signedAt: string | null;
  cancelledAt: string | null;
  contractStartDate: any | null;
  initialTermEndDate: any | null;
  pdfUrl: string | null;
}

export interface PropertyContractsShared {
  /**
   * List all property contracts for the current organization (admin)
   */
  propertyContracts: PropertyContractsShared_propertyContracts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResendPropertyContractShared
// ====================================================

export interface ResendPropertyContractShared_resendPropertyContract {
  __typename: "ResendPropertyContractResult";
  signatureRequestId: string | null;
  signUrl: string | null;
}

export interface ResendPropertyContractShared {
  /**
   * Resend a property contract for signature; embedded contracts also return sign_url
   */
  resendPropertyContract: ResendPropertyContractShared_resendPropertyContract | null;
}

export interface ResendPropertyContractSharedVariables {
  id: string;
  signerName?: string | null;
  signerEmail?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PropertyContractSignUrlShared
// ====================================================

export interface PropertyContractSignUrlShared {
  /**
   * Get an embedded sign URL for an existing sent contract
   */
  propertyContractSignUrl: string | null;
}

export interface PropertyContractSignUrlSharedVariables {
  id: string;
  timeZone?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkPropertyContractPendingShared
// ====================================================

export interface MarkPropertyContractPendingShared {
  /**
   * Mark a sent contract as pending after the signer completes embedded signing (no-op if already signed)
   */
  markPropertyContractPending: boolean | null;
}

export interface MarkPropertyContractPendingSharedVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchivePropertyContractShared
// ====================================================

export interface ArchivePropertyContractShared {
  /**
   * Archive a property contract while it is still a draft
   */
  archivePropertyContract: boolean | null;
}

export interface ArchivePropertyContractSharedVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getListByIdShort
// ====================================================

export interface getListByIdShort_interestList_property {
  __typename: "Property";
  timezone: string | null;
}

export interface getListByIdShort_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  property: getListByIdShort_interestList_property;
}

export interface getListByIdShort {
  /**
   * Interest List
   */
  interestList: getListByIdShort_interestList;
}

export interface getListByIdShortVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orgQuery
// ====================================================

export interface orgQuery_viewer_organization {
  __typename: "Organization";
  id: string;
  bccEmail: string | null;
  logoFilename: string | null;
  whoCanAssign: string | null;
  pmVisibility: string | null;
}

export interface orgQuery_viewer {
  __typename: "UserPostgres";
  id: string;
  organization: orgQuery_viewer_organization | null;
}

export interface orgQuery {
  /**
   * Logged in user
   */
  viewer: orgQuery_viewer | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateOrgDashboard
// ====================================================

export interface updateOrgDashboard_updateOrganization {
  __typename: "Organization";
  id: string;
  bccEmail: string | null;
}

export interface updateOrgDashboard {
  /**
   * Update an organization
   */
  updateOrganization: updateOrgDashboard_updateOrganization | null;
}

export interface updateOrgDashboardVariables {
  id: string;
  data: OrganizationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateOrgOwnerAssignment
// ====================================================

export interface updateOrgOwnerAssignment_updateOrganization {
  __typename: "Organization";
  id: string;
  whoCanAssign: string | null;
  pmVisibility: string | null;
}

export interface updateOrgOwnerAssignment {
  /**
   * Update an organization
   */
  updateOrganization: updateOrgOwnerAssignment_updateOrganization | null;
}

export interface updateOrgOwnerAssignmentVariables {
  id: string;
  data: OrganizationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateOrgLogo
// ====================================================

export interface updateOrgLogo_updateOrganization {
  __typename: "Organization";
  id: string;
}

export interface updateOrgLogo {
  /**
   * Update an organization
   */
  updateOrganization: updateOrgLogo_updateOrganization | null;
}

export interface updateOrgLogoVariables {
  id: string;
  data: OrganizationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchWaitlistUpdateSettings
// ====================================================

export interface FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests_settings {
  __typename: "ScheduledUpdateSettings";
  enabled: boolean;
  letterMode: string;
  letterDelay: boolean;
}

export interface FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests_templates {
  __typename: "Template";
  id: string;
  type: TemplateType;
  name: string | null;
  body: string;
  html: string | null;
}

export interface FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests {
  __typename: "ScheduledUpdateRequest";
  settings: FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests_settings;
  templates: FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests_templates[];
}

export interface FetchWaitlistUpdateSettings_organization_interestLists_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
}

export interface FetchWaitlistUpdateSettings_organization_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  type: string | null;
  scheduledUpdate: FetchWaitlistUpdateSettings_organization_interestLists_scheduledUpdate;
}

export interface FetchWaitlistUpdateSettings_organization {
  __typename: "Organization";
  id: string;
  scheduledUpdateRequests: FetchWaitlistUpdateSettings_organization_scheduledUpdateRequests;
  interestLists: FetchWaitlistUpdateSettings_organization_interestLists[];
}

export interface FetchWaitlistUpdateSettings {
  /**
   * Fetch an organization by it's ID
   */
  organization: FetchWaitlistUpdateSettings_organization;
}

export interface FetchWaitlistUpdateSettingsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeWaitlistUpdateSettings
// ====================================================

export interface ChangeWaitlistUpdateSettings_changeScheduledUpdateSettings_settings {
  __typename: "ScheduledUpdateSettings";
  enabled: boolean;
  letterMode: string;
  letterDelay: boolean;
}

export interface ChangeWaitlistUpdateSettings_changeScheduledUpdateSettings {
  __typename: "ScheduledUpdateRequest";
  settings: ChangeWaitlistUpdateSettings_changeScheduledUpdateSettings_settings;
}

export interface ChangeWaitlistUpdateSettings {
  /**
   * Change waitlist update organization settings
   */
  changeScheduledUpdateSettings: ChangeWaitlistUpdateSettings_changeScheduledUpdateSettings | null;
}

export interface ChangeWaitlistUpdateSettingsVariables {
  id: string;
  options: WaitlistUpdateOptions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleWaitlistUpdate
// ====================================================

export interface ToggleWaitlistUpdate {
  /**
   * Change waitlist update interest list settings
   */
  changeWaitlistUpdateSettings: boolean | null;
}

export interface ToggleWaitlistUpdateVariables {
  id: string;
  enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createTeamUser
// ====================================================

export interface createTeamUser_createUser {
  __typename: "UserPostgres";
  id: string;
  email: string | null;
}

export interface createTeamUser {
  /**
   * Create a user
   */
  createUser: createTeamUser_createUser | null;
}

export interface createTeamUserVariables {
  data: UserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getTeamByOrgId
// ====================================================

export interface getTeamByOrgId_organization_team {
  __typename: "UserPostgres";
  id: string;
  fullName: string | null;
  email: string | null;
  roles: UserRole[];
  directPhone: string | null;
  title: string | null;
  isArchived: boolean;
}

export interface getTeamByOrgId_organization {
  __typename: "Organization";
  id: string;
  name: string;
  team: getTeamByOrgId_organization_team[];
}

export interface getTeamByOrgId {
  /**
   * Fetch an organization by it's ID
   */
  organization: getTeamByOrgId_organization;
}

export interface getTeamByOrgIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: deleteTeamMember
// ====================================================

export interface deleteTeamMember {
  /**
   * Delete a team member
   */
  deleteUser: string | null;
}

export interface deleteTeamMemberVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: archiveTeamMember
// ====================================================

export interface archiveTeamMember_archiveUser {
  __typename: "UserPostgres";
  id: string;
  isArchived: boolean;
}

export interface archiveTeamMember {
  /**
   * Archive a team member
   */
  archiveUser: archiveTeamMember_archiveUser | null;
}

export interface archiveTeamMemberVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: restoreTeamMember
// ====================================================

export interface restoreTeamMember_restoreUser {
  __typename: "UserPostgres";
  id: string;
  isArchived: boolean;
}

export interface restoreTeamMember {
  /**
   * Restore a team member
   */
  restoreUser: restoreTeamMember_restoreUser | null;
}

export interface restoreTeamMemberVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getUserforTeam
// ====================================================

export interface getUserforTeam_user_lists {
  __typename: "ListItem";
  id: string;
  name: string;
}

export interface getUserforTeam_user {
  __typename: "UserPostgres";
  id: string;
  organizationId: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  roles: UserRole[];
  directPhone: string | null;
  title: string | null;
  isArchived: boolean;
  /**
   * The waitlists a property manager user belongs to
   */
  lists: getUserforTeam_user_lists[] | null;
}

export interface getUserforTeam {
  /**
   * Fetch users by id (admin)
   */
  user: getUserforTeam_user;
}

export interface getUserforTeamVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateUserForTeam
// ====================================================

export interface updateUserForTeam_updateUser {
  __typename: "UserPostgres";
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  roles: UserRole[];
}

export interface updateUserForTeam {
  /**
   * Update a user (admin/ supervisor/ team member)
   */
  updateUser: updateUserForTeam_updateUser | null;
}

export interface updateUserForTeamVariables {
  id: string;
  data: UserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyContractProgress
// ====================================================

export interface PropertyContractProgress_propertyContractProgress {
  __typename: "PropertyContractProgress";
  submissionId: string | null;
  stepIndex: number | null;
  valuesJson: string | null;
}

export interface PropertyContractProgress {
  /**
   * Load in-progress property contract draft for current user (optionally by submission_id)
   */
  propertyContractProgress: PropertyContractProgress_propertyContractProgress | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreatePropertyContract
// ====================================================

export interface CreatePropertyContract_createPropertyContract {
  __typename: "CreatePropertyContractResult";
  id: string | null;
  signUrl: string | null;
  signatureRequestId: string | null;
}

export interface CreatePropertyContract {
  /**
   * Create a property contract (embedded returns sign_url; email returns signature_request_id)
   */
  createPropertyContract: CreatePropertyContract_createPropertyContract | null;
}

export interface CreatePropertyContractVariables {
  data: CreatePropertyContractInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SavePropertyContractProgress
// ====================================================

export interface SavePropertyContractProgress_savePropertyContractProgress {
  __typename: "SavePropertyContractProgressResult";
  submissionId: string;
}

export interface SavePropertyContractProgress {
  /**
   * Persist property contract draft progress (step + values) and return submission_id
   */
  savePropertyContractProgress: SavePropertyContractProgress_savePropertyContractProgress;
}

export interface SavePropertyContractProgressVariables {
  data: SavePropertyContractProgressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelPropertyContract
// ====================================================

export interface CancelPropertyContract {
  /**
   * Cancel a property contract by signature_request_id
   */
  cancelPropertyContract: boolean | null;
}

export interface CancelPropertyContractVariables {
  signatureRequestId: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendPropertyQuoteEmail
// ====================================================

export interface SendPropertyQuoteEmail {
  /**
   * Email a PDF quote for the selected plan and property (same pricing as the contract order form)
   */
  sendPropertyQuoteEmail: boolean | null;
}

export interface SendPropertyQuoteEmailVariables {
  data: SendPropertyQuoteEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyContractSigningStatus
// ====================================================

export interface PropertyContractSigningStatus_propertyContracts {
  __typename: "PropertyContract";
  id: string;
  status: string | null;
  pdfUrl: string | null;
}

export interface PropertyContractSigningStatus {
  /**
   * List all property contracts for the current organization (admin)
   */
  propertyContracts: PropertyContractSigningStatus_propertyContracts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyBuildings
// ====================================================

export interface PropertyBuildings_propertyBuildings {
  __typename: "Building";
  id: string;
  name: string;
  type: BuildingType;
  bin: string | null;
  phase: string | null;
  address1: string;
  address2: string | null;
  city: string;
  state: UsState;
  zip: string;
}

export interface PropertyBuildings {
  propertyBuildings: PropertyBuildings_propertyBuildings[];
}

export interface PropertyBuildingsVariables {
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBuilding
// ====================================================

export interface UpdateBuilding_updateBuilding {
  __typename: "Building";
  id: string;
  name: string;
}

export interface UpdateBuilding {
  updateBuilding: UpdateBuilding_updateBuilding | null;
}

export interface UpdateBuildingVariables {
  id: string;
  input: UpdateBuildingInput;
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateBuilding
// ====================================================

export interface CreateBuilding_createBuilding {
  __typename: "Building";
  id: string;
  name: string;
}

export interface CreateBuilding {
  createBuilding: CreateBuilding_createBuilding | null;
}

export interface CreateBuildingVariables {
  input: BuildingInput;
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteBuilding
// ====================================================

export interface DeleteBuilding_deleteBuilding {
  __typename: "Building";
  id: string;
}

export interface DeleteBuilding {
  deleteBuilding: DeleteBuilding_deleteBuilding | null;
}

export interface DeleteBuildingVariables {
  id: string;
  propertyId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ListBuildingUnits
// ====================================================

export interface ListBuildingUnits_buildingUnits {
  __typename: "BuildingUnit";
  id: string;
  name: string;
  bedrooms: string;
  bathrooms: number;
  occupancyMin: number;
  occupancyMax: number;
  rentType: string;
  rentValue: number;
  sqft: number;
  floor: number;
  occupied: string;
  isReferral: boolean;
  referralOrg: string | null;
  accessibility: string[];
  buildingId: string;
  fundingSource: string[];
  incomeDesignation: string;
  preference: string[];
}

export interface ListBuildingUnits {
  /**
   * Get all Building Units
   */
  buildingUnits: ListBuildingUnits_buildingUnits[];
}

export interface ListBuildingUnitsVariables {
  buildingId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateBuildingUnit
// ====================================================

export interface CreateBuildingUnit_createBuildingUnit {
  __typename: "BuildingUnit";
  id: string;
  name: string;
  bedrooms: string;
  bathrooms: number;
  occupancyMin: number;
  occupancyMax: number;
  rentType: string;
  rentValue: number;
  sqft: number;
  floor: number;
  occupied: string;
  isReferral: boolean;
  referralOrg: string | null;
  accessibility: string[];
  buildingId: string;
  fundingSource: string[];
  incomeDesignation: string;
  preference: string[];
}

export interface CreateBuildingUnit {
  /**
   * Create a new Building Unit
   */
  createBuildingUnit: CreateBuildingUnit_createBuildingUnit | null;
}

export interface CreateBuildingUnitVariables {
  buildingUnit: BuildingUnitInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBuildingUnit
// ====================================================

export interface UpdateBuildingUnit_updateBuildingUnit {
  __typename: "BuildingUnit";
  id: string;
  name: string;
  bedrooms: string;
  bathrooms: number;
  occupancyMin: number;
  occupancyMax: number;
  rentType: string;
  rentValue: number;
  sqft: number;
  floor: number;
  occupied: string;
  isReferral: boolean;
  referralOrg: string | null;
  accessibility: string[];
  buildingId: string;
  fundingSource: string[];
  incomeDesignation: string;
  preference: string[];
}

export interface UpdateBuildingUnit {
  /**
   * Update an existing Building Unit
   */
  updateBuildingUnit: UpdateBuildingUnit_updateBuildingUnit | null;
}

export interface UpdateBuildingUnitVariables {
  id: string;
  buildingUnit: UpdateBuildingUnitInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteBuildingUnit
// ====================================================

export interface DeleteBuildingUnit_deleteBuildingUnit {
  __typename: "BuildingUnit";
  id: string;
}

export interface DeleteBuildingUnit {
  /**
   * Delete a Building Unit
   */
  deleteBuildingUnit: DeleteBuildingUnit_deleteBuildingUnit | null;
}

export interface DeleteBuildingUnitVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertyDigestById
// ====================================================

export interface getPropertyDigestById_property {
  __typename: "Property";
  id: string;
  email: string;
  submissionDigestEnabled: boolean;
}

export interface getPropertyDigestById {
  /**
   * Property by it's ID
   */
  property: getPropertyDigestById_property;
}

export interface getPropertyDigestByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePropertyDailyDigest
// ====================================================

export interface updatePropertyDailyDigest_updatePropertyDailyDigest {
  __typename: "Property";
  id: string;
  email: string;
  submissionDigestEnabled: boolean;
}

export interface updatePropertyDailyDigest {
  /**
   * Update a property's daily digest settings
   */
  updatePropertyDailyDigest: updatePropertyDailyDigest_updatePropertyDailyDigest;
}

export interface updatePropertyDailyDigestVariables {
  id: string;
  data: PropertyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: toggleFormOpen
// ====================================================

export interface toggleFormOpen_toggleFormOpen {
  __typename: "Form";
  id: string;
}

export interface toggleFormOpen {
  /**
   * Allow a manager to open/close a form
   */
  toggleFormOpen: toggleFormOpen_toggleFormOpen | null;
}

export interface toggleFormOpenVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: toggleFormDisplay
// ====================================================

export interface toggleFormDisplay_toggleFormDisplay {
  __typename: "Form";
  id: string;
}

export interface toggleFormDisplay {
  toggleFormDisplay: toggleFormDisplay_toggleFormDisplay | null;
}

export interface toggleFormDisplayVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setListDefaultSorting
// ====================================================

export interface setListDefaultSorting_setListDefaultSorting {
  __typename: "InterestList";
  id: string;
  defaultSorting: string | null;
}

export interface setListDefaultSorting {
  /**
   * Allow a manager to set list default sorting
   */
  setListDefaultSorting: setListDefaultSorting_setListDefaultSorting | null;
}

export interface setListDefaultSortingVariables {
  id: string;
  defaultSorting: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setPropertyTimezone
// ====================================================

export interface setPropertyTimezone_setPropertyTimezone {
  __typename: "Property";
  id: string;
  timezone: string | null;
}

export interface setPropertyTimezone {
  /**
   * Allow a manager to adjust proprty timezone
   */
  setPropertyTimezone: setPropertyTimezone_setPropertyTimezone | null;
}

export interface setPropertyTimezoneVariables {
  propertyId: string;
  timezone: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertyReinstatementEmailById
// ====================================================

export interface getPropertyReinstatementEmailById_property {
  __typename: "Property";
  id: string;
  reinstatementEmail: string | null;
  reinstatementEmailFrequency: string;
}

export interface getPropertyReinstatementEmailById {
  /**
   * Property by it's ID
   */
  property: getPropertyReinstatementEmailById_property;
}

export interface getPropertyReinstatementEmailByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePropertyReinstatement
// ====================================================

export interface updatePropertyReinstatement_updatePropertyReinstatement {
  __typename: "Property";
  id: string;
  reinstatementEmail: string | null;
  reinstatementEmailFrequency: string;
}

export interface updatePropertyReinstatement {
  updatePropertyReinstatement: updatePropertyReinstatement_updatePropertyReinstatement;
}

export interface updatePropertyReinstatementVariables {
  id: string;
  data: PropertyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertyById
// ====================================================

export interface getPropertyById_property {
  __typename: "Property";
  id: string;
  name: string;
  phone: string;
  email: string;
  respondToEmail: string | null;
  respondToEmailEnabled: boolean;
}

export interface getPropertyById {
  /**
   * Property by it's ID
   */
  property: getPropertyById_property;
}

export interface getPropertyByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateProperty
// ====================================================

export interface updateProperty_updateProperty {
  __typename: "Property";
  id: string;
  respondToEmail: string | null;
  respondToEmailEnabled: boolean;
}

export interface updateProperty {
  /**
   * Update a property
   */
  updateProperty: updateProperty_updateProperty | null;
}

export interface updatePropertyVariables {
  id: string;
  data: PropertyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setListWaitTime
// ====================================================

export interface setListWaitTime_setListWaitTime {
  __typename: "InterestList";
  id: string;
  waitTime: string;
}

export interface setListWaitTime {
  /**
   * Allow a manager to set list wait time
   */
  setListWaitTime: setListWaitTime_setListWaitTime | null;
}

export interface setListWaitTimeVariables {
  id: string;
  waitTime: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: invoicedLetterCosts
// ====================================================

export interface invoicedLetterCosts_invoicedLetterCosts {
  __typename: "InvoicedLetterCosts";
  firstPageCost: any | null;
  additionalPagesCost: any | null;
}

export interface invoicedLetterCosts {
  /**
   * Combined unit costs for letter 'first_page' and 'additional_pages'
   */
  invoicedLetterCosts: invoicedLetterCosts_invoicedLetterCosts | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getListById
// ====================================================

export interface getListById_interestList_property_forms {
  __typename: "Form";
  id: string;
  type: FormType;
  open: boolean;
  display: boolean;
  createInterest: boolean;
}

export interface getListById_interestList_property {
  __typename: "Property";
  id: string;
  name: string;
  isDraft: boolean | null;
  respondToEmailEnabled: boolean;
  timezone: string | null;
  forms: getListById_interestList_property_forms[];
}

export interface getListById_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  isOpen: boolean | null;
  defaultSorting: string | null;
  waitTime: string;
  property: getListById_interestList_property;
}

export interface getListById {
  /**
   * Interest List
   */
  interestList: getListById_interestList;
}

export interface getListByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getPropertyInfoById
// ====================================================

export interface getPropertyInfoById_property_address {
  __typename: "Address";
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: any | null;
}

export interface getPropertyInfoById_property {
  __typename: "Property";
  id: string;
  name: string;
  phone: string;
  phoneExt: string | null;
  email: string;
  address: getPropertyInfoById_property_address | null;
}

export interface getPropertyInfoById {
  /**
   * Property by it's ID
   */
  property: getPropertyInfoById_property;
}

export interface getPropertyInfoByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePropertyDetails
// ====================================================

export interface updatePropertyDetails_updateProperty_address {
  __typename: "Address";
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: any | null;
}

export interface updatePropertyDetails_updateProperty {
  __typename: "Property";
  id: string;
  name: string;
  phone: string;
  phoneExt: string | null;
  email: string;
  address: updatePropertyDetails_updateProperty_address | null;
}

export interface updatePropertyDetails {
  /**
   * Update a property
   */
  updateProperty: updatePropertyDetails_updateProperty | null;
}

export interface updatePropertyDetailsVariables {
  id: string;
  data: PropertyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyStageSettings
// ====================================================

export interface PropertyStageSettings_property_stages {
  __typename: "StageSetting";
  id: string;
  name: string;
  enabled: boolean;
  standard: boolean;
}

export interface PropertyStageSettings_property {
  __typename: "Property";
  id: string;
  name: string;
  stages: PropertyStageSettings_property_stages[];
}

export interface PropertyStageSettings {
  /**
   * Property by it's ID
   */
  property: PropertyStageSettings_property;
}

export interface PropertyStageSettingsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleStageSettings
// ====================================================

export interface ToggleStageSettings_togglePropertyStage {
  __typename: "PropertyStageSettingsResult";
  isSuccess: boolean;
  reason: string;
}

export interface ToggleStageSettings {
  /**
   * Enable or disable an applicant stage setting
   */
  togglePropertyStage: ToggleStageSettings_togglePropertyStage;
}

export interface ToggleStageSettingsVariables {
  property: string;
  stage: string;
  enabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: InterestListUsers
// ====================================================

export interface InterestListUsers_interestListUsers {
  __typename: "UserPostgres";
  id: string;
  fullName: string | null;
  email: string | null;
  roles: UserRole[];
  directPhone: string | null;
  title: string | null;
}

export interface InterestListUsers {
  /**
   * Fetch users for interest list (property mgr/supervisor)
   */
  interestListUsers: InterestListUsers_interestListUsers[];
}

export interface InterestListUsersVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: templateGroups
// ====================================================

export interface templateGroups_templateGroups_user_profile {
  __typename: "Profile";
  fullName: string;
}

export interface templateGroups_templateGroups_user {
  __typename: "UserPostgres";
  profile: templateGroups_templateGroups_user_profile;
}

export interface templateGroups_templateGroups_properties {
  __typename: "Property";
  name: string;
}

export interface templateGroups_templateGroups_templates {
  __typename: "Template";
  id: string;
  type: TemplateType;
  isEmpty: boolean | null;
  updatedAt: string | null;
}

export interface templateGroups_templateGroups {
  __typename: "TemplateGroup";
  id: string;
  name: string;
  isOrgTemplate: boolean | null;
  isPropertyTemplate: boolean | null;
  organizationId: string | null;
  userId: string | null;
  user: templateGroups_templateGroups_user | null;
  properties: templateGroups_templateGroups_properties[];
  canModify: boolean | null;
  templates: templateGroups_templateGroups_templates[];
}

export interface templateGroups {
  /**
   * TemplateGroups for User
   */
  templateGroups: templateGroups_templateGroups[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createTemplateGroup
// ====================================================

export interface createTemplateGroup_createTemplateGroup {
  __typename: "TemplateGroup";
  id: string;
}

export interface createTemplateGroup {
  /**
   * Create template group with multiple channels
   */
  createTemplateGroup: createTemplateGroup_createTemplateGroup | null;
}

export interface createTemplateGroupVariables {
  data: TemplateGroupCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: removeTemplateGroup
// ====================================================

export interface removeTemplateGroup_removeTemplateGroup {
  __typename: "TemplateGroup";
  id: string;
}

export interface removeTemplateGroup {
  /**
   * Remove Template Group (admin/owner only)
   */
  removeTemplateGroup: removeTemplateGroup_removeTemplateGroup | null;
}

export interface removeTemplateGroupVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateTemplateGroup
// ====================================================

export interface DuplicateTemplateGroup_duplicateTemplateGroup {
  __typename: "TemplateGroup";
  id: string;
}

export interface DuplicateTemplateGroup {
  /**
   * Duplicate a TemplateGroup
   */
  duplicateTemplateGroup: DuplicateTemplateGroup_duplicateTemplateGroup | null;
}

export interface DuplicateTemplateGroupVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateTemplateGroup
// ====================================================

export interface updateTemplateGroup_updateTemplateGroup {
  __typename: "TemplateGroup";
  id: string;
}

export interface updateTemplateGroup {
  /**
   * Update a TemplateGroup
   */
  updateTemplateGroup: updateTemplateGroup_updateTemplateGroup | null;
}

export interface updateTemplateGroupVariables {
  id: string;
  data: TemplateGroupCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getTemplateGroup
// ====================================================

export interface getTemplateGroup_templateGroup_properties {
  __typename: "Property";
  id: string;
  interestListId: string | null;
  name: string;
}

export interface getTemplateGroup_templateGroup_templates {
  __typename: "Template";
  id: string;
  type: TemplateType;
  html: string | null;
  body: string;
  subject: string | null;
  isEmpty: boolean | null;
}

export interface getTemplateGroup_templateGroup {
  __typename: "TemplateGroup";
  id: string;
  name: string;
  isOrgTemplate: boolean | null;
  isPropertyTemplate: boolean | null;
  properties: getTemplateGroup_templateGroup_properties[];
  canModify: boolean | null;
  templates: getTemplateGroup_templateGroup_templates[];
}

export interface getTemplateGroup {
  /**
   * TemplateGroups by id
   */
  templateGroup: getTemplateGroup_templateGroup | null;
}

export interface getTemplateGroupVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveApplicants
// ====================================================

export interface RemoveApplicants {
  /**
   * Change the status of multiple interests on the same interest list
   */
  changeInterestsStatus: string[];
}

export interface RemoveApplicantsVariables {
  interestListIds: string[];
  interestIds?: string[] | null;
  status: string;
  reason?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: NotDuplicate
// ====================================================

export interface NotDuplicate_notDuplicate {
  __typename: "InterestNotDuplicate";
  id: string;
}

export interface NotDuplicate {
  /**
   * Mark one or more interests as Not Duplicate
   */
  notDuplicate: NotDuplicate_notDuplicate[];
}

export interface NotDuplicateVariables {
  interestIds: string[];
  criteria: string[];
  otherCandidateIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyDuplicates
// ====================================================

export interface PropertyDuplicates_interestList_property_features {
  __typename: "FeatureFlag";
  id: string;
  name: Feature;
}

export interface PropertyDuplicates_interestList_property_duplicates_candidates {
  __typename: "DuplicateInterestCandidate";
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  loginEmail: string | null;
  loginPhone: string | null;
  userId: string | null;
  ssn: string | null;
  propertyName: string;
  submittedAt: number;
  mailingAddress1: string | null;
  mailingAddress2: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  residenceAddress1: string | null;
  residenceAddress2: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
}

export interface PropertyDuplicates_interestList_property_duplicates {
  __typename: "DuplicateInterestGroup";
  matchedFields: string[];
  showSocialColumn: boolean;
  candidates: PropertyDuplicates_interestList_property_duplicates_candidates[];
}

export interface PropertyDuplicates_interestList_property {
  __typename: "Property";
  id: string;
  features: PropertyDuplicates_interestList_property_features[];
  duplicates: PropertyDuplicates_interestList_property_duplicates[];
}

export interface PropertyDuplicates_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  property: PropertyDuplicates_interestList_property;
}

export interface PropertyDuplicates {
  /**
   * Interest List
   */
  interestList: PropertyDuplicates_interestList;
}

export interface PropertyDuplicatesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertyDuplicatesCount
// ====================================================

export interface PropertyDuplicatesCount_interestList_property {
  __typename: "Property";
  id: string;
  duplicatesCount: number;
}

export interface PropertyDuplicatesCount_interestList {
  __typename: "InterestList";
  id: string;
  property: PropertyDuplicatesCount_interestList_property;
}

export interface PropertyDuplicatesCount {
  /**
   * Interest List
   */
  interestList: PropertyDuplicatesCount_interestList;
}

export interface PropertyDuplicatesCountVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormDocumentComplete
// ====================================================

export interface FormDocumentComplete_documentUploadComplete {
  __typename: "Document";
  id: string;
}

export interface FormDocumentComplete {
  /**
   * Mark document uploads as completed.
   */
  documentUploadComplete: FormDocumentComplete_documentUploadComplete[];
}

export interface FormDocumentCompleteVariables {
  documents: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSubDoc
// ====================================================

export interface CreateSubDoc_createSubmissionDocument_document {
  __typename: "Document";
  id: string;
}

export interface CreateSubDoc_createSubmissionDocument {
  __typename: "DocumentPreflight";
  uploadUrl: string;
  document: CreateSubDoc_createSubmissionDocument_document;
}

export interface CreateSubDoc {
  createSubmissionDocument: CreateSubDoc_createSubmissionDocument;
}

export interface CreateSubDocVariables {
  submissionId: string;
  document: SubmissionDocumentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFormSignature
// ====================================================

export interface CreateFormSignature {
  /**
   * Sign a submission
   */
  createFormSignature: string;
}

export interface CreateFormSignatureVariables {
  submission: string;
  answers: FormAnswer[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EligibilityFormContext
// ====================================================

export interface EligibilityFormContext_submission_interest {
  __typename: "Interest";
  id: string;
  interestListId: string | null;
  userId: string | null;
}

export interface EligibilityFormContext_submission_documents {
  __typename: "Document";
  id: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerText_data {
  __typename: "FormAnswerTextData";
  text: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerText {
  __typename: "FormAnswerText";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerText_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerBoolean_data {
  __typename: "FormAnswerBooleanData";
  boolean: boolean;
}

export interface EligibilityFormContext_submission_presets_FormAnswerBoolean {
  __typename: "FormAnswerBoolean";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerBoolean_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerSelect_data {
  __typename: "FormAnswerSelectData";
  selected: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerSelect {
  __typename: "FormAnswerSelect";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerSelect_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerPhoneNumber_data {
  __typename: "FormAnswerPhoneNumberData";
  raw: string | null;
  parsed: string | null;
  phoneType: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerPhoneNumber {
  __typename: "FormAnswerPhoneNumber";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerPhoneNumber_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerEmail_data {
  __typename: "FormAnswerEmailData";
  email: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerEmail {
  __typename: "FormAnswerEmail";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerEmail_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerDate_data {
  __typename: "FormAnswerDateData";
  date: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerDate {
  __typename: "FormAnswerDate";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerDate_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerUsState_data {
  __typename: "FormAnswerUsStateData";
  state: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerUsState {
  __typename: "FormAnswerUsState";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerUsState_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerAddress_data {
  __typename: "FormAnswerAddressData";
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerAddress {
  __typename: "FormAnswerAddress";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerAddress_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerArray_data {
  __typename: "FormAnswerArrayData";
  keys: string[];
}

export interface EligibilityFormContext_submission_presets_FormAnswerArray {
  __typename: "FormAnswerArray";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerArray_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerMultiple_data {
  __typename: "FormAnswerMultipleData";
  selections: string[];
}

export interface EligibilityFormContext_submission_presets_FormAnswerMultiple {
  __typename: "FormAnswerMultiple";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerMultiple_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerDateRange_data {
  __typename: "FormAnswerDateRangeData";
  startDate: string | null;
  endDate: string | null;
  current: boolean;
}

export interface EligibilityFormContext_submission_presets_FormAnswerDateRange {
  __typename: "FormAnswerDateRange";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerDateRange_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerFaxNumber_data {
  __typename: "FormAnswerFaxNumberData";
  raw: string | null;
  parsed: string | null;
}

export interface EligibilityFormContext_submission_presets_FormAnswerFaxNumber {
  __typename: "FormAnswerFaxNumber";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerFaxNumber_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerHouseholdMember_data {
  __typename: "FormAnswerHouseholdMemberData";
  householdMember: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerHouseholdMember {
  __typename: "FormAnswerHouseholdMember";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerHouseholdMember_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerMoney_data {
  __typename: "FormAnswerMoneyData";
  amount: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerMoney {
  __typename: "FormAnswerMoney";
  identity: string[];
  key: string | null;
  data: EligibilityFormContext_submission_presets_FormAnswerMoney_data;
}

export interface EligibilityFormContext_submission_presets_FormAnswerUpload_documents {
  __typename: "FormAnswerUploadData";
  documentId: string;
  documentName: string;
}

export interface EligibilityFormContext_submission_presets_FormAnswerUpload {
  __typename: "FormAnswerUpload";
  identity: string[];
  key: string | null;
  documents: EligibilityFormContext_submission_presets_FormAnswerUpload_documents[];
}

export type EligibilityFormContext_submission_presets = EligibilityFormContext_submission_presets_FormAnswerText | EligibilityFormContext_submission_presets_FormAnswerBoolean | EligibilityFormContext_submission_presets_FormAnswerSelect | EligibilityFormContext_submission_presets_FormAnswerPhoneNumber | EligibilityFormContext_submission_presets_FormAnswerEmail | EligibilityFormContext_submission_presets_FormAnswerDate | EligibilityFormContext_submission_presets_FormAnswerUsState | EligibilityFormContext_submission_presets_FormAnswerAddress | EligibilityFormContext_submission_presets_FormAnswerArray | EligibilityFormContext_submission_presets_FormAnswerMultiple | EligibilityFormContext_submission_presets_FormAnswerDateRange | EligibilityFormContext_submission_presets_FormAnswerFaxNumber | EligibilityFormContext_submission_presets_FormAnswerHouseholdMember | EligibilityFormContext_submission_presets_FormAnswerMoney | EligibilityFormContext_submission_presets_FormAnswerUpload;

export interface EligibilityFormContext_submission_form_layouts_groups {
  __typename: "FormLayoutGroup";
  name: string;
  title: string;
  description: string;
  questions: string[][];
}

export interface EligibilityFormContext_submission_form_layouts {
  __typename: "FormLayout";
  name: FormLayoutName;
  groups: EligibilityFormContext_submission_form_layouts_groups[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionAddress_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionAddress {
  __typename: "FormQuestionAddress" | "FormQuestionDate" | "FormQuestionEmail" | "FormQuestionFaxNumber" | "FormQuestionHouseholdMember" | "FormQuestionLanguage" | "FormQuestionMoney" | "FormQuestionNumber" | "FormQuestionPhoneNumber" | "FormQuestionUpload" | "FormQuestionUsState";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionAddress_cond | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionArray_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionArray_data {
  __typename: "FormQuestionArrayData";
  label: string;
  children: string[][];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionArray {
  __typename: "FormQuestionArray";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionArray_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionArray_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionDateRange_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionDateRange_data {
  __typename: "FormQuestionDateRangeData";
  label: string;
  allowPresent: boolean | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionDateRange {
  __typename: "FormQuestionDateRange";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionDateRange_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionDateRange_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionMultiple_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionMultiple_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionMultiple_data {
  __typename: "FormQuestionMultipleData";
  options: EligibilityFormContext_submission_form_questions_FormQuestionMultiple_data_options[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionMultiple {
  __typename: "FormQuestionMultiple";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionMultiple_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionMultiple_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionSelect_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionSelect_data_layout {
  __typename: "FormQuestionSelectDataLayout";
  type: string;
  wrap: boolean;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionSelect_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionSelect_data {
  __typename: "FormQuestionSelectData";
  layout: EligibilityFormContext_submission_form_questions_FormQuestionSelect_data_layout | null;
  options: EligibilityFormContext_submission_form_questions_FormQuestionSelect_data_options[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionSelect {
  __typename: "FormQuestionSelect";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionSelect_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionSelect_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionBoolean_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionBoolean_data_custom {
  __typename: "FormQuestionBooleanDataCustom";
  yesText: string | null;
  noText: string | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionBoolean_data {
  __typename: "FormQuestionBooleanData";
  message: string | null;
  custom: EligibilityFormContext_submission_form_questions_FormQuestionBoolean_data_custom | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionBoolean {
  __typename: "FormQuestionBoolean";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionBoolean_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionBoolean_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionText_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionText_data {
  __typename: "FormQuestionTextData";
  placeholder: string | null;
  mask: string | null;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionText {
  __typename: "FormQuestionText";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionText_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionText_data;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionFormatted_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionFormatted_data {
  __typename: "FormQuestionFormattedData";
  content: string;
}

export interface EligibilityFormContext_submission_form_questions_FormQuestionFormatted {
  __typename: "FormQuestionFormatted";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: EligibilityFormContext_submission_form_questions_FormQuestionFormatted_cond | null;
  data: EligibilityFormContext_submission_form_questions_FormQuestionFormatted_data;
}

export type EligibilityFormContext_submission_form_questions = EligibilityFormContext_submission_form_questions_FormQuestionAddress | EligibilityFormContext_submission_form_questions_FormQuestionArray | EligibilityFormContext_submission_form_questions_FormQuestionDateRange | EligibilityFormContext_submission_form_questions_FormQuestionMultiple | EligibilityFormContext_submission_form_questions_FormQuestionSelect | EligibilityFormContext_submission_form_questions_FormQuestionBoolean | EligibilityFormContext_submission_form_questions_FormQuestionText | EligibilityFormContext_submission_form_questions_FormQuestionFormatted;

export interface EligibilityFormContext_submission_form_property {
  __typename: "Property";
  id: string;
  name: string;
  organizationId: string;
  email: string;
  phone: string;
}

export interface EligibilityFormContext_submission_form {
  __typename: "Form";
  id: string;
  type: FormType;
  skipSignature: boolean;
  open: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
  layouts: EligibilityFormContext_submission_form_layouts[];
  questions: EligibilityFormContext_submission_form_questions[];
  property: EligibilityFormContext_submission_form_property;
}

export interface EligibilityFormContext_submission {
  __typename: "Submission";
  id: string;
  interest: EligibilityFormContext_submission_interest | null;
  userId: string | null;
  firstOpenedAt: string | null;
  submittedAt: string | null;
  documents: (EligibilityFormContext_submission_documents | null)[] | null;
  presets: EligibilityFormContext_submission_presets[];
  form: EligibilityFormContext_submission_form;
}

export interface EligibilityFormContext {
  /**
   * Fetch an application submission by it's ID
   */
  submission: EligibilityFormContext_submission | null;
}

export interface EligibilityFormContextVariables {
  submissionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EligibilitySubmissionId
// ====================================================

export interface EligibilitySubmissionId_interest_eligibilitySubmission {
  __typename: "Submission";
  id: string;
}

export interface EligibilitySubmissionId_interest {
  __typename: "Interest";
  id: string;
  eligibilitySubmission: EligibilitySubmissionId_interest_eligibilitySubmission;
}

export interface EligibilitySubmissionId {
  /**
   * Fetch a interest application by it's ID
   */
  interest: EligibilitySubmissionId_interest;
}

export interface EligibilitySubmissionIdVariables {
  interest: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PublicOrganization
// ====================================================

export interface PublicOrganization_publicOrganization {
  __typename: "Organization";
  id: string;
  logoFilename: string | null;
}

export interface PublicOrganization {
  /**
   * Fetch an organization by it's ID (non-supervisor)
   */
  publicOrganization: PublicOrganization_publicOrganization;
}

export interface PublicOrganizationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveEligibilityFormProgress
// ====================================================

export interface SaveEligibilityFormProgress_saveWorkingFormChanges {
  __typename: "Submission";
  id: string;
}

export interface SaveEligibilityFormProgress {
  /**
   * Save working form changes
   */
  saveWorkingFormChanges: SaveEligibilityFormProgress_saveWorkingFormChanges | null;
}

export interface SaveEligibilityFormProgressVariables {
  submissionID: string;
  answers: FormAnswer[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SubmitEligibilityForm
// ====================================================

export interface SubmitEligibilityForm {
  /**
   * Submit a submission
   */
  submitEligibilityForm: string | null;
}

export interface SubmitEligibilityFormVariables {
  submission: string;
  answers: FormAnswer[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackFirstOpening
// ====================================================

export interface TrackFirstOpening_trackFirstOpening_messages {
  __typename: "ValidationMessage";
  /**
   * A unique error code for the type of validation used.
   */
  code: string;
  /**
   * The input field that the error applies to. The field can be used to
   * identify which field the error message should be displayed next to in the
   * presentation layer.
   * 
   * If there are multiple errors to display for a field, multiple validation
   * messages will be in the result.
   * 
   * This field may be null in cases where an error cannot be applied to a specific field.
   */
  field: string | null;
  /**
   * A friendly error message, appropriate for display to the end user.
   * 
   * The message is interpolated to include the appropriate variables.
   * 
   * Example: `Username must be at least 10 characters`
   * 
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  message: string | null;
}

export interface TrackFirstOpening_trackFirstOpening_result {
  __typename: "SuccessfulTracking";
  success: boolean;
}

export interface TrackFirstOpening_trackFirstOpening {
  __typename: "TrackFirstOpeningPayload";
  /**
   * A list of failed validations. May be blank or null if mutation succeeded.
   */
  messages: (TrackFirstOpening_trackFirstOpening_messages | null)[] | null;
  /**
   * The object created/updated/deleted by the mutation. May be null if mutation failed.
   */
  result: TrackFirstOpening_trackFirstOpening_result | null;
}

export interface TrackFirstOpening {
  /**
   * Track first opening of a form.
   */
  trackFirstOpening: TrackFirstOpening_trackFirstOpening;
}

export interface TrackFirstOpeningVariables {
  submissionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: findOrCreateSubmission
// ====================================================

export interface findOrCreateSubmission_findOrCreateSubmission_form_layouts_groups {
  __typename: "FormLayoutGroup";
  name: string;
  title: string;
  description: string;
  questions: string[][];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_layouts {
  __typename: "FormLayout";
  name: FormLayoutName;
  groups: findOrCreateSubmission_findOrCreateSubmission_form_layouts_groups[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionAddress_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionAddress {
  __typename: "FormQuestionAddress" | "FormQuestionDate" | "FormQuestionEmail" | "FormQuestionFaxNumber" | "FormQuestionHouseholdMember" | "FormQuestionLanguage" | "FormQuestionMoney" | "FormQuestionNumber" | "FormQuestionPhoneNumber" | "FormQuestionUpload" | "FormQuestionUsState";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionAddress_cond | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray_data {
  __typename: "FormQuestionArrayData";
  label: string;
  children: string[][];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray {
  __typename: "FormQuestionArray";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange_data {
  __typename: "FormQuestionDateRangeData";
  label: string;
  allowPresent: boolean | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange {
  __typename: "FormQuestionDateRange";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_data {
  __typename: "FormQuestionMultipleData";
  options: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_data_options[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple {
  __typename: "FormQuestionMultiple";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data_layout {
  __typename: "FormQuestionSelectDataLayout";
  type: string;
  wrap: boolean;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data {
  __typename: "FormQuestionSelectData";
  layout: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data_layout | null;
  options: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data_options[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect {
  __typename: "FormQuestionSelect";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_data_custom {
  __typename: "FormQuestionBooleanDataCustom";
  yesText: string | null;
  noText: string | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_data {
  __typename: "FormQuestionBooleanData";
  message: string | null;
  custom: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_data_custom | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean {
  __typename: "FormQuestionBoolean";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText_data {
  __typename: "FormQuestionTextData";
  placeholder: string | null;
  mask: string | null;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText {
  __typename: "FormQuestionText";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText_data;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted_data {
  __typename: "FormQuestionFormattedData";
  content: string;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted {
  __typename: "FormQuestionFormatted";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted_cond | null;
  data: findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted_data;
}

export type findOrCreateSubmission_findOrCreateSubmission_form_questions = findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionAddress | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionArray | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionDateRange | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionMultiple | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionSelect | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionBoolean | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionText | findOrCreateSubmission_findOrCreateSubmission_form_questions_FormQuestionFormatted;

export interface findOrCreateSubmission_findOrCreateSubmission_form_property {
  __typename: "Property";
  id: string;
  name: string;
  organizationId: string;
  email: string;
  phone: string;
}

export interface findOrCreateSubmission_findOrCreateSubmission_form {
  __typename: "Form";
  id: string;
  type: FormType;
  skipSignature: boolean;
  open: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
  layouts: findOrCreateSubmission_findOrCreateSubmission_form_layouts[];
  questions: findOrCreateSubmission_findOrCreateSubmission_form_questions[];
  property: findOrCreateSubmission_findOrCreateSubmission_form_property;
}

export interface findOrCreateSubmission_findOrCreateSubmission {
  __typename: "Submission";
  id: string;
  form: findOrCreateSubmission_findOrCreateSubmission_form;
}

export interface findOrCreateSubmission {
  /**
   * Get or add a submission for a form for a user
   */
  findOrCreateSubmission: findOrCreateSubmission_findOrCreateSubmission;
}

export interface findOrCreateSubmissionVariables {
  formId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getForm
// ====================================================

export interface getForm_form_property_organization {
  __typename: "Organization";
  name: string;
}

export interface getForm_form_property {
  __typename: "Property";
  interestListId: string | null;
  name: string;
  organization: getForm_form_property_organization | null;
}

export interface getForm_form {
  __typename: "Form";
  type: FormType;
  open: boolean;
  property: getForm_form_property;
}

export interface getForm {
  /**
   * Fetch form by id
   */
  form: getForm_form;
}

export interface getFormVariables {
  formId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LinkAppPrefill
// ====================================================

export interface LinkAppPrefill_linkAppPrefill {
  __typename: "LinkAppPrefill";
  firstName: string | null;
  lastName: string | null;
}

export interface LinkAppPrefill {
  /**
   * Fetch the values to prefill a link-application form by the link code
   */
  linkAppPrefill: LinkAppPrefill_linkAppPrefill | null;
}

export interface LinkAppPrefillVariables {
  linkCode: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LinkApp
// ====================================================

export interface LinkApp_linkApp {
  __typename: "LinkAppPayload";
  success: boolean;
}

export interface LinkApp {
  /**
   * Links applications with the given link-code to a user
   */
  linkApp: LinkApp_linkApp | null;
}

export interface LinkAppVariables {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  password: string;
  linkCode: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendResetPasswordEmail
// ====================================================

export interface SendResetPasswordEmail {
  /**
   * Send reset password email to a user
   */
  sendResetPasswordEmail: boolean | null;
}

export interface SendResetPasswordEmailVariables {
  email: string;
  returnUrl?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendEnrollmentEmail
// ====================================================

export interface SendEnrollmentEmail {
  /**
   * Send enrollment email to a user
   */
  sendEnrollmentEmail: boolean | null;
}

export interface SendEnrollmentEmailVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetPassword
// ====================================================

export interface ResetPassword_resetPassword {
  __typename: "UserLoginResponse";
  success: boolean | null;
  token: string | null;
  returnUrl: string | null;
}

export interface ResetPassword {
  /**
   * Reset user password using token
   */
  resetPassword: ResetPassword_resetPassword | null;
}

export interface ResetPasswordVariables {
  token: string;
  password: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: newUserViewer
// ====================================================

export interface newUserViewer_viewer_lists {
  __typename: "ListItem";
  id: string;
  name: string;
}

export interface newUserViewer_viewer {
  __typename: "UserPostgres";
  id: string;
  firstName: string | null;
  lastName: string | null;
  organizationId: string | null;
  email: string | null;
  roles: UserRole[];
  directPhone: string | null;
  title: string | null;
  /**
   * The waitlists a property manager user belongs to
   */
  lists: newUserViewer_viewer_lists[] | null;
}

export interface newUserViewer {
  /**
   * Logged in user
   */
  viewer: newUserViewer_viewer | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updateNewUserForTeam
// ====================================================

export interface updateNewUserForTeam_updateUser {
  __typename: "UserPostgres";
  id: string;
}

export interface updateNewUserForTeam {
  /**
   * Update a user (admin/ supervisor/ team member)
   */
  updateUser: updateNewUserForTeam_updateUser | null;
}

export interface updateNewUserForTeamVariables {
  id: string;
  data: UserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchUserExistance
// ====================================================

export interface FetchUserExistance {
  /**
   * User exists by token
   */
  userExists: boolean | null;
}

export interface FetchUserExistanceVariables {
  token: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: PropertiesPage
// ====================================================

export interface PropertiesPage_propertiesPage_viewerSubmissions {
  __typename: "ViewerSubmission";
  propertyId: string;
  interestId: string | null;
  submissionId: string | null;
  interestListId: string;
  submittedAt: number | null;
  currentStatus: string;
}

export interface PropertiesPage_propertiesPage {
  __typename: "PropertySummary";
  address1: string;
  preAppUrl: string;
  city: string;
  email: string;
  id: string;
  name: string;
  orgName: string;
  phone: string;
  state: string;
  zip: string;
  unitSizes: string[];
  interestCreatingFormType: string | null;
  viewerSubmissions: PropertiesPage_propertiesPage_viewerSubmissions[];
}

export interface PropertiesPage {
  /**
   * Public properties page after whitelabel
   */
  propertiesPage: PropertiesPage_propertiesPage[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: reportQuery
// ====================================================

export interface reportQuery_report {
  __typename: "ReportResult";
  columns: string[];
  footer: string[];
  records: string[][];
}

export interface reportQuery_organization {
  __typename: "Organization";
  id: string;
  asksDobInterestQuestion: boolean;
}

export interface reportQuery {
  report: reportQuery_report;
  /**
   * Fetch an organization by it's ID
   */
  organization: reportQuery_organization;
}

export interface reportQueryVariables {
  name: ReportName;
  dateStart?: number | null;
  dateEnd?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ReportSidebarQuery
// ====================================================

export interface ReportSidebarQuery_organization {
  __typename: "Organization";
  id: string;
  asksDobInterestQuestion: boolean;
}

export interface ReportSidebarQuery {
  /**
   * Fetch an organization by it's ID
   */
  organization: ReportSidebarQuery_organization;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getListsByOrg
// ====================================================

export interface getListsByOrg_organization_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
}

export interface getListsByOrg_organization {
  __typename: "Organization";
  id: string;
  interestLists: getListsByOrg_organization_interestLists[];
}

export interface getListsByOrg {
  /**
   * Fetch an organization by it's ID
   */
  organization: getListsByOrg_organization;
}

export interface getListsByOrgVariables {
  orgId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WaitlistUpdateMetadata
// ====================================================

export interface WaitlistUpdateMetadata_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
  begins: string;
  ends: string;
}

export interface WaitlistUpdateMetadata_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  scheduledUpdate: WaitlistUpdateMetadata_interestList_scheduledUpdate;
}

export interface WaitlistUpdateMetadata {
  /**
   * Interest List
   */
  interestList: WaitlistUpdateMetadata_interestList;
}

export interface WaitlistUpdateMetadataVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WaitlistUpdateQuery
// ====================================================

export interface WaitlistUpdateQuery_interestList_scheduledUpdate_requested_results {
  __typename: "WaitlistUpdateRequest";
  name: string | null;
  phone: string | null;
  respondedAt: string | null;
  status: WaitlistUpdateRequestStatus;
  interestId: string;
}

export interface WaitlistUpdateQuery_interestList_scheduledUpdate_requested {
  __typename: "WaitlistUpdateRequestQuery";
  totalCount: number;
  results: WaitlistUpdateQuery_interestList_scheduledUpdate_requested_results[];
}

export interface WaitlistUpdateQuery_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
  begins: string;
  ends: string;
  requested: WaitlistUpdateQuery_interestList_scheduledUpdate_requested;
}

export interface WaitlistUpdateQuery_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  scheduledUpdate: WaitlistUpdateQuery_interestList_scheduledUpdate;
}

export interface WaitlistUpdateQuery {
  /**
   * Interest List
   */
  interestList: WaitlistUpdateQuery_interestList;
}

export interface WaitlistUpdateQueryVariables {
  id: string;
  statuses?: (WaitlistUpdateRequestStatus | null)[] | null;
  limit: number;
  offset: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RequestedCounts
// ====================================================

export interface RequestedCounts_interestList_scheduledUpdate_requestedCounts {
  __typename: "WaitlistUpdateRequestCount";
  status: WaitlistUpdateRequestStatus;
  totalCount: number;
}

export interface RequestedCounts_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  requestedCounts: RequestedCounts_interestList_scheduledUpdate_requestedCounts[];
}

export interface RequestedCounts_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  scheduledUpdate: RequestedCounts_interestList_scheduledUpdate;
}

export interface RequestedCounts {
  /**
   * Interest List
   */
  interestList: RequestedCounts_interestList;
}

export interface RequestedCountsVariables {
  id: string;
  statuses?: (WaitlistUpdateRequestStatus | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WaitlistUpdatesEnabled
// ====================================================

export interface WaitlistUpdatesEnabled_organization_interestLists_scheduledUpdate {
  __typename: "WaitlistUpdate";
  enabled: boolean;
}

export interface WaitlistUpdatesEnabled_organization_interestLists {
  __typename: "InterestList";
  id: string;
  name: string;
  type: string | null;
  scheduledUpdate: WaitlistUpdatesEnabled_organization_interestLists_scheduledUpdate;
}

export interface WaitlistUpdatesEnabled_organization {
  __typename: "Organization";
  interestLists: WaitlistUpdatesEnabled_organization_interestLists[];
}

export interface WaitlistUpdatesEnabled {
  /**
   * Fetch an organization by it's ID
   */
  organization: WaitlistUpdatesEnabled_organization;
}

export interface WaitlistUpdatesEnabledVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchManualContactsView
// ====================================================

export interface FetchManualContactsView_interestList_scheduledUpdate_manualContacts_results_phones {
  __typename: "LabelledPhone";
  label: string;
  number: string;
  type: string;
  ext: string | null;
  enabled: boolean | null;
}

export interface FetchManualContactsView_interestList_scheduledUpdate_manualContacts_results {
  __typename: "WaitlistUpdateRequest";
  name: string | null;
  phones: FetchManualContactsView_interestList_scheduledUpdate_manualContacts_results_phones[];
  respondedAt: string | null;
  status: WaitlistUpdateRequestStatus;
  interestId: string;
}

export interface FetchManualContactsView_interestList_scheduledUpdate_manualContacts {
  __typename: "WaitlistUpdateRequestQuery";
  totalCount: number;
  results: FetchManualContactsView_interestList_scheduledUpdate_manualContacts_results[];
}

export interface FetchManualContactsView_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  begins: string;
  ends: string;
  manualContacts: FetchManualContactsView_interestList_scheduledUpdate_manualContacts;
}

export interface FetchManualContactsView_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  scheduledUpdate: FetchManualContactsView_interestList_scheduledUpdate;
}

export interface FetchManualContactsView {
  /**
   * Interest List
   */
  interestList: FetchManualContactsView_interestList;
}

export interface FetchManualContactsViewVariables {
  id: string;
  limit: number;
  offset: number;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveManualContactActivity
// ====================================================

export interface SaveManualContactActivity_createActivity {
  __typename: "Activity";
  id: string | null;
}

export interface SaveManualContactActivity {
  /**
   * Create an Activity
   */
  createActivity: SaveManualContactActivity_createActivity;
}

export interface SaveManualContactActivityVariables {
  activity: ActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveAsManuallyContactedWithActivity
// ====================================================

export interface SaveAsManuallyContactedWithActivity_createActivity {
  __typename: "Activity";
  id: string | null;
}

export interface SaveAsManuallyContactedWithActivity {
  /**
   * Create an Activity
   */
  createActivity: SaveAsManuallyContactedWithActivity_createActivity;
  /**
   * Excludes an applicant from pending removals
   */
  manuallyContacted: boolean;
}

export interface SaveAsManuallyContactedWithActivityVariables {
  interest: string;
  activity: ActivityInput;
  data: FormUpdate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveAsManuallyContactedWithoutActivity
// ====================================================

export interface SaveAsManuallyContactedWithoutActivity {
  /**
   * Excludes an applicant from pending removals
   */
  manuallyContacted: boolean;
}

export interface SaveAsManuallyContactedWithoutActivityVariables {
  interest: string;
  data: FormUpdate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveApplicantFromListWithActivity
// ====================================================

export interface RemoveApplicantFromListWithActivity_createActivity {
  __typename: "Activity";
  id: string | null;
}

export interface RemoveApplicantFromListWithActivity {
  /**
   * Create an Activity
   */
  createActivity: RemoveApplicantFromListWithActivity_createActivity;
  /**
   * Change the status of an interest
   */
  changeInterestStatus: string | null;
}

export interface RemoveApplicantFromListWithActivityVariables {
  interest: string;
  reason: string;
  activity: ActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveApplicantFromList
// ====================================================

export interface RemoveApplicantFromList {
  /**
   * Change the status of an interest
   */
  changeInterestStatus: string | null;
}

export interface RemoveApplicantFromListVariables {
  interest: string;
  reason: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TemplatesWithPreview
// ====================================================

export interface TemplatesWithPreview_template {
  __typename: "Template";
  id: string;
  name: string | null;
  renderedHtml: string | null;
}

export interface TemplatesWithPreview {
  /**
   * Templates by id
   */
  template: TemplatesWithPreview_template | null;
}

export interface TemplatesWithPreviewVariables {
  templateId: string;
  interestId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ProcessRemovalsView
// ====================================================

export interface ProcessRemovalsView_templates {
  __typename: "Template";
  id: string;
  name: string | null;
  type: TemplateType;
  isOrgTemplate: boolean | null;
  body: string;
}

export interface ProcessRemovalsView_interestList_scheduledUpdate_removals_results {
  __typename: "WaitlistUpdateRequest";
  name: string | null;
  phone: string | null;
  respondedAt: string | null;
  status: WaitlistUpdateRequestStatus;
  interestId: string;
}

export interface ProcessRemovalsView_interestList_scheduledUpdate_removals {
  __typename: "WaitlistUpdateRequestQuery";
  totalCount: number;
  results: ProcessRemovalsView_interestList_scheduledUpdate_removals_results[];
}

export interface ProcessRemovalsView_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  begins: string;
  ends: string;
  removals: ProcessRemovalsView_interestList_scheduledUpdate_removals;
}

export interface ProcessRemovalsView_interestList {
  __typename: "InterestList";
  id: string;
  name: string;
  scheduledUpdate: ProcessRemovalsView_interestList_scheduledUpdate;
}

export interface ProcessRemovalsView {
  /**
   * Templates for letters/sms/emails
   */
  templates: ProcessRemovalsView_templates[];
  /**
   * Interest List
   */
  interestList: ProcessRemovalsView_interestList;
}

export interface ProcessRemovalsViewVariables {
  list: string;
  limit: number;
  offset: number;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProcessRemovals
// ====================================================

export interface ProcessRemovals {
  /**
   * Process the result of a waitlist update
   */
  processWaitlistUpdate: boolean | null;
}

export interface ProcessRemovalsVariables {
  interestList: string;
  templateGroupId: string;
  emailEnabled: boolean;
  letterEnabled: boolean;
  smsEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RemovalsTracking
// ====================================================

export interface RemovalsTracking_removalsTracking {
  __typename: "WaitlistUpdateRemovalsTracking";
  percentComplete: number;
}

export interface RemovalsTracking_interestList_scheduledUpdate_removals {
  __typename: "WaitlistUpdateRequestQuery";
  totalCount: number;
}

export interface RemovalsTracking_interestList_scheduledUpdate {
  __typename: "WaitlistUpdate";
  removals: RemovalsTracking_interestList_scheduledUpdate_removals;
}

export interface RemovalsTracking_interestList {
  __typename: "InterestList";
  id: string;
  scheduledUpdate: RemovalsTracking_interestList_scheduledUpdate;
}

export interface RemovalsTracking {
  removalsTracking: RemovalsTracking_removalsTracking | null;
  /**
   * Interest List
   */
  interestList: RemovalsTracking_interestList;
}

export interface RemovalsTrackingVariables {
  interestListId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ManuallyContacted
// ====================================================

export interface ManuallyContacted {
  /**
   * Excludes an applicant from pending removals
   */
  manuallyContacted: boolean;
}

export interface ManuallyContactedVariables {
  interest: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SubmitUpdateRequest
// ====================================================

export interface SubmitUpdateRequest_submitWaitlistUpdate {
  __typename: "UpdateRequest";
  code: string;
}

export interface SubmitUpdateRequest {
  /**
   * Submit applicant waitlist update
   */
  submitWaitlistUpdate: SubmitUpdateRequest_submitWaitlistUpdate | null;
}

export interface SubmitUpdateRequestVariables {
  code: string;
  data: FormUpdate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UpdateRequest
// ====================================================

export interface UpdateRequest_updateRequest_interests_status {
  __typename: "InterestStatus";
  name: string;
  changedAt: string | null;
}

export interface UpdateRequest_updateRequest_interests_interestList_address {
  __typename: "Address";
  city: string;
  state: string;
}

export interface UpdateRequest_updateRequest_interests_interestList {
  __typename: "InterestList";
  email: string | null;
  name: string;
  address: UpdateRequest_updateRequest_interests_interestList_address;
  waitTime: string;
}

export interface UpdateRequest_updateRequest_interests {
  __typename: "Interest";
  id: string;
  userId: string | null;
  status: UpdateRequest_updateRequest_interests_status;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  interestListName: string;
  interestList: UpdateRequest_updateRequest_interests_interestList;
}

export interface UpdateRequest_updateRequest {
  __typename: "UpdateRequest";
  code: string;
  isActive: boolean;
  isComplete: boolean;
  interests: UpdateRequest_updateRequest_interests[];
}

export interface UpdateRequest {
  /**
   * Update request
   */
  updateRequest: UpdateRequest_updateRequest | null;
}

export interface UpdateRequestVariables {
  code: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BuildingUnitFragment
// ====================================================

export interface BuildingUnitFragment {
  __typename: "BuildingUnit";
  id: string;
  name: string;
  bedrooms: string;
  bathrooms: number;
  occupancyMin: number;
  occupancyMax: number;
  rentType: string;
  rentValue: number;
  sqft: number;
  floor: number;
  occupied: string;
  isReferral: boolean;
  referralOrg: string | null;
  accessibility: string[];
  buildingId: string;
  fundingSource: string[];
  incomeDesignation: string;
  preference: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormAnswerData
// ====================================================

export interface FormAnswerData_FormAnswerText_data {
  __typename: "FormAnswerTextData";
  text: string;
}

export interface FormAnswerData_FormAnswerText {
  __typename: "FormAnswerText";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerText_data;
}

export interface FormAnswerData_FormAnswerBoolean_data {
  __typename: "FormAnswerBooleanData";
  boolean: boolean;
}

export interface FormAnswerData_FormAnswerBoolean {
  __typename: "FormAnswerBoolean";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerBoolean_data;
}

export interface FormAnswerData_FormAnswerSelect_data {
  __typename: "FormAnswerSelectData";
  selected: string;
}

export interface FormAnswerData_FormAnswerSelect {
  __typename: "FormAnswerSelect";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerSelect_data;
}

export interface FormAnswerData_FormAnswerPhoneNumber_data {
  __typename: "FormAnswerPhoneNumberData";
  raw: string | null;
  parsed: string | null;
  phoneType: string;
}

export interface FormAnswerData_FormAnswerPhoneNumber {
  __typename: "FormAnswerPhoneNumber";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerPhoneNumber_data;
}

export interface FormAnswerData_FormAnswerEmail_data {
  __typename: "FormAnswerEmailData";
  email: string;
}

export interface FormAnswerData_FormAnswerEmail {
  __typename: "FormAnswerEmail";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerEmail_data;
}

export interface FormAnswerData_FormAnswerDate_data {
  __typename: "FormAnswerDateData";
  date: string;
}

export interface FormAnswerData_FormAnswerDate {
  __typename: "FormAnswerDate";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerDate_data;
}

export interface FormAnswerData_FormAnswerUsState_data {
  __typename: "FormAnswerUsStateData";
  state: string;
}

export interface FormAnswerData_FormAnswerUsState {
  __typename: "FormAnswerUsState";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerUsState_data;
}

export interface FormAnswerData_FormAnswerAddress_data {
  __typename: "FormAnswerAddressData";
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface FormAnswerData_FormAnswerAddress {
  __typename: "FormAnswerAddress";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerAddress_data;
}

export interface FormAnswerData_FormAnswerArray_data {
  __typename: "FormAnswerArrayData";
  keys: string[];
}

export interface FormAnswerData_FormAnswerArray {
  __typename: "FormAnswerArray";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerArray_data;
}

export interface FormAnswerData_FormAnswerMultiple_data {
  __typename: "FormAnswerMultipleData";
  selections: string[];
}

export interface FormAnswerData_FormAnswerMultiple {
  __typename: "FormAnswerMultiple";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerMultiple_data;
}

export interface FormAnswerData_FormAnswerDateRange_data {
  __typename: "FormAnswerDateRangeData";
  startDate: string | null;
  endDate: string | null;
  current: boolean;
}

export interface FormAnswerData_FormAnswerDateRange {
  __typename: "FormAnswerDateRange";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerDateRange_data;
}

export interface FormAnswerData_FormAnswerFaxNumber_data {
  __typename: "FormAnswerFaxNumberData";
  raw: string | null;
  parsed: string | null;
}

export interface FormAnswerData_FormAnswerFaxNumber {
  __typename: "FormAnswerFaxNumber";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerFaxNumber_data;
}

export interface FormAnswerData_FormAnswerHouseholdMember_data {
  __typename: "FormAnswerHouseholdMemberData";
  householdMember: string;
}

export interface FormAnswerData_FormAnswerHouseholdMember {
  __typename: "FormAnswerHouseholdMember";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerHouseholdMember_data;
}

export interface FormAnswerData_FormAnswerMoney_data {
  __typename: "FormAnswerMoneyData";
  amount: string;
}

export interface FormAnswerData_FormAnswerMoney {
  __typename: "FormAnswerMoney";
  identity: string[];
  key: string | null;
  data: FormAnswerData_FormAnswerMoney_data;
}

export interface FormAnswerData_FormAnswerUpload_documents {
  __typename: "FormAnswerUploadData";
  documentId: string;
  documentName: string;
}

export interface FormAnswerData_FormAnswerUpload {
  __typename: "FormAnswerUpload";
  identity: string[];
  key: string | null;
  documents: FormAnswerData_FormAnswerUpload_documents[];
}

export type FormAnswerData = FormAnswerData_FormAnswerText | FormAnswerData_FormAnswerBoolean | FormAnswerData_FormAnswerSelect | FormAnswerData_FormAnswerPhoneNumber | FormAnswerData_FormAnswerEmail | FormAnswerData_FormAnswerDate | FormAnswerData_FormAnswerUsState | FormAnswerData_FormAnswerAddress | FormAnswerData_FormAnswerArray | FormAnswerData_FormAnswerMultiple | FormAnswerData_FormAnswerDateRange | FormAnswerData_FormAnswerFaxNumber | FormAnswerData_FormAnswerHouseholdMember | FormAnswerData_FormAnswerMoney | FormAnswerData_FormAnswerUpload;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormQuestionData
// ====================================================

export interface FormQuestionData_FormQuestionAddress_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionAddress {
  __typename: "FormQuestionAddress" | "FormQuestionDate" | "FormQuestionEmail" | "FormQuestionFaxNumber" | "FormQuestionHouseholdMember" | "FormQuestionLanguage" | "FormQuestionMoney" | "FormQuestionNumber" | "FormQuestionPhoneNumber" | "FormQuestionUpload" | "FormQuestionUsState";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionAddress_cond | null;
}

export interface FormQuestionData_FormQuestionArray_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionArray_data {
  __typename: "FormQuestionArrayData";
  label: string;
  children: string[][];
}

export interface FormQuestionData_FormQuestionArray {
  __typename: "FormQuestionArray";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionArray_cond | null;
  data: FormQuestionData_FormQuestionArray_data;
}

export interface FormQuestionData_FormQuestionDateRange_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionDateRange_data {
  __typename: "FormQuestionDateRangeData";
  label: string;
  allowPresent: boolean | null;
}

export interface FormQuestionData_FormQuestionDateRange {
  __typename: "FormQuestionDateRange";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionDateRange_cond | null;
  data: FormQuestionData_FormQuestionDateRange_data;
}

export interface FormQuestionData_FormQuestionMultiple_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionMultiple_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface FormQuestionData_FormQuestionMultiple_data {
  __typename: "FormQuestionMultipleData";
  options: FormQuestionData_FormQuestionMultiple_data_options[];
}

export interface FormQuestionData_FormQuestionMultiple {
  __typename: "FormQuestionMultiple";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionMultiple_cond | null;
  data: FormQuestionData_FormQuestionMultiple_data;
}

export interface FormQuestionData_FormQuestionSelect_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionSelect_data_layout {
  __typename: "FormQuestionSelectDataLayout";
  type: string;
  wrap: boolean;
}

export interface FormQuestionData_FormQuestionSelect_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface FormQuestionData_FormQuestionSelect_data {
  __typename: "FormQuestionSelectData";
  layout: FormQuestionData_FormQuestionSelect_data_layout | null;
  options: FormQuestionData_FormQuestionSelect_data_options[];
}

export interface FormQuestionData_FormQuestionSelect {
  __typename: "FormQuestionSelect";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionSelect_cond | null;
  data: FormQuestionData_FormQuestionSelect_data;
}

export interface FormQuestionData_FormQuestionBoolean_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionBoolean_data_custom {
  __typename: "FormQuestionBooleanDataCustom";
  yesText: string | null;
  noText: string | null;
}

export interface FormQuestionData_FormQuestionBoolean_data {
  __typename: "FormQuestionBooleanData";
  message: string | null;
  custom: FormQuestionData_FormQuestionBoolean_data_custom | null;
}

export interface FormQuestionData_FormQuestionBoolean {
  __typename: "FormQuestionBoolean";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionBoolean_cond | null;
  data: FormQuestionData_FormQuestionBoolean_data;
}

export interface FormQuestionData_FormQuestionText_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionText_data {
  __typename: "FormQuestionTextData";
  placeholder: string | null;
  mask: string | null;
}

export interface FormQuestionData_FormQuestionText {
  __typename: "FormQuestionText";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionText_cond | null;
  data: FormQuestionData_FormQuestionText_data;
}

export interface FormQuestionData_FormQuestionFormatted_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormQuestionData_FormQuestionFormatted_data {
  __typename: "FormQuestionFormattedData";
  content: string;
}

export interface FormQuestionData_FormQuestionFormatted {
  __typename: "FormQuestionFormatted";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormQuestionData_FormQuestionFormatted_cond | null;
  data: FormQuestionData_FormQuestionFormatted_data;
}

export type FormQuestionData = FormQuestionData_FormQuestionAddress | FormQuestionData_FormQuestionArray | FormQuestionData_FormQuestionDateRange | FormQuestionData_FormQuestionMultiple | FormQuestionData_FormQuestionSelect | FormQuestionData_FormQuestionBoolean | FormQuestionData_FormQuestionText | FormQuestionData_FormQuestionFormatted;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormData
// ====================================================

export interface FormData_layouts_groups {
  __typename: "FormLayoutGroup";
  name: string;
  title: string;
  description: string;
  questions: string[][];
}

export interface FormData_layouts {
  __typename: "FormLayout";
  name: FormLayoutName;
  groups: FormData_layouts_groups[];
}

export interface FormData_questions_FormQuestionAddress_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionAddress {
  __typename: "FormQuestionAddress" | "FormQuestionDate" | "FormQuestionEmail" | "FormQuestionFaxNumber" | "FormQuestionHouseholdMember" | "FormQuestionLanguage" | "FormQuestionMoney" | "FormQuestionNumber" | "FormQuestionPhoneNumber" | "FormQuestionUpload" | "FormQuestionUsState";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionAddress_cond | null;
}

export interface FormData_questions_FormQuestionArray_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionArray_data {
  __typename: "FormQuestionArrayData";
  label: string;
  children: string[][];
}

export interface FormData_questions_FormQuestionArray {
  __typename: "FormQuestionArray";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionArray_cond | null;
  data: FormData_questions_FormQuestionArray_data;
}

export interface FormData_questions_FormQuestionDateRange_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionDateRange_data {
  __typename: "FormQuestionDateRangeData";
  label: string;
  allowPresent: boolean | null;
}

export interface FormData_questions_FormQuestionDateRange {
  __typename: "FormQuestionDateRange";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionDateRange_cond | null;
  data: FormData_questions_FormQuestionDateRange_data;
}

export interface FormData_questions_FormQuestionMultiple_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionMultiple_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface FormData_questions_FormQuestionMultiple_data {
  __typename: "FormQuestionMultipleData";
  options: FormData_questions_FormQuestionMultiple_data_options[];
}

export interface FormData_questions_FormQuestionMultiple {
  __typename: "FormQuestionMultiple";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionMultiple_cond | null;
  data: FormData_questions_FormQuestionMultiple_data;
}

export interface FormData_questions_FormQuestionSelect_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionSelect_data_layout {
  __typename: "FormQuestionSelectDataLayout";
  type: string;
  wrap: boolean;
}

export interface FormData_questions_FormQuestionSelect_data_options {
  __typename: "FormQuestionSelectOption";
  label: string;
  value: string;
  children: string[][] | null;
}

export interface FormData_questions_FormQuestionSelect_data {
  __typename: "FormQuestionSelectData";
  layout: FormData_questions_FormQuestionSelect_data_layout | null;
  options: FormData_questions_FormQuestionSelect_data_options[];
}

export interface FormData_questions_FormQuestionSelect {
  __typename: "FormQuestionSelect";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionSelect_cond | null;
  data: FormData_questions_FormQuestionSelect_data;
}

export interface FormData_questions_FormQuestionBoolean_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionBoolean_data_custom {
  __typename: "FormQuestionBooleanDataCustom";
  yesText: string | null;
  noText: string | null;
}

export interface FormData_questions_FormQuestionBoolean_data {
  __typename: "FormQuestionBooleanData";
  message: string | null;
  custom: FormData_questions_FormQuestionBoolean_data_custom | null;
}

export interface FormData_questions_FormQuestionBoolean {
  __typename: "FormQuestionBoolean";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionBoolean_cond | null;
  data: FormData_questions_FormQuestionBoolean_data;
}

export interface FormData_questions_FormQuestionText_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionText_data {
  __typename: "FormQuestionTextData";
  placeholder: string | null;
  mask: string | null;
}

export interface FormData_questions_FormQuestionText {
  __typename: "FormQuestionText";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionText_cond | null;
  data: FormData_questions_FormQuestionText_data;
}

export interface FormData_questions_FormQuestionFormatted_cond {
  __typename: "FormQuestionCondition";
  type: string;
  values: string[];
}

export interface FormData_questions_FormQuestionFormatted_data {
  __typename: "FormQuestionFormattedData";
  content: string;
}

export interface FormData_questions_FormQuestionFormatted {
  __typename: "FormQuestionFormatted";
  identity: string[];
  title: string;
  required: boolean;
  children: string[][];
  cond: FormData_questions_FormQuestionFormatted_cond | null;
  data: FormData_questions_FormQuestionFormatted_data;
}

export type FormData_questions = FormData_questions_FormQuestionAddress | FormData_questions_FormQuestionArray | FormData_questions_FormQuestionDateRange | FormData_questions_FormQuestionMultiple | FormData_questions_FormQuestionSelect | FormData_questions_FormQuestionBoolean | FormData_questions_FormQuestionText | FormData_questions_FormQuestionFormatted;

export interface FormData_property {
  __typename: "Property";
  id: string;
  name: string;
  organizationId: string;
  email: string;
  phone: string;
}

export interface FormData {
  __typename: "Form";
  id: string;
  type: FormType;
  skipSignature: boolean;
  open: boolean;
  ageRequirement: number | null;
  ageRequirementOrDisabilityOverride: boolean | null;
  layouts: FormData_layouts[];
  questions: FormData_questions[];
  property: FormData_property;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InterestAllFields
// ====================================================

export interface InterestAllFields {
  __typename: "Interest";
  id: string;
  signatureId: string | null;
  insertedAt: string | null;
  submittedAt: number | null;
  submittedAtRel: string | null;
  updatedAt: string | null;
  mailingAddressType: string | null;
  residenceAddress1: string | null;
  residenceSteNumber: string | null;
  residenceCity: string | null;
  residenceState: string | null;
  residenceZip: string | null;
  mailingAddress1: string | null;
  mailingSteNumber: string | null;
  mailingCity: string | null;
  mailingState: string | null;
  mailingZip: string | null;
  householdCount: any | null;
  householdMember0FirstName: string | null;
  householdMember0LastName: string | null;
  householdMember0Email: string | null;
  agreeToOrgTerms: boolean | null;
  applicantPreferedContactType: string | null;
  householdMember1RelationToApp: string | null;
  householdMember2RelationToApp: string | null;
  householdMember3RelationToApp: string | null;
  householdMember4RelationToApp: string | null;
  householdMember5RelationToApp: string | null;
  householdMember0Gender: string | null;
  householdMember1Gender: string | null;
  householdMember2Gender: string | null;
  householdMember3Gender: string | null;
  householdMember4Gender: string | null;
  householdMember5Gender: string | null;
  householdMember0NoDob: boolean | null;
  householdMember1NoDob: boolean | null;
  householdMember2NoDob: boolean | null;
  householdMember3NoDob: boolean | null;
  householdMember4NoDob: boolean | null;
  householdMember5NoDob: boolean | null;
  householdMember0PrimaryPhone: string | null;
  householdMember1PrimaryPhone: string | null;
  householdMember2PrimaryPhone: string | null;
  householdMember3PrimaryPhone: string | null;
  householdMember4PrimaryPhone: string | null;
  householdMember5PrimaryPhone: string | null;
  householdMember0PrimaryPhoneType: string | null;
  householdMember1PrimaryPhoneType: string | null;
  householdMember2PrimaryPhoneType: string | null;
  householdMember3PrimaryPhoneType: string | null;
  householdMember4PrimaryPhoneType: string | null;
  householdMember5PrimaryPhoneType: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember1PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember2PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember3PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember4PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember5PrimaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0SecondaryPhone: string | null;
  householdMember0SecondaryPhoneType: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage: boolean | null;
  householdMember0NoPrimaryPhone: boolean | null;
  householdMember1NoPrimaryPhone: boolean | null;
  householdMember2NoPrimaryPhone: boolean | null;
  householdMember3NoPrimaryPhone: boolean | null;
  householdMember4NoPrimaryPhone: boolean | null;
  householdMember5NoPrimaryPhone: boolean | null;
  householdMember0NoEmail: boolean | null;
  householdMember1NoEmail: boolean | null;
  householdMember2NoEmail: boolean | null;
  householdMember3NoEmail: boolean | null;
  householdMember4NoEmail: boolean | null;
  householdMember5NoEmail: boolean | null;
  householdMember0StudentType: string | null;
  householdMember1StudentType: string | null;
  householdMember2StudentType: string | null;
  householdMember3StudentType: string | null;
  householdMember4StudentType: string | null;
  householdMember5StudentType: string | null;
  householdMember0Occupation: string | null;
  householdMember1Occupation: string | null;
  householdMember2Occupation: string | null;
  householdMember3Occupation: string | null;
  householdMember4Occupation: string | null;
  householdMember5Occupation: string | null;
  householdMember0IsDisabled: boolean | null;
  householdMember1IsDisabled: boolean | null;
  householdMember2IsDisabled: boolean | null;
  householdMember3IsDisabled: boolean | null;
  householdMember4IsDisabled: boolean | null;
  householdMember5IsDisabled: boolean | null;
  householdMember0Dob: any | null;
  householdMember1FirstName: string | null;
  householdMember1LastName: string | null;
  householdMember1Email: string | null;
  householdMember1Dob: any | null;
  householdMember2FirstName: string | null;
  householdMember2LastName: string | null;
  householdMember2Email: string | null;
  householdMember2Dob: any | null;
  householdMember3FirstName: string | null;
  householdMember3LastName: string | null;
  householdMember3Email: string | null;
  householdMember3Dob: any | null;
  householdMember4FirstName: string | null;
  householdMember4LastName: string | null;
  householdMember4Email: string | null;
  householdMember4Dob: any | null;
  householdMember5FirstName: string | null;
  householdMember5LastName: string | null;
  householdMember5Email: string | null;
  householdMember5Dob: any | null;
  householdGrossAnnualIncome: number | null;
  householdIsSelfEmployed: boolean | null;
  householdIsEmployed: boolean | null;
  householdIsReceivingUnemployment: boolean | null;
  householdIsReceivingVetIncome: boolean | null;
  householdIsReceivingSocialSecurity: boolean | null;
  householdIsReceivingGifts: boolean | null;
  householdIsReceivingPeriodicPayments: boolean | null;
  householdIsReceivingSsi: boolean | null;
  householdIsReceivingDisabilityBenefits: boolean | null;
  householdIsReceivingPublicAssistanceIncome: boolean | null;
  householdIsReceivingChildSupport: boolean | null;
  householdIsEntitledToChildSupport: boolean | null;
  householdIsReceivingAlimony: boolean | null;
  householdIsReceivingPropertyIncome: boolean | null;
  householdIsReceivingNonLoanFinancialAid: boolean | null;
  householdIsReceivingWorkersComp: boolean | null;
  householdIsReceivingPension: boolean | null;
  householdIsReceivingIncomeNotListed: boolean | null;
  householdMember0NetSelfIncome0: any | null;
  householdMember0NetSelfIncome1: any | null;
  householdMember0NetSelfIncome2: any | null;
  householdMember1NetSelfIncome0: any | null;
  householdMember1NetSelfIncome1: any | null;
  householdMember1NetSelfIncome2: any | null;
  householdMember2NetSelfIncome0: any | null;
  householdMember2NetSelfIncome1: any | null;
  householdMember2NetSelfIncome2: any | null;
  householdMember3NetSelfIncome0: any | null;
  householdMember3NetSelfIncome1: any | null;
  householdMember3NetSelfIncome2: any | null;
  householdMember4NetSelfIncome0: any | null;
  householdMember4NetSelfIncome1: any | null;
  householdMember4NetSelfIncome2: any | null;
  householdMember5NetSelfIncome0: any | null;
  householdMember5NetSelfIncome1: any | null;
  householdMember5NetSelfIncome2: any | null;
  householdMember0Employer0Name: string | null;
  householdMember0Employer1Name: string | null;
  householdMember0Employer2Name: string | null;
  householdMember1Employer0Name: string | null;
  householdMember1Employer1Name: string | null;
  householdMember1Employer2Name: string | null;
  householdMember2Employer0Name: string | null;
  householdMember2Employer1Name: string | null;
  householdMember2Employer2Name: string | null;
  householdMember3Employer0Name: string | null;
  householdMember3Employer1Name: string | null;
  householdMember3Employer2Name: string | null;
  householdMember4Employer0Name: string | null;
  householdMember4Employer1Name: string | null;
  householdMember4Employer2Name: string | null;
  householdMember5Employer0Name: string | null;
  householdMember5Employer1Name: string | null;
  householdMember5Employer2Name: string | null;
  householdMember0Employer0Address: string | null;
  householdMember0Employer1Address: string | null;
  householdMember0Employer2Address: string | null;
  householdMember1Employer0Address: string | null;
  householdMember1Employer1Address: string | null;
  householdMember1Employer2Address: string | null;
  householdMember2Employer0Address: string | null;
  householdMember2Employer1Address: string | null;
  householdMember2Employer2Address: string | null;
  householdMember3Employer0Address: string | null;
  householdMember3Employer1Address: string | null;
  householdMember3Employer2Address: string | null;
  householdMember4Employer0Address: string | null;
  householdMember4Employer1Address: string | null;
  householdMember4Employer2Address: string | null;
  householdMember5Employer0Address: string | null;
  householdMember5Employer1Address: string | null;
  householdMember5Employer2Address: string | null;
  householdMember0Employer0GrossAnnualIncome: any | null;
  householdMember0Employer1GrossAnnualIncome: any | null;
  householdMember0Employer2GrossAnnualIncome: any | null;
  householdMember1Employer0GrossAnnualIncome: any | null;
  householdMember1Employer1GrossAnnualIncome: any | null;
  householdMember1Employer2GrossAnnualIncome: any | null;
  householdMember2Employer0GrossAnnualIncome: any | null;
  householdMember2Employer1GrossAnnualIncome: any | null;
  householdMember2Employer2GrossAnnualIncome: any | null;
  householdMember3Employer0GrossAnnualIncome: any | null;
  householdMember3Employer1GrossAnnualIncome: any | null;
  householdMember3Employer2GrossAnnualIncome: any | null;
  householdMember4Employer0GrossAnnualIncome: any | null;
  householdMember4Employer1GrossAnnualIncome: any | null;
  householdMember4Employer2GrossAnnualIncome: any | null;
  householdMember5Employer0GrossAnnualIncome: any | null;
  householdMember5Employer1GrossAnnualIncome: any | null;
  householdMember5Employer2GrossAnnualIncome: any | null;
  householdMember0Employer0YearsAtJob: string | null;
  householdMember0Employer1YearsAtJob: string | null;
  householdMember0Employer2YearsAtJob: string | null;
  householdMember1Employer0YearsAtJob: string | null;
  householdMember1Employer1YearsAtJob: string | null;
  householdMember1Employer2YearsAtJob: string | null;
  householdMember2Employer0YearsAtJob: string | null;
  householdMember2Employer1YearsAtJob: string | null;
  householdMember2Employer2YearsAtJob: string | null;
  householdMember3Employer0YearsAtJob: string | null;
  householdMember3Employer1YearsAtJob: string | null;
  householdMember3Employer2YearsAtJob: string | null;
  householdMember4Employer0YearsAtJob: string | null;
  householdMember4Employer1YearsAtJob: string | null;
  householdMember4Employer2YearsAtJob: string | null;
  householdMember5Employer0YearsAtJob: string | null;
  householdMember5Employer1YearsAtJob: string | null;
  householdMember5Employer2YearsAtJob: string | null;
  householdMember0GrossAnnualUnemploymentIncome: any | null;
  householdMember1GrossAnnualUnemploymentIncome: any | null;
  householdMember2GrossAnnualUnemploymentIncome: any | null;
  householdMember3GrossAnnualUnemploymentIncome: any | null;
  householdMember4GrossAnnualUnemploymentIncome: any | null;
  householdMember5GrossAnnualUnemploymentIncome: any | null;
  householdMember0GrossAnnualVetIncome: any | null;
  householdMember1GrossAnnualVetIncome: any | null;
  householdMember2GrossAnnualVetIncome: any | null;
  householdMember3GrossAnnualVetIncome: any | null;
  householdMember4GrossAnnualVetIncome: any | null;
  householdMember5GrossAnnualVetIncome: any | null;
  householdMember0GrossAnnualWorkCompIncome: any | null;
  householdMember1GrossAnnualWorkCompIncome: any | null;
  householdMember2GrossAnnualWorkCompIncome: any | null;
  householdMember3GrossAnnualWorkCompIncome: any | null;
  householdMember4GrossAnnualWorkCompIncome: any | null;
  householdMember5GrossAnnualWorkCompIncome: any | null;
  householdMember0GrossAnnualPensionIncome: any | null;
  householdMember1GrossAnnualPensionIncome: any | null;
  householdMember2GrossAnnualPensionIncome: any | null;
  householdMember3GrossAnnualPensionIncome: any | null;
  householdMember4GrossAnnualPensionIncome: any | null;
  householdMember5GrossAnnualPensionIncome: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source: string | null;
  householdMember0GrossAnnualUnlistedIncome1Source: string | null;
  householdMember0GrossAnnualUnlistedIncome2Source: string | null;
  householdMember1GrossAnnualUnlistedIncome0Source: string | null;
  householdMember1GrossAnnualUnlistedIncome1Source: string | null;
  householdMember1GrossAnnualUnlistedIncome2Source: string | null;
  householdMember2GrossAnnualUnlistedIncome0Source: string | null;
  householdMember2GrossAnnualUnlistedIncome1Source: string | null;
  householdMember2GrossAnnualUnlistedIncome2Source: string | null;
  householdMember3GrossAnnualUnlistedIncome0Source: string | null;
  householdMember3GrossAnnualUnlistedIncome1Source: string | null;
  householdMember3GrossAnnualUnlistedIncome2Source: string | null;
  householdMember4GrossAnnualUnlistedIncome0Source: string | null;
  householdMember4GrossAnnualUnlistedIncome1Source: string | null;
  householdMember4GrossAnnualUnlistedIncome2Source: string | null;
  householdMember5GrossAnnualUnlistedIncome0Source: string | null;
  householdMember5GrossAnnualUnlistedIncome1Source: string | null;
  householdMember5GrossAnnualUnlistedIncome2Source: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value: any | null;
  householdMember0GrossAnnualUnlistedIncome1Value: any | null;
  householdMember0GrossAnnualUnlistedIncome2Value: any | null;
  householdMember1GrossAnnualUnlistedIncome0Value: any | null;
  householdMember1GrossAnnualUnlistedIncome1Value: any | null;
  householdMember1GrossAnnualUnlistedIncome2Value: any | null;
  householdMember2GrossAnnualUnlistedIncome0Value: any | null;
  householdMember2GrossAnnualUnlistedIncome1Value: any | null;
  householdMember2GrossAnnualUnlistedIncome2Value: any | null;
  householdMember3GrossAnnualUnlistedIncome0Value: any | null;
  householdMember3GrossAnnualUnlistedIncome1Value: any | null;
  householdMember3GrossAnnualUnlistedIncome2Value: any | null;
  householdMember4GrossAnnualUnlistedIncome0Value: any | null;
  householdMember4GrossAnnualUnlistedIncome1Value: any | null;
  householdMember4GrossAnnualUnlistedIncome2Value: any | null;
  householdMember5GrossAnnualUnlistedIncome0Value: any | null;
  householdMember5GrossAnnualUnlistedIncome1Value: any | null;
  householdMember5GrossAnnualUnlistedIncome2Value: any | null;
  householdMember0GrossAnnualSocialSecurityIncome: any | null;
  householdMember1GrossAnnualSocialSecurityIncome: any | null;
  householdMember2GrossAnnualSocialSecurityIncome: any | null;
  householdMember3GrossAnnualSocialSecurityIncome: any | null;
  householdMember4GrossAnnualSocialSecurityIncome: any | null;
  householdMember5GrossAnnualSocialSecurityIncome: any | null;
  householdMember0GrossAnnualGiftIncome: any | null;
  householdMember1GrossAnnualGiftIncome: any | null;
  householdMember2GrossAnnualGiftIncome: any | null;
  householdMember3GrossAnnualGiftIncome: any | null;
  householdMember4GrossAnnualGiftIncome: any | null;
  householdMember5GrossAnnualGiftIncome: any | null;
  householdMember0GrossAnnualSsiIncome: any | null;
  householdMember1GrossAnnualSsiIncome: any | null;
  householdMember2GrossAnnualSsiIncome: any | null;
  householdMember3GrossAnnualSsiIncome: any | null;
  householdMember4GrossAnnualSsiIncome: any | null;
  householdMember5GrossAnnualSsiIncome: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome: any | null;
  householdMember0GrossAnnualChildSupportIncome: any | null;
  householdMember1GrossAnnualChildSupportIncome: any | null;
  householdMember2GrossAnnualChildSupportIncome: any | null;
  householdMember3GrossAnnualChildSupportIncome: any | null;
  householdMember4GrossAnnualChildSupportIncome: any | null;
  householdMember5GrossAnnualChildSupportIncome: any | null;
  householdMember0GrossAnnualAlimonyIncome: any | null;
  householdMember1GrossAnnualAlimonyIncome: any | null;
  householdMember2GrossAnnualAlimonyIncome: any | null;
  householdMember3GrossAnnualAlimonyIncome: any | null;
  householdMember4GrossAnnualAlimonyIncome: any | null;
  householdMember5GrossAnnualAlimonyIncome: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome: any | null;
  householdMember0GrossAnnualPropertyIncome: any | null;
  householdMember1GrossAnnualPropertyIncome: any | null;
  householdMember2GrossAnnualPropertyIncome: any | null;
  householdMember3GrossAnnualPropertyIncome: any | null;
  householdMember4GrossAnnualPropertyIncome: any | null;
  householdMember5GrossAnnualPropertyIncome: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome: any | null;
  householdHasCheckingAccount: boolean | null;
  householdHasSavingsAccount: boolean | null;
  householdHasRevokTrust: boolean | null;
  householdHasRealEstate: boolean | null;
  householdHasStocksTreasuries: boolean | null;
  householdHasCdMoneyMarket: boolean | null;
  householdHasIra401kLumpPension: boolean | null;
  householdHasWholeLifePolicy: boolean | null;
  householdHasCash: boolean | null;
  householdHasDisposedOfAssets: boolean | null;
  householdHasAssetsNotListed: boolean | null;
  householdMember0Checking0Balance: any | null;
  householdMember0Checking1Balance: any | null;
  householdMember0Checking2Balance: any | null;
  householdMember1Checking0Balance: any | null;
  householdMember1Checking1Balance: any | null;
  householdMember1Checking2Balance: any | null;
  householdMember2Checking0Balance: any | null;
  householdMember2Checking1Balance: any | null;
  householdMember2Checking2Balance: any | null;
  householdMember3Checking0Balance: any | null;
  householdMember3Checking1Balance: any | null;
  householdMember3Checking2Balance: any | null;
  householdMember4Checking0Balance: any | null;
  householdMember4Checking1Balance: any | null;
  householdMember4Checking2Balance: any | null;
  householdMember5Checking0Balance: any | null;
  householdMember5Checking1Balance: any | null;
  householdMember5Checking2Balance: any | null;
  householdMember0Checking0BankName: string | null;
  householdMember0Checking1BankName: string | null;
  householdMember0Checking2BankName: string | null;
  householdMember1Checking0BankName: string | null;
  householdMember1Checking1BankName: string | null;
  householdMember1Checking2BankName: string | null;
  householdMember2Checking0BankName: string | null;
  householdMember2Checking1BankName: string | null;
  householdMember2Checking2BankName: string | null;
  householdMember3Checking0BankName: string | null;
  householdMember3Checking1BankName: string | null;
  householdMember3Checking2BankName: string | null;
  householdMember4Checking0BankName: string | null;
  householdMember4Checking1BankName: string | null;
  householdMember4Checking2BankName: string | null;
  householdMember5Checking0BankName: string | null;
  householdMember5Checking1BankName: string | null;
  householdMember5Checking2BankName: string | null;
  householdMember0Checking0IsJointAccount: boolean | null;
  householdMember0Checking1IsJointAccount: boolean | null;
  householdMember0Checking2IsJointAccount: boolean | null;
  householdMember1Checking0IsJointAccount: boolean | null;
  householdMember1Checking1IsJointAccount: boolean | null;
  householdMember1Checking2IsJointAccount: boolean | null;
  householdMember2Checking0IsJointAccount: boolean | null;
  householdMember2Checking1IsJointAccount: boolean | null;
  householdMember2Checking2IsJointAccount: boolean | null;
  householdMember3Checking0IsJointAccount: boolean | null;
  householdMember3Checking1IsJointAccount: boolean | null;
  householdMember3Checking2IsJointAccount: boolean | null;
  householdMember4Checking0IsJointAccount: boolean | null;
  householdMember4Checking1IsJointAccount: boolean | null;
  householdMember4Checking2IsJointAccount: boolean | null;
  householdMember5Checking0IsJointAccount: boolean | null;
  householdMember5Checking1IsJointAccount: boolean | null;
  householdMember5Checking2IsJointAccount: boolean | null;
  householdMember0Checking0JointAccountHolderName: string | null;
  householdMember0Checking1JointAccountHolderName: string | null;
  householdMember0Checking2JointAccountHolderName: string | null;
  householdMember1Checking0JointAccountHolderName: string | null;
  householdMember1Checking1JointAccountHolderName: string | null;
  householdMember1Checking2JointAccountHolderName: string | null;
  householdMember2Checking0JointAccountHolderName: string | null;
  householdMember2Checking1JointAccountHolderName: string | null;
  householdMember2Checking2JointAccountHolderName: string | null;
  householdMember3Checking0JointAccountHolderName: string | null;
  householdMember3Checking1JointAccountHolderName: string | null;
  householdMember3Checking2JointAccountHolderName: string | null;
  householdMember4Checking0JointAccountHolderName: string | null;
  householdMember4Checking1JointAccountHolderName: string | null;
  householdMember4Checking2JointAccountHolderName: string | null;
  householdMember5Checking0JointAccountHolderName: string | null;
  householdMember5Checking1JointAccountHolderName: string | null;
  householdMember5Checking2JointAccountHolderName: string | null;
  householdMember0Savings0Balance: any | null;
  householdMember0Savings1Balance: any | null;
  householdMember0Savings2Balance: any | null;
  householdMember1Savings0Balance: any | null;
  householdMember1Savings1Balance: any | null;
  householdMember1Savings2Balance: any | null;
  householdMember2Savings0Balance: any | null;
  householdMember2Savings1Balance: any | null;
  householdMember2Savings2Balance: any | null;
  householdMember3Savings0Balance: any | null;
  householdMember3Savings1Balance: any | null;
  householdMember3Savings2Balance: any | null;
  householdMember4Savings0Balance: any | null;
  householdMember4Savings1Balance: any | null;
  householdMember4Savings2Balance: any | null;
  householdMember5Savings0Balance: any | null;
  householdMember5Savings1Balance: any | null;
  householdMember5Savings2Balance: any | null;
  householdMember0Savings0BankName: string | null;
  householdMember0Savings1BankName: string | null;
  householdMember0Savings2BankName: string | null;
  householdMember1Savings0BankName: string | null;
  householdMember1Savings1BankName: string | null;
  householdMember1Savings2BankName: string | null;
  householdMember2Savings0BankName: string | null;
  householdMember2Savings1BankName: string | null;
  householdMember2Savings2BankName: string | null;
  householdMember3Savings0BankName: string | null;
  householdMember3Savings1BankName: string | null;
  householdMember3Savings2BankName: string | null;
  householdMember4Savings0BankName: string | null;
  householdMember4Savings1BankName: string | null;
  householdMember4Savings2BankName: string | null;
  householdMember5Savings0BankName: string | null;
  householdMember5Savings1BankName: string | null;
  householdMember5Savings2BankName: string | null;
  householdMember0Savings0IsJointAccount: boolean | null;
  householdMember0Savings1IsJointAccount: boolean | null;
  householdMember0Savings2IsJointAccount: boolean | null;
  householdMember1Savings0IsJointAccount: boolean | null;
  householdMember1Savings1IsJointAccount: boolean | null;
  householdMember1Savings2IsJointAccount: boolean | null;
  householdMember2Savings0IsJointAccount: boolean | null;
  householdMember2Savings1IsJointAccount: boolean | null;
  householdMember2Savings2IsJointAccount: boolean | null;
  householdMember3Savings0IsJointAccount: boolean | null;
  householdMember3Savings1IsJointAccount: boolean | null;
  householdMember3Savings2IsJointAccount: boolean | null;
  householdMember4Savings0IsJointAccount: boolean | null;
  householdMember4Savings1IsJointAccount: boolean | null;
  householdMember4Savings2IsJointAccount: boolean | null;
  householdMember5Savings0IsJointAccount: boolean | null;
  householdMember5Savings1IsJointAccount: boolean | null;
  householdMember5Savings2IsJointAccount: boolean | null;
  householdMember0Savings0JointAccountHolderName: string | null;
  householdMember0Savings1JointAccountHolderName: string | null;
  householdMember0Savings2JointAccountHolderName: string | null;
  householdMember1Savings0JointAccountHolderName: string | null;
  householdMember1Savings1JointAccountHolderName: string | null;
  householdMember1Savings2JointAccountHolderName: string | null;
  householdMember2Savings0JointAccountHolderName: string | null;
  householdMember2Savings1JointAccountHolderName: string | null;
  householdMember2Savings2JointAccountHolderName: string | null;
  householdMember3Savings0JointAccountHolderName: string | null;
  householdMember3Savings1JointAccountHolderName: string | null;
  householdMember3Savings2JointAccountHolderName: string | null;
  householdMember4Savings0JointAccountHolderName: string | null;
  householdMember4Savings1JointAccountHolderName: string | null;
  householdMember4Savings2JointAccountHolderName: string | null;
  householdMember5Savings0JointAccountHolderName: string | null;
  householdMember5Savings1JointAccountHolderName: string | null;
  householdMember5Savings2JointAccountHolderName: string | null;
  householdMember0RevokTrustValue: any | null;
  householdMember1RevokTrustValue: any | null;
  householdMember2RevokTrustValue: any | null;
  householdMember3RevokTrustValue: any | null;
  householdMember4RevokTrustValue: any | null;
  householdMember5RevokTrustValue: any | null;
  householdMember0RealEstateValue: any | null;
  householdMember1RealEstateValue: any | null;
  householdMember2RealEstateValue: any | null;
  householdMember3RealEstateValue: any | null;
  householdMember4RealEstateValue: any | null;
  householdMember5RealEstateValue: any | null;
  householdMember0StockBondTreasuryValue: any | null;
  householdMember1StockBondTreasuryValue: any | null;
  householdMember2StockBondTreasuryValue: any | null;
  householdMember3StockBondTreasuryValue: any | null;
  householdMember4StockBondTreasuryValue: any | null;
  householdMember5StockBondTreasuryValue: any | null;
  householdMember0BrokerageName: string | null;
  householdMember1BrokerageName: string | null;
  householdMember2BrokerageName: string | null;
  householdMember3BrokerageName: string | null;
  householdMember4BrokerageName: string | null;
  householdMember5BrokerageName: string | null;
  householdMember0CdMoneyMarketValue: any | null;
  householdMember1CdMoneyMarketValue: any | null;
  householdMember2CdMoneyMarketValue: any | null;
  householdMember3CdMoneyMarketValue: any | null;
  householdMember4CdMoneyMarketValue: any | null;
  householdMember5CdMoneyMarketValue: any | null;
  householdMember0CdMoneyMarketBankName: string | null;
  householdMember1CdMoneyMarketBankName: string | null;
  householdMember2CdMoneyMarketBankName: string | null;
  householdMember3CdMoneyMarketBankName: string | null;
  householdMember4CdMoneyMarketBankName: string | null;
  householdMember5CdMoneyMarketBankName: string | null;
  householdMember0CdMoneyMarketIsJointAccount: boolean | null;
  householdMember1CdMoneyMarketIsJointAccount: boolean | null;
  householdMember2CdMoneyMarketIsJointAccount: boolean | null;
  householdMember3CdMoneyMarketIsJointAccount: boolean | null;
  householdMember4CdMoneyMarketIsJointAccount: boolean | null;
  householdMember5CdMoneyMarketIsJointAccount: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName: string | null;
  householdMember1CdMoneyMarketJointAccountHolderName: string | null;
  householdMember2CdMoneyMarketJointAccountHolderName: string | null;
  householdMember3CdMoneyMarketJointAccountHolderName: string | null;
  householdMember4CdMoneyMarketJointAccountHolderName: string | null;
  householdMember5CdMoneyMarketJointAccountHolderName: string | null;
  householdMember0Ira401kLumpPensionBalance: any | null;
  householdMember1Ira401kLumpPensionBalance: any | null;
  householdMember2Ira401kLumpPensionBalance: any | null;
  householdMember3Ira401kLumpPensionBalance: any | null;
  householdMember4Ira401kLumpPensionBalance: any | null;
  householdMember5Ira401kLumpPensionBalance: any | null;
  householdMember0Ira401kLumpPensionBankName: string | null;
  householdMember1Ira401kLumpPensionBankName: string | null;
  householdMember2Ira401kLumpPensionBankName: string | null;
  householdMember3Ira401kLumpPensionBankName: string | null;
  householdMember4Ira401kLumpPensionBankName: string | null;
  householdMember5Ira401kLumpPensionBankName: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember1Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember2Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember3Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember4Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember5Ira401kLumpPensionIsJointAccount: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName: string | null;
  householdMember0WholeLifeInsuranceValue: any | null;
  householdMember1WholeLifeInsuranceValue: any | null;
  householdMember2WholeLifeInsuranceValue: any | null;
  householdMember3WholeLifeInsuranceValue: any | null;
  householdMember4WholeLifeInsuranceValue: any | null;
  householdMember5WholeLifeInsuranceValue: any | null;
  householdMember0CashValue: any | null;
  householdMember1CashValue: any | null;
  householdMember2CashValue: any | null;
  householdMember3CashValue: any | null;
  householdMember4CashValue: any | null;
  householdMember5CashValue: any | null;
  householdMember0DisposedAssetsValue: any | null;
  householdMember1DisposedAssetsValue: any | null;
  householdMember2DisposedAssetsValue: any | null;
  householdMember3DisposedAssetsValue: any | null;
  householdMember4DisposedAssetsValue: any | null;
  householdMember5DisposedAssetsValue: any | null;
  householdMember0AssetsNotListed0Source: string | null;
  householdMember0AssetsNotListed1Source: string | null;
  householdMember0AssetsNotListed2Source: string | null;
  householdMember1AssetsNotListed0Source: string | null;
  householdMember1AssetsNotListed1Source: string | null;
  householdMember1AssetsNotListed2Source: string | null;
  householdMember2AssetsNotListed0Source: string | null;
  householdMember2AssetsNotListed1Source: string | null;
  householdMember2AssetsNotListed2Source: string | null;
  householdMember3AssetsNotListed0Source: string | null;
  householdMember3AssetsNotListed1Source: string | null;
  householdMember3AssetsNotListed2Source: string | null;
  householdMember4AssetsNotListed0Source: string | null;
  householdMember4AssetsNotListed1Source: string | null;
  householdMember4AssetsNotListed2Source: string | null;
  householdMember5AssetsNotListed0Source: string | null;
  householdMember5AssetsNotListed1Source: string | null;
  householdMember5AssetsNotListed2Source: string | null;
  householdMember0AssetsNotListed0Value: any | null;
  householdMember0AssetsNotListed1Value: any | null;
  householdMember0AssetsNotListed2Value: any | null;
  householdMember1AssetsNotListed0Value: any | null;
  householdMember1AssetsNotListed1Value: any | null;
  householdMember1AssetsNotListed2Value: any | null;
  householdMember2AssetsNotListed0Value: any | null;
  householdMember2AssetsNotListed1Value: any | null;
  householdMember2AssetsNotListed2Value: any | null;
  householdMember3AssetsNotListed0Value: any | null;
  householdMember3AssetsNotListed1Value: any | null;
  householdMember3AssetsNotListed2Value: any | null;
  householdMember4AssetsNotListed0Value: any | null;
  householdMember4AssetsNotListed1Value: any | null;
  householdMember4AssetsNotListed2Value: any | null;
  householdMember5AssetsNotListed0Value: any | null;
  householdMember5AssetsNotListed1Value: any | null;
  householdMember5AssetsNotListed2Value: any | null;
  applicantHomelessDoesNotHaveLandlord: boolean | null;
  landlordFirstName: string | null;
  landlordLastName: string | null;
  landlordAddress1: string | null;
  landlordSteNumber: string | null;
  landlordCity: string | null;
  landlordState: string | null;
  landlordZip: string | null;
  landlordPrimaryPhone: string | null;
  landlordPrimaryPhoneType: string | null;
  landlordOkToLeaveMessage: boolean | null;
  landlordHasUnknownPhone: boolean | null;
  landlordEmail: string | null;
  reasonForMoving: string | null;
  applicantTotalMonthlyRent: any | null;
  applicantContributionToRent: any | null;
  isRentSubsidized: boolean | null;
  landlordHasUnknownAddress: boolean | null;
  contactDenyInformation: boolean | null;
  contactName: string | null;
  contactEmail: string | null;
  contactRelation: string | null;
  contactAddress1: string | null;
  contactSteNumber: string | null;
  contactCity: string | null;
  contactState: string | null;
  contactZip: string | null;
  contactPrimaryPhone: string | null;
  contactPrimaryPhoneType: string | null;
  contactPrimaryPhoneOkToLeaveMessage: boolean | null;
  contactSecondaryPhone: string | null;
  contactSecondaryPhoneType: string | null;
  contactSecondaryPhoneOkToLeaveMessage: boolean | null;
  contactReasonReceipt: boolean | null;
  contactReasonEmergency: boolean | null;
  contactReasonUnableToContact: boolean | null;
  contactReasonTerminationOfRentalAssist: boolean | null;
  contactReasonEvictionFromUnit: boolean | null;
  contactReasonLatePaymentOfRent: boolean | null;
  contactReasonAssistWithRecertification: boolean | null;
  contactReasonChangeInLeaseTerms: boolean | null;
  contactReasonChangeInHouseRules: boolean | null;
  contactReasonOther: boolean | null;
  householdMember0EthnicCategory: string | null;
  householdMember1EthnicCategory: string | null;
  householdMember2EthnicCategory: string | null;
  householdMember3EthnicCategory: string | null;
  householdMember4EthnicCategory: string | null;
  householdMember5EthnicCategory: string | null;
  householdMember0RaceAmerIndianAlaskanNative: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative: boolean | null;
  householdMember0RaceAsian: boolean | null;
  householdMember1RaceAsian: boolean | null;
  householdMember2RaceAsian: boolean | null;
  householdMember3RaceAsian: boolean | null;
  householdMember4RaceAsian: boolean | null;
  householdMember5RaceAsian: boolean | null;
  householdMember0RaceAfricanAmerican: boolean | null;
  householdMember1RaceAfricanAmerican: boolean | null;
  householdMember2RaceAfricanAmerican: boolean | null;
  householdMember3RaceAfricanAmerican: boolean | null;
  householdMember4RaceAfricanAmerican: boolean | null;
  householdMember5RaceAfricanAmerican: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander: boolean | null;
  householdMember0RaceWhite: boolean | null;
  householdMember1RaceWhite: boolean | null;
  householdMember2RaceWhite: boolean | null;
  householdMember3RaceWhite: boolean | null;
  householdMember4RaceWhite: boolean | null;
  householdMember5RaceWhite: boolean | null;
  householdMember0RaceOther: boolean | null;
  householdMember1RaceOther: boolean | null;
  householdMember2RaceOther: boolean | null;
  householdMember3RaceOther: boolean | null;
  householdMember4RaceOther: boolean | null;
  householdMember5RaceOther: boolean | null;
  householdMember0RaceDecline: boolean | null;
  householdMember1RaceDecline: boolean | null;
  householdMember2RaceDecline: boolean | null;
  householdMember3RaceDecline: boolean | null;
  householdMember4RaceDecline: boolean | null;
  householdMember5RaceDecline: boolean | null;
  householdReceivesOtherHousingAssistance: boolean | null;
  applicantEmployeeOfNyc: boolean | null;
  applicantHadNycHousingInvolvement: boolean | null;
  householdRequiresImpairmentMobility: boolean | null;
  householdRequiresImpairmentVisual: boolean | null;
  householdRequiresImpairmentHearing: boolean | null;
  howDidApplicantHearAboutProperty: string | null;
  householdHasHousingAuthorityVoucher: boolean | null;
  householdHasPets: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType: string | null;
  signupForHavenNewsletter: boolean | null;
  applicantFirstName: string | null;
  applicantLastName: string | null;
  applicantDob: string | null;
  residenceHousingType: string | null;
  applicantPhonePrimary: string | null;
  applicantPhoneSecondary: string | null;
  applicantPhoneSecondaryExt: string | null;
  applicantNoPhone: boolean | null;
  applicantEmail: string | null;
  applicantAdultCount: number | null;
  applicantChildCount: number | null;
  unitSize: string | null;
  unitSizeSro: boolean | null;
  unitSizeStudio: boolean | null;
  unitSize1br: boolean | null;
  unitSize1brDen: boolean | null;
  unitSize2br: boolean | null;
  unitSize3br: boolean | null;
  unitSize4br: boolean | null;
  unitSize5br: boolean | null;
  unitSizeShared: boolean | null;
  householdServedInArmedForces: boolean | null;
  householdHasSpecialAccommodations: boolean | null;
  householdLivesWorksInMenloPark: boolean | null;
  householdLivesWorksInSouthSf: boolean | null;
  householdLivesWorksInSanMateo: boolean | null;
  householdLivesWorksInSanCarlos: boolean | null;
  income0Source: string | null;
  income1Source: string | null;
  income2Source: string | null;
  income3Source: string | null;
  income0Amount: any | null;
  income1Amount: any | null;
  income2Amount: any | null;
  income3Amount: any | null;
  asset0Type: string | null;
  asset1Type: string | null;
  asset2Type: string | null;
  asset3Type: string | null;
  asset0Amount: any | null;
  asset1Amount: any | null;
  asset2Amount: any | null;
  asset3Amount: any | null;
  coApplicantDerived: string | null;
  applicantRentalBuyPref: string | null;
  extraInfo: string | null;
  propertyId: string | null;
  hasPrinted: boolean | null;
  hasDownloaded: boolean | null;
  householdPetDescription: string | null;
  houseMemberWheelchair: boolean | null;
  householdLivesInPaloAlto: boolean | null;
  householdWorksInPaloAlto: boolean | null;
  worksInPaloAltoSite: string | null;
  householdMember0CitizenIdType: string | null;
  householdMember1CitizenIdType: string | null;
  householdMember2CitizenIdType: string | null;
  householdMember3CitizenIdType: string | null;
  householdMember4CitizenIdType: string | null;
  householdMember5CitizenIdType: string | null;
  householdMember0CitizenIdResult: string | null;
  householdMember1CitizenIdResult: string | null;
  householdMember2CitizenIdResult: string | null;
  householdMember3CitizenIdResult: string | null;
  householdMember4CitizenIdResult: string | null;
  householdMember5CitizenIdResult: string | null;
  householdMember0SsnItinPendingExpectedDate: any | null;
  householdMember1SsnItinPendingExpectedDate: any | null;
  householdMember2SsnItinPendingExpectedDate: any | null;
  householdMember3SsnItinPendingExpectedDate: any | null;
  householdMember4SsnItinPendingExpectedDate: any | null;
  householdMember5SsnItinPendingExpectedDate: any | null;
  householdMember0Social: string | null;
  householdMember1Social: string | null;
  householdMember2Social: string | null;
  householdMember3Social: string | null;
  householdMember4Social: string | null;
  householdMember5Social: string | null;
  householdMember0TaxIdNumber: string | null;
  householdMember1TaxIdNumber: string | null;
  householdMember2TaxIdNumber: string | null;
  householdMember3TaxIdNumber: string | null;
  householdMember4TaxIdNumber: string | null;
  householdMember5TaxIdNumber: string | null;
  householdMember0Age: number | null;
  householdMember1Age: number | null;
  householdMember2Age: number | null;
  householdMember3Age: number | null;
  householdMember4Age: number | null;
  householdMember5Age: number | null;
  householdMember0GenderPronoun: string | null;
  householdMember1GenderPronoun: string | null;
  householdMember2GenderPronoun: string | null;
  householdMember3GenderPronoun: string | null;
  householdMember4GenderPronoun: string | null;
  householdMember5GenderPronoun: string | null;
  householdMember0Income: number | null;
  householdMember1Income: number | null;
  householdMember2Income: number | null;
  householdMember3Income: number | null;
  householdMember4Income: number | null;
  householdMember5Income: number | null;
  householdMember0RelationToApp: string | null;
  householdMember0TotalGrossAnnualIncome: number | null;
  householdMember1TotalGrossAnnualIncome: number | null;
  householdMember2TotalGrossAnnualIncome: number | null;
  householdMember3TotalGrossAnnualIncome: number | null;
  householdMember4TotalGrossAnnualIncome: number | null;
  householdMember5TotalGrossAnnualIncome: number | null;
  householdMember0SecondaryPhoneExt: string | null;
  householdMember1SecondaryPhoneExt: string | null;
  householdMember2SecondaryPhoneExt: string | null;
  householdMember3SecondaryPhoneExt: string | null;
  householdMember4SecondaryPhoneExt: string | null;
  householdMember5SecondaryPhoneExt: string | null;
  contactPrimaryPhoneExt: string | null;
  contactSecondaryPhoneExt: string | null;
  householdLivesWorksInAlameda: boolean | null;
  householdAllFullTimeStudents: boolean | null;
  householdOwnsCar: boolean | null;
  customPref1: boolean | null;
  customPref2: boolean | null;
  customPref3: boolean | null;
  customPref4: boolean | null;
  customPref5: boolean | null;
  customPref6: boolean | null;
  customPref7: boolean | null;
  customPref8: boolean | null;
  customPref9: boolean | null;
  customPref10: boolean | null;
  customPref11: boolean | null;
  customPref12: boolean | null;
  customPref13: boolean | null;
  customPref14: boolean | null;
  customPref1Answer: string | null;
  customPref2Answer: string | null;
  customPref3Answer: string | null;
  customPref4Answer: string | null;
  customPref5Answer: string | null;
  customPref6Answer: string | null;
  customPref7Answer: string | null;
  customPref8Answer: string | null;
  customPref9Answer: string | null;
  customPref10Answer: string | null;
  customPref11Answer: string | null;
  customPref12Answer: string | null;
  customPref13Answer: string | null;
  customPref14Answer: string | null;
  contactMethodEmail: boolean | null;
  contactMethodPhone: boolean | null;
  contactMethodMail: boolean | null;
  contactMethodSms: boolean | null;
  householdDisability: boolean | null;
  householdDisabilityAnswer: string | null;
  prefMoveInDate: string | null;
  prefLang: string | null;
  householdMember0MiddleName: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BuildingType {
  CONDO = "CONDO",
  MULTIFAMILY = "MULTIFAMILY",
  OTHER = "OTHER",
  SINGLE_FAMILY = "SINGLE_FAMILY",
  TOWNHOMES = "TOWNHOMES",
}

export enum Citizenships {
  LEGAL_PERMANENT_RESIDENT = "LEGAL_PERMANENT_RESIDENT",
  OTHER = "OTHER",
  US_CITIZEN = "US_CITIZEN",
  WORK_AUTH = "WORK_AUTH",
  WORK_AUTH_PENDING = "WORK_AUTH_PENDING",
}

export enum DocumentType {
  DOCUMENT = "DOCUMENT",
  PREAPP_DOCUMENT = "PREAPP_DOCUMENT",
  SUBMISSION_DOCUMENT = "SUBMISSION_DOCUMENT",
}

export enum Ethnicities {
  HISPANIC_OR_LATINO = "HISPANIC_OR_LATINO",
  NOT_HISPANIC_OR_LATINO = "NOT_HISPANIC_OR_LATINO",
}

export enum Feature {
  AMI_RANGE = "AMI_RANGE",
  APPLICANT_DOCUMENT_UPLOAD = "APPLICANT_DOCUMENT_UPLOAD",
  BUILDING_SETTINGS = "BUILDING_SETTINGS",
  DOCUMENT_UPLOAD = "DOCUMENT_UPLOAD",
  ELIGIBILITY_FORM = "ELIGIBILITY_FORM",
  FILTER_LOGIC = "FILTER_LOGIC",
  FULL_APPLICATION = "FULL_APPLICATION",
  FUNDING_SOURCES = "FUNDING_SOURCES",
  IMPORTS = "IMPORTS",
  INTEREST_PROFILE_SLIDEOUT = "INTEREST_PROFILE_SLIDEOUT",
  KILL_WHITELABEL = "KILL_WHITELABEL",
  KILL_WHITELABEL_PROPERTIES_PAGE = "KILL_WHITELABEL_PROPERTIES_PAGE",
  NEW_DASHBOARD = "NEW_DASHBOARD",
  ONESITE_SYNC = "ONESITE_SYNC",
  PLAN_SELECTION = "PLAN_SELECTION",
  PREAPP_PDF_PRINT_MARKS = "PREAPP_PDF_PRINT_MARKS",
  REMOVE_BOOTSTRAP = "REMOVE_BOOTSTRAP",
  REMOVE_WHITELABEL_METADATA = "REMOVE_WHITELABEL_METADATA",
  REQUEST_FORMS = "REQUEST_FORMS",
  REQUEST_REINSTATEMENT = "REQUEST_REINSTATEMENT",
  SEND_LETTERS = "SEND_LETTERS",
  SEND_MAIL_VIA_POSTGRID = "SEND_MAIL_VIA_POSTGRID",
  USER_PROFILE = "USER_PROFILE",
  WEIGHTED_PREFERENCES = "WEIGHTED_PREFERENCES",
}

export enum FilterCondition {
  AND = "AND",
  OR = "OR",
}

/**
 * Available form layout names
 */
export enum FormLayoutName {
  APPLY = "APPLY",
}

export enum FormType {
  AFFIDAVIT = "AFFIDAVIT",
  FULL_APPLICATION = "FULL_APPLICATION",
  INTEREST_LIST_SUBMISSION = "INTEREST_LIST_SUBMISSION",
  PRE_APPLICATION = "PRE_APPLICATION",
  VERIFICATION = "VERIFICATION",
}

export enum Genders {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
  TRANS = "TRANS",
}

export enum LoginMethod {
  EMAIL = "EMAIL",
  PHONE = "PHONE",
}

export enum PostgresUserRole {
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  PROPERTY_MANAGER = "PROPERTY_MANAGER",
  SUPERVISOR = "SUPERVISOR",
}

export enum Pronouns {
  HE_HIM = "HE_HIM",
  OTHER = "OTHER",
  SHE_HER = "SHE_HER",
  THEY_THEM = "THEY_THEM",
}

export enum Races {
  AFRICAN_AMERICAN = "AFRICAN_AMERICAN",
  AMERICAN_INDIAN_ALASKAN_NATIVE = "AMERICAN_INDIAN_ALASKAN_NATIVE",
  ASIAN = "ASIAN",
  NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER = "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
  OTHER = "OTHER",
  WHITE = "WHITE",
}

export enum RelatedEntityType {
  ORGANIZATION = "ORGANIZATION",
  PROPERTY = "PROPERTY",
}

export enum ReportName {
  INTEREST_COUNT = "INTEREST_COUNT",
  INTEREST_DATE_MISMATCH = "INTEREST_DATE_MISMATCH",
  INTEREST_DOB = "INTEREST_DOB",
  INTEREST_ETHNICITY = "INTEREST_ETHNICITY",
  INTEREST_GENDER = "INTEREST_GENDER",
  INTEREST_RACE = "INTEREST_RACE",
  INTEREST_SOURCE = "INTEREST_SOURCE",
  INTEREST_STATUS = "INTEREST_STATUS",
  USER_STATS = "USER_STATS",
}

export enum TemplateType {
  EMAIL = "EMAIL",
  LETTER = "LETTER",
  SMS = "SMS",
}

export enum UpdateRequestChannel {
  EMAIL = "EMAIL",
  LETTER = "LETTER",
  MANUAL_CONTACT = "MANUAL_CONTACT",
  SMS = "SMS",
}

export enum UsState {
  AK = "AK",
  AL = "AL",
  AR = "AR",
  AS = "AS",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FL = "FL",
  FM = "FM",
  GA = "GA",
  GU = "GU",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MH = "MH",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  PR = "PR",
  PW = "PW",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  VI = "VI",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

export enum UserRole {
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  PROPERTY_MANAGER = "PROPERTY_MANAGER",
  SUPERVISOR = "SUPERVISOR",
}

export enum ValueType {
  address = "address",
  array = "array",
  boolean = "boolean",
  date = "date",
  date_range = "date_range",
  email = "email",
  encrypted_text = "encrypted_text",
  fax_number = "fax_number",
  formatted = "formatted",
  household_member = "household_member",
  money = "money",
  multiple = "multiple",
  phone_number = "phone_number",
  select = "select",
  text = "text",
  upload = "upload",
  us_state = "us_state",
}

export enum WaitlistUpdateRequestStatus {
  ALL_BOUNCED = "ALL_BOUNCED",
  NO_RESPONSE = "NO_RESPONSE",
  RESPONDED = "RESPONDED",
  UNREACHABLE = "UNREACHABLE",
  UNREACHABLE_LANDLINE_ONLY = "UNREACHABLE_LANDLINE_ONLY",
}

export interface ActivityInput {
  note?: string | null;
  resourceId?: string | null;
  resourceTable?: string | null;
  title?: string | null;
  type?: string | null;
}

export interface AddressInput {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  name?: string | null;
  state?: string | null;
  zip?: any | null;
}

export interface AdminUserInput {
  emailVerified?: boolean | null;
  loginEmail?: string | null;
  loginPhone?: string | null;
  organizationId?: string | null;
  password?: string | null;
  phoneVerified?: boolean | null;
}

export interface AdminUserProfileInput {
  firstName?: string | null;
  lastName?: string | null;
}

export interface BuildingInput {
  address1: string;
  address2?: string | null;
  bin?: string | null;
  city: string;
  name: string;
  phase?: string | null;
  state: UsState;
  type: BuildingType;
  zip: string;
}

export interface BuildingUnitInput {
  accessibility: (string | null)[];
  bathrooms: number;
  bedrooms: string;
  buildingId: string;
  floor: number;
  fundingSource: (string | null)[];
  incomeDesignation: string;
  isReferral: boolean;
  name: string;
  occupancyMax: number;
  occupancyMin: number;
  occupied: string;
  preference: (string | null)[];
  referralOrg?: string | null;
  rentType: string;
  rentValue: number;
  sqft: number;
}

export interface ChannelTemplate {
  body?: string | null;
  html?: string | null;
  id?: string | null;
  subject?: string | null;
  type?: string | null;
}

export interface ColumnMapping {
  csvColumn: string;
  havenColumn: string;
}

/**
 * Structured property address parts used when the post-sign path creates a draft property
 */
export interface ContractAddressPartsInput {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

export interface CreatePropertyContractInput {
  embedded: boolean;
  initialTermEndDate?: string | null;
  signerEmail: string;
  signerName: string;
  signerTitle: string;
  startDate?: string | null;
  submissionId?: any | null;
  timeZone?: string | null;
  userId: any;
  valuesJson: string;
}

export interface CsvImportConfigInput {
  allowNulls: boolean;
  columnMappings: (ColumnMapping | null)[];
  dryRun: boolean;
}

export interface DocumentPreflightRequest {
  category: string;
  filename: string;
  filesize: number;
  interest?: string | null;
  tempId: string;
}

export interface ElasticFilterInput {
  field: string;
  max?: string | null;
  min?: string | null;
  type: string;
  value?: string | null;
  values?: string[] | null;
}

export interface ElasticQuery {
  defaultSorting?: string | null;
  filterCondition?: FilterCondition | null;
  filters: ElasticFilterInput[];
  textFilter?: string | null;
}

export interface FormAnswer {
  context?: (string | null)[] | null;
  key?: string | null;
  questionName: string;
  value: any;
}

export interface FormDefinitionInput {
  ageRequirement?: number | null;
  ageRequirementOrDisabilityOverride?: boolean | null;
  content?: string | null;
  createInterest?: boolean | null;
  enabled?: boolean | null;
  formId?: string | null;
  formOpen?: boolean | null;
  formType?: FormType | null;
  name?: string | null;
  propertyId?: string | null;
  renderParagraphs?: boolean | null;
  skipSignature?: boolean | null;
}

export interface FormQuestionInput {
  name?: string | null;
  valueType?: ValueType | null;
}

export interface FormUpdate {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  contactEmail?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactPhoneType?: string | null;
  contactRelation?: string | null;
  email?: string | null;
  householdCount?: number | null;
  householdHasHousingAuthorityVoucher?: boolean | null;
  householdNetIncome?: number | null;
  isStayingOnList?: boolean | null;
  primaryPhone?: string | null;
  primaryPhoneType?: string | null;
  responseChannel?: UpdateRequestChannel | null;
  secondaryPhone?: string | null;
  secondaryPhoneType?: string | null;
  state?: string | null;
  zip?: string | null;
}

/**
 * Haven interest application (fields allowed to UPDATE)
 */
export interface InterestInput {
  agreeToOrgTerms?: boolean | null;
  applicantAdultCount?: any | null;
  applicantChildCount?: any | null;
  applicantContributionToRent?: any | null;
  applicantDob?: string | null;
  applicantEmail?: string | null;
  applicantEmployeeOfNyc?: boolean | null;
  applicantFirstName?: string | null;
  applicantHadNycHousingInvolvement?: boolean | null;
  applicantHomelessDoesNotHaveLandlord?: boolean | null;
  applicantHomelessOrNoResidence?: boolean | null;
  applicantLastName?: string | null;
  applicantMiddleInitial?: string | null;
  applicantNoPhone?: boolean | null;
  applicantPhonePrimary?: string | null;
  applicantPhoneSecondary?: string | null;
  applicantPhoneSecondaryExt?: string | null;
  applicantPreferedContactType?: string | null;
  applicantRentalBuyPref?: string | null;
  applicantTotalMonthlyRent?: any | null;
  asset0Amount?: any | null;
  asset0Type?: string | null;
  asset1Amount?: any | null;
  asset1Type?: string | null;
  asset2Amount?: any | null;
  asset2Type?: string | null;
  asset3Amount?: any | null;
  asset3Type?: string | null;
  contactAddress1?: string | null;
  contactCity?: string | null;
  contactDenyInformation?: boolean | null;
  contactEmail?: string | null;
  contactMethodEmail?: boolean | null;
  contactMethodMail?: boolean | null;
  contactMethodPhone?: boolean | null;
  contactMethodSms?: boolean | null;
  contactName?: string | null;
  contactNumber?: string | null;
  contactNumberExt?: string | null;
  contactPrimaryPhone?: string | null;
  contactPrimaryPhoneExt?: string | null;
  contactPrimaryPhoneOkToLeaveMessage?: boolean | null;
  contactPrimaryPhoneType?: string | null;
  contactReasonAssistWithRecertification?: boolean | null;
  contactReasonChangeInHouseRules?: boolean | null;
  contactReasonChangeInLeaseTerms?: boolean | null;
  contactReasonEmergency?: boolean | null;
  contactReasonEvictionFromUnit?: boolean | null;
  contactReasonLatePaymentOfRent?: boolean | null;
  contactReasonOther?: boolean | null;
  contactReasonReceipt?: boolean | null;
  contactReasonTerminationOfRentalAssist?: boolean | null;
  contactReasonUnableToContact?: boolean | null;
  contactRelation?: string | null;
  contactSecondaryPhone?: string | null;
  contactSecondaryPhoneExt?: string | null;
  contactSecondaryPhoneOkToLeaveMessage?: boolean | null;
  contactSecondaryPhoneType?: string | null;
  contactState?: string | null;
  contactSteNumber?: string | null;
  contactZip?: string | null;
  createType?: string | null;
  customPref1?: boolean | null;
  customPref10?: boolean | null;
  customPref10Answer?: string | null;
  customPref11?: boolean | null;
  customPref11Answer?: string | null;
  customPref12?: boolean | null;
  customPref12Answer?: string | null;
  customPref13?: boolean | null;
  customPref13Answer?: string | null;
  customPref14?: boolean | null;
  customPref14Answer?: string | null;
  customPref1Answer?: string | null;
  customPref2?: boolean | null;
  customPref2Answer?: string | null;
  customPref3?: boolean | null;
  customPref3Answer?: string | null;
  customPref4?: boolean | null;
  customPref4Answer?: string | null;
  customPref5?: boolean | null;
  customPref5Answer?: string | null;
  customPref6?: boolean | null;
  customPref6Answer?: string | null;
  customPref7?: boolean | null;
  customPref7Answer?: string | null;
  customPref8?: boolean | null;
  customPref8Answer?: string | null;
  customPref9?: boolean | null;
  customPref9Answer?: string | null;
  extraInfo?: string | null;
  hasMailingAddress?: boolean | null;
  houseMemberWheelchair?: boolean | null;
  householdAllFullTimeStudents?: boolean | null;
  householdCount?: any | null;
  householdDisability?: boolean | null;
  householdDisabilityAnswer?: string | null;
  householdGrossAnnualIncome?: any | null;
  householdHasAssetsNotListed?: boolean | null;
  householdHasCash?: boolean | null;
  householdHasCdMoneyMarket?: boolean | null;
  householdHasCheckingAccount?: boolean | null;
  householdHasDisposedOfAssets?: boolean | null;
  householdHasHousingAuthorityVoucher?: boolean | null;
  householdHasIra401kLumpPension?: boolean | null;
  householdHasPets?: boolean | null;
  householdHasRealEstate?: boolean | null;
  householdHasRevokTrust?: boolean | null;
  householdHasSavingsAccount?: boolean | null;
  householdHasSpecialAccommodations?: boolean | null;
  householdHasStocksTreasuries?: boolean | null;
  householdHasWholeLifePolicy?: boolean | null;
  householdIsEmployed?: boolean | null;
  householdIsEntitledToChildSupport?: boolean | null;
  householdIsReceivingAlimony?: boolean | null;
  householdIsReceivingChildSupport?: boolean | null;
  householdIsReceivingDisabilityBenefits?: boolean | null;
  householdIsReceivingGifts?: boolean | null;
  householdIsReceivingIncomeNotListed?: boolean | null;
  householdIsReceivingNonLoanFinancialAid?: boolean | null;
  householdIsReceivingPension?: boolean | null;
  householdIsReceivingPeriodicPayments?: boolean | null;
  householdIsReceivingPropertyIncome?: boolean | null;
  householdIsReceivingPublicAssistanceIncome?: boolean | null;
  householdIsReceivingSocialSecurity?: boolean | null;
  householdIsReceivingSsi?: boolean | null;
  householdIsReceivingUnemployment?: boolean | null;
  householdIsReceivingVetIncome?: boolean | null;
  householdIsReceivingWorkersComp?: boolean | null;
  householdIsSelfEmployed?: boolean | null;
  householdLivesInPaloAlto?: boolean | null;
  householdLivesWorksInAlameda?: boolean | null;
  householdLivesWorksInMenloPark?: boolean | null;
  householdLivesWorksInSanCarlos?: boolean | null;
  householdLivesWorksInSanMateo?: boolean | null;
  householdLivesWorksInSouthSf?: boolean | null;
  householdMember0Age?: any | null;
  householdMember0AssetsNotListed0Source?: string | null;
  householdMember0AssetsNotListed0Value?: any | null;
  householdMember0AssetsNotListed1Source?: string | null;
  householdMember0AssetsNotListed1Value?: any | null;
  householdMember0AssetsNotListed2Source?: string | null;
  householdMember0AssetsNotListed2Value?: any | null;
  householdMember0BrokerageName?: string | null;
  householdMember0CashValue?: any | null;
  householdMember0CdMoneyMarketBankName?: string | null;
  householdMember0CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember0CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember0CdMoneyMarketValue?: any | null;
  householdMember0Checking0Balance?: any | null;
  householdMember0Checking0BankName?: string | null;
  householdMember0Checking0IsJointAccount?: boolean | null;
  householdMember0Checking0JointAccountHolderName?: string | null;
  householdMember0Checking1Balance?: any | null;
  householdMember0Checking1BankName?: string | null;
  householdMember0Checking1IsJointAccount?: boolean | null;
  householdMember0Checking1JointAccountHolderName?: string | null;
  householdMember0Checking2Balance?: any | null;
  householdMember0Checking2BankName?: string | null;
  householdMember0Checking2IsJointAccount?: boolean | null;
  householdMember0Checking2JointAccountHolderName?: string | null;
  householdMember0CitizenIdResult?: string | null;
  householdMember0CitizenIdType?: string | null;
  householdMember0DisposedAssetsValue?: any | null;
  householdMember0Dob?: any | null;
  householdMember0Email?: string | null;
  householdMember0Employer0Address?: string | null;
  householdMember0Employer0GrossAnnualIncome?: any | null;
  householdMember0Employer0Name?: string | null;
  householdMember0Employer0YearsAtJob?: string | null;
  householdMember0Employer1Address?: string | null;
  householdMember0Employer1GrossAnnualIncome?: any | null;
  householdMember0Employer1Name?: string | null;
  householdMember0Employer1YearsAtJob?: string | null;
  householdMember0Employer2Address?: string | null;
  householdMember0Employer2GrossAnnualIncome?: any | null;
  householdMember0Employer2Name?: string | null;
  householdMember0Employer2YearsAtJob?: string | null;
  householdMember0EthnicCategory?: string | null;
  householdMember0FirstName?: string | null;
  householdMember0Gender?: string | null;
  householdMember0GenderPronoun?: string | null;
  householdMember0GrossAnnualAlimonyIncome?: any | null;
  householdMember0GrossAnnualChildSupportIncome?: any | null;
  householdMember0GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember0GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember0GrossAnnualGiftIncome?: any | null;
  householdMember0GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember0GrossAnnualPensionIncome?: any | null;
  householdMember0GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember0GrossAnnualPropertyIncome?: any | null;
  householdMember0GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember0GrossAnnualSocialSecurityIncome?: any | null;
  householdMember0GrossAnnualSsiIncome?: any | null;
  householdMember0GrossAnnualUnemploymentIncome?: any | null;
  householdMember0GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember0GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember0GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember0GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember0GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember0GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember0GrossAnnualVetIncome?: any | null;
  householdMember0GrossAnnualWorkCompIncome?: any | null;
  householdMember0Income?: any | null;
  householdMember0Ira401kLumpPensionBalance?: any | null;
  householdMember0Ira401kLumpPensionBankName?: string | null;
  householdMember0Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember0Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember0IsDisabled?: boolean | null;
  householdMember0LastName?: string | null;
  householdMember0MiddleName?: string | null;
  householdMember0NetSelfIncome0?: any | null;
  householdMember0NetSelfIncome1?: any | null;
  householdMember0NetSelfIncome2?: any | null;
  householdMember0NoDob?: boolean | null;
  householdMember0NoEmail?: boolean | null;
  householdMember0NoPrimaryPhone?: boolean | null;
  householdMember0Occupation?: string | null;
  householdMember0PrimaryPhone?: string | null;
  householdMember0PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember0PrimaryPhoneType?: string | null;
  householdMember0RaceAfricanAmerican?: boolean | null;
  householdMember0RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember0RaceAsian?: boolean | null;
  householdMember0RaceDecline?: boolean | null;
  householdMember0RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember0RaceOther?: boolean | null;
  householdMember0RaceWhite?: boolean | null;
  householdMember0RealEstateValue?: any | null;
  householdMember0RelationToApp?: string | null;
  householdMember0RevokTrustValue?: any | null;
  householdMember0Savings0Balance?: any | null;
  householdMember0Savings0BankName?: string | null;
  householdMember0Savings0IsJointAccount?: boolean | null;
  householdMember0Savings0JointAccountHolderName?: string | null;
  householdMember0Savings1Balance?: any | null;
  householdMember0Savings1BankName?: string | null;
  householdMember0Savings1IsJointAccount?: boolean | null;
  householdMember0Savings1JointAccountHolderName?: string | null;
  householdMember0Savings2Balance?: any | null;
  householdMember0Savings2BankName?: string | null;
  householdMember0Savings2IsJointAccount?: boolean | null;
  householdMember0Savings2JointAccountHolderName?: string | null;
  householdMember0SecondaryPhone?: string | null;
  householdMember0SecondaryPhoneExt?: string | null;
  householdMember0SecondaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember0SecondaryPhoneType?: string | null;
  householdMember0SignatureContactType?: string | null;
  householdMember0Social?: string | null;
  householdMember0SsnItinPendingExpectedDate?: any | null;
  householdMember0SsnItinPendingType?: string | null;
  householdMember0StockBondTreasuryValue?: any | null;
  householdMember0StudentType?: string | null;
  householdMember0TaxIdNumber?: string | null;
  householdMember0TotalGrossAnnualIncome?: any | null;
  householdMember0WholeLifeInsuranceValue?: any | null;
  householdMember1Age?: any | null;
  householdMember1AssetsNotListed0Source?: string | null;
  householdMember1AssetsNotListed0Value?: any | null;
  householdMember1AssetsNotListed1Source?: string | null;
  householdMember1AssetsNotListed1Value?: any | null;
  householdMember1AssetsNotListed2Source?: string | null;
  householdMember1AssetsNotListed2Value?: any | null;
  householdMember1BrokerageName?: string | null;
  householdMember1CashValue?: any | null;
  householdMember1CdMoneyMarketBankName?: string | null;
  householdMember1CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember1CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember1CdMoneyMarketValue?: any | null;
  householdMember1Checking0Balance?: any | null;
  householdMember1Checking0BankName?: string | null;
  householdMember1Checking0IsJointAccount?: boolean | null;
  householdMember1Checking0JointAccountHolderName?: string | null;
  householdMember1Checking1Balance?: any | null;
  householdMember1Checking1BankName?: string | null;
  householdMember1Checking1IsJointAccount?: boolean | null;
  householdMember1Checking1JointAccountHolderName?: string | null;
  householdMember1Checking2Balance?: any | null;
  householdMember1Checking2BankName?: string | null;
  householdMember1Checking2IsJointAccount?: boolean | null;
  householdMember1Checking2JointAccountHolderName?: string | null;
  householdMember1CitizenIdResult?: string | null;
  householdMember1CitizenIdType?: string | null;
  householdMember1DisposedAssetsValue?: any | null;
  householdMember1Dob?: any | null;
  householdMember1Email?: string | null;
  householdMember1Employer0Address?: string | null;
  householdMember1Employer0GrossAnnualIncome?: any | null;
  householdMember1Employer0Name?: string | null;
  householdMember1Employer0YearsAtJob?: string | null;
  householdMember1Employer1Address?: string | null;
  householdMember1Employer1GrossAnnualIncome?: any | null;
  householdMember1Employer1Name?: string | null;
  householdMember1Employer1YearsAtJob?: string | null;
  householdMember1Employer2Address?: string | null;
  householdMember1Employer2GrossAnnualIncome?: any | null;
  householdMember1Employer2Name?: string | null;
  householdMember1Employer2YearsAtJob?: string | null;
  householdMember1EthnicCategory?: string | null;
  householdMember1FirstName?: string | null;
  householdMember1Gender?: string | null;
  householdMember1GenderPronoun?: string | null;
  householdMember1GrossAnnualAlimonyIncome?: any | null;
  householdMember1GrossAnnualChildSupportIncome?: any | null;
  householdMember1GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember1GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember1GrossAnnualGiftIncome?: any | null;
  householdMember1GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember1GrossAnnualPensionIncome?: any | null;
  householdMember1GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember1GrossAnnualPropertyIncome?: any | null;
  householdMember1GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember1GrossAnnualSocialSecurityIncome?: any | null;
  householdMember1GrossAnnualSsiIncome?: any | null;
  householdMember1GrossAnnualUnemploymentIncome?: any | null;
  householdMember1GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember1GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember1GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember1GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember1GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember1GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember1GrossAnnualVetIncome?: any | null;
  householdMember1GrossAnnualWorkCompIncome?: any | null;
  householdMember1Income?: any | null;
  householdMember1Ira401kLumpPensionBalance?: any | null;
  householdMember1Ira401kLumpPensionBankName?: string | null;
  householdMember1Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember1Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember1IsDisabled?: boolean | null;
  householdMember1LastName?: string | null;
  householdMember1NetSelfIncome0?: any | null;
  householdMember1NetSelfIncome1?: any | null;
  householdMember1NetSelfIncome2?: any | null;
  householdMember1NoDob?: boolean | null;
  householdMember1NoEmail?: boolean | null;
  householdMember1NoPrimaryPhone?: boolean | null;
  householdMember1Occupation?: string | null;
  householdMember1PrimaryPhone?: string | null;
  householdMember1PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember1PrimaryPhoneType?: string | null;
  householdMember1RaceAfricanAmerican?: boolean | null;
  householdMember1RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember1RaceAsian?: boolean | null;
  householdMember1RaceDecline?: boolean | null;
  householdMember1RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember1RaceOther?: boolean | null;
  householdMember1RaceWhite?: boolean | null;
  householdMember1RealEstateValue?: any | null;
  householdMember1RelationToApp?: string | null;
  householdMember1RevokTrustValue?: any | null;
  householdMember1Savings0Balance?: any | null;
  householdMember1Savings0BankName?: string | null;
  householdMember1Savings0IsJointAccount?: boolean | null;
  householdMember1Savings0JointAccountHolderName?: string | null;
  householdMember1Savings1Balance?: any | null;
  householdMember1Savings1BankName?: string | null;
  householdMember1Savings1IsJointAccount?: boolean | null;
  householdMember1Savings1JointAccountHolderName?: string | null;
  householdMember1Savings2Balance?: any | null;
  householdMember1Savings2BankName?: string | null;
  householdMember1Savings2IsJointAccount?: boolean | null;
  householdMember1Savings2JointAccountHolderName?: string | null;
  householdMember1SecondaryPhoneExt?: string | null;
  householdMember1SignatureContactType?: string | null;
  householdMember1Social?: string | null;
  householdMember1SsnItinPendingExpectedDate?: any | null;
  householdMember1SsnItinPendingType?: string | null;
  householdMember1StockBondTreasuryValue?: any | null;
  householdMember1StudentType?: string | null;
  householdMember1TaxIdNumber?: string | null;
  householdMember1TotalGrossAnnualIncome?: any | null;
  householdMember1WholeLifeInsuranceValue?: any | null;
  householdMember2Age?: any | null;
  householdMember2AssetsNotListed0Source?: string | null;
  householdMember2AssetsNotListed0Value?: any | null;
  householdMember2AssetsNotListed1Source?: string | null;
  householdMember2AssetsNotListed1Value?: any | null;
  householdMember2AssetsNotListed2Source?: string | null;
  householdMember2AssetsNotListed2Value?: any | null;
  householdMember2BrokerageName?: string | null;
  householdMember2CashValue?: any | null;
  householdMember2CdMoneyMarketBankName?: string | null;
  householdMember2CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember2CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember2CdMoneyMarketValue?: any | null;
  householdMember2Checking0Balance?: any | null;
  householdMember2Checking0BankName?: string | null;
  householdMember2Checking0IsJointAccount?: boolean | null;
  householdMember2Checking0JointAccountHolderName?: string | null;
  householdMember2Checking1Balance?: any | null;
  householdMember2Checking1BankName?: string | null;
  householdMember2Checking1IsJointAccount?: boolean | null;
  householdMember2Checking1JointAccountHolderName?: string | null;
  householdMember2Checking2Balance?: any | null;
  householdMember2Checking2BankName?: string | null;
  householdMember2Checking2IsJointAccount?: boolean | null;
  householdMember2Checking2JointAccountHolderName?: string | null;
  householdMember2CitizenIdResult?: string | null;
  householdMember2CitizenIdType?: string | null;
  householdMember2DisposedAssetsValue?: any | null;
  householdMember2Dob?: any | null;
  householdMember2Email?: string | null;
  householdMember2Employer0Address?: string | null;
  householdMember2Employer0GrossAnnualIncome?: any | null;
  householdMember2Employer0Name?: string | null;
  householdMember2Employer0YearsAtJob?: string | null;
  householdMember2Employer1Address?: string | null;
  householdMember2Employer1GrossAnnualIncome?: any | null;
  householdMember2Employer1Name?: string | null;
  householdMember2Employer1YearsAtJob?: string | null;
  householdMember2Employer2Address?: string | null;
  householdMember2Employer2GrossAnnualIncome?: any | null;
  householdMember2Employer2Name?: string | null;
  householdMember2Employer2YearsAtJob?: string | null;
  householdMember2EthnicCategory?: string | null;
  householdMember2FirstName?: string | null;
  householdMember2Gender?: string | null;
  householdMember2GenderPronoun?: string | null;
  householdMember2GrossAnnualAlimonyIncome?: any | null;
  householdMember2GrossAnnualChildSupportIncome?: any | null;
  householdMember2GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember2GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember2GrossAnnualGiftIncome?: any | null;
  householdMember2GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember2GrossAnnualPensionIncome?: any | null;
  householdMember2GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember2GrossAnnualPropertyIncome?: any | null;
  householdMember2GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember2GrossAnnualSocialSecurityIncome?: any | null;
  householdMember2GrossAnnualSsiIncome?: any | null;
  householdMember2GrossAnnualUnemploymentIncome?: any | null;
  householdMember2GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember2GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember2GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember2GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember2GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember2GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember2GrossAnnualVetIncome?: any | null;
  householdMember2GrossAnnualWorkCompIncome?: any | null;
  householdMember2Income?: any | null;
  householdMember2Ira401kLumpPensionBalance?: any | null;
  householdMember2Ira401kLumpPensionBankName?: string | null;
  householdMember2Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember2Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember2IsDisabled?: boolean | null;
  householdMember2LastName?: string | null;
  householdMember2NetSelfIncome0?: any | null;
  householdMember2NetSelfIncome1?: any | null;
  householdMember2NetSelfIncome2?: any | null;
  householdMember2NoDob?: boolean | null;
  householdMember2NoEmail?: boolean | null;
  householdMember2NoPrimaryPhone?: boolean | null;
  householdMember2Occupation?: string | null;
  householdMember2PrimaryPhone?: string | null;
  householdMember2PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember2PrimaryPhoneType?: string | null;
  householdMember2RaceAfricanAmerican?: boolean | null;
  householdMember2RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember2RaceAsian?: boolean | null;
  householdMember2RaceDecline?: boolean | null;
  householdMember2RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember2RaceOther?: boolean | null;
  householdMember2RaceWhite?: boolean | null;
  householdMember2RealEstateValue?: any | null;
  householdMember2RelationToApp?: string | null;
  householdMember2RevokTrustValue?: any | null;
  householdMember2Savings0Balance?: any | null;
  householdMember2Savings0BankName?: string | null;
  householdMember2Savings0IsJointAccount?: boolean | null;
  householdMember2Savings0JointAccountHolderName?: string | null;
  householdMember2Savings1Balance?: any | null;
  householdMember2Savings1BankName?: string | null;
  householdMember2Savings1IsJointAccount?: boolean | null;
  householdMember2Savings1JointAccountHolderName?: string | null;
  householdMember2Savings2Balance?: any | null;
  householdMember2Savings2BankName?: string | null;
  householdMember2Savings2IsJointAccount?: boolean | null;
  householdMember2Savings2JointAccountHolderName?: string | null;
  householdMember2SecondaryPhoneExt?: string | null;
  householdMember2SignatureContactType?: string | null;
  householdMember2Social?: string | null;
  householdMember2SsnItinPendingExpectedDate?: any | null;
  householdMember2SsnItinPendingType?: string | null;
  householdMember2StockBondTreasuryValue?: any | null;
  householdMember2StudentType?: string | null;
  householdMember2TaxIdNumber?: string | null;
  householdMember2TotalGrossAnnualIncome?: any | null;
  householdMember2WholeLifeInsuranceValue?: any | null;
  householdMember3Age?: any | null;
  householdMember3AssetsNotListed0Source?: string | null;
  householdMember3AssetsNotListed0Value?: any | null;
  householdMember3AssetsNotListed1Source?: string | null;
  householdMember3AssetsNotListed1Value?: any | null;
  householdMember3AssetsNotListed2Source?: string | null;
  householdMember3AssetsNotListed2Value?: any | null;
  householdMember3BrokerageName?: string | null;
  householdMember3CashValue?: any | null;
  householdMember3CdMoneyMarketBankName?: string | null;
  householdMember3CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember3CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember3CdMoneyMarketValue?: any | null;
  householdMember3Checking0Balance?: any | null;
  householdMember3Checking0BankName?: string | null;
  householdMember3Checking0IsJointAccount?: boolean | null;
  householdMember3Checking0JointAccountHolderName?: string | null;
  householdMember3Checking1Balance?: any | null;
  householdMember3Checking1BankName?: string | null;
  householdMember3Checking1IsJointAccount?: boolean | null;
  householdMember3Checking1JointAccountHolderName?: string | null;
  householdMember3Checking2Balance?: any | null;
  householdMember3Checking2BankName?: string | null;
  householdMember3Checking2IsJointAccount?: boolean | null;
  householdMember3Checking2JointAccountHolderName?: string | null;
  householdMember3CitizenIdResult?: string | null;
  householdMember3CitizenIdType?: string | null;
  householdMember3DisposedAssetsValue?: any | null;
  householdMember3Dob?: any | null;
  householdMember3Email?: string | null;
  householdMember3Employer0Address?: string | null;
  householdMember3Employer0GrossAnnualIncome?: any | null;
  householdMember3Employer0Name?: string | null;
  householdMember3Employer0YearsAtJob?: string | null;
  householdMember3Employer1Address?: string | null;
  householdMember3Employer1GrossAnnualIncome?: any | null;
  householdMember3Employer1Name?: string | null;
  householdMember3Employer1YearsAtJob?: string | null;
  householdMember3Employer2Address?: string | null;
  householdMember3Employer2GrossAnnualIncome?: any | null;
  householdMember3Employer2Name?: string | null;
  householdMember3Employer2YearsAtJob?: string | null;
  householdMember3EthnicCategory?: string | null;
  householdMember3FirstName?: string | null;
  householdMember3Gender?: string | null;
  householdMember3GenderPronoun?: string | null;
  householdMember3GrossAnnualAlimonyIncome?: any | null;
  householdMember3GrossAnnualChildSupportIncome?: any | null;
  householdMember3GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember3GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember3GrossAnnualGiftIncome?: any | null;
  householdMember3GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember3GrossAnnualPensionIncome?: any | null;
  householdMember3GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember3GrossAnnualPropertyIncome?: any | null;
  householdMember3GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember3GrossAnnualSocialSecurityIncome?: any | null;
  householdMember3GrossAnnualSsiIncome?: any | null;
  householdMember3GrossAnnualUnemploymentIncome?: any | null;
  householdMember3GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember3GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember3GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember3GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember3GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember3GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember3GrossAnnualVetIncome?: any | null;
  householdMember3GrossAnnualWorkCompIncome?: any | null;
  householdMember3Income?: any | null;
  householdMember3Ira401kLumpPensionBalance?: any | null;
  householdMember3Ira401kLumpPensionBankName?: string | null;
  householdMember3Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember3Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember3IsDisabled?: boolean | null;
  householdMember3LastName?: string | null;
  householdMember3NetSelfIncome0?: any | null;
  householdMember3NetSelfIncome1?: any | null;
  householdMember3NetSelfIncome2?: any | null;
  householdMember3NoDob?: boolean | null;
  householdMember3NoEmail?: boolean | null;
  householdMember3NoPrimaryPhone?: boolean | null;
  householdMember3Occupation?: string | null;
  householdMember3PrimaryPhone?: string | null;
  householdMember3PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember3PrimaryPhoneType?: string | null;
  householdMember3RaceAfricanAmerican?: boolean | null;
  householdMember3RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember3RaceAsian?: boolean | null;
  householdMember3RaceDecline?: boolean | null;
  householdMember3RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember3RaceOther?: boolean | null;
  householdMember3RaceWhite?: boolean | null;
  householdMember3RealEstateValue?: any | null;
  householdMember3RelationToApp?: string | null;
  householdMember3RevokTrustValue?: any | null;
  householdMember3Savings0Balance?: any | null;
  householdMember3Savings0BankName?: string | null;
  householdMember3Savings0IsJointAccount?: boolean | null;
  householdMember3Savings0JointAccountHolderName?: string | null;
  householdMember3Savings1Balance?: any | null;
  householdMember3Savings1BankName?: string | null;
  householdMember3Savings1IsJointAccount?: boolean | null;
  householdMember3Savings1JointAccountHolderName?: string | null;
  householdMember3Savings2Balance?: any | null;
  householdMember3Savings2BankName?: string | null;
  householdMember3Savings2IsJointAccount?: boolean | null;
  householdMember3Savings2JointAccountHolderName?: string | null;
  householdMember3SecondaryPhoneExt?: string | null;
  householdMember3SignatureContactType?: string | null;
  householdMember3Social?: string | null;
  householdMember3SsnItinPendingExpectedDate?: any | null;
  householdMember3SsnItinPendingType?: string | null;
  householdMember3StockBondTreasuryValue?: any | null;
  householdMember3StudentType?: string | null;
  householdMember3TaxIdNumber?: string | null;
  householdMember3TotalGrossAnnualIncome?: any | null;
  householdMember3WholeLifeInsuranceValue?: any | null;
  householdMember4Age?: any | null;
  householdMember4AssetsNotListed0Source?: string | null;
  householdMember4AssetsNotListed0Value?: any | null;
  householdMember4AssetsNotListed1Source?: string | null;
  householdMember4AssetsNotListed1Value?: any | null;
  householdMember4AssetsNotListed2Source?: string | null;
  householdMember4AssetsNotListed2Value?: any | null;
  householdMember4BrokerageName?: string | null;
  householdMember4CashValue?: any | null;
  householdMember4CdMoneyMarketBankName?: string | null;
  householdMember4CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember4CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember4CdMoneyMarketValue?: any | null;
  householdMember4Checking0Balance?: any | null;
  householdMember4Checking0BankName?: string | null;
  householdMember4Checking0IsJointAccount?: boolean | null;
  householdMember4Checking0JointAccountHolderName?: string | null;
  householdMember4Checking1Balance?: any | null;
  householdMember4Checking1BankName?: string | null;
  householdMember4Checking1IsJointAccount?: boolean | null;
  householdMember4Checking1JointAccountHolderName?: string | null;
  householdMember4Checking2Balance?: any | null;
  householdMember4Checking2BankName?: string | null;
  householdMember4Checking2IsJointAccount?: boolean | null;
  householdMember4Checking2JointAccountHolderName?: string | null;
  householdMember4CitizenIdResult?: string | null;
  householdMember4CitizenIdType?: string | null;
  householdMember4DisposedAssetsValue?: any | null;
  householdMember4Dob?: any | null;
  householdMember4Email?: string | null;
  householdMember4Employer0Address?: string | null;
  householdMember4Employer0GrossAnnualIncome?: any | null;
  householdMember4Employer0Name?: string | null;
  householdMember4Employer0YearsAtJob?: string | null;
  householdMember4Employer1Address?: string | null;
  householdMember4Employer1GrossAnnualIncome?: any | null;
  householdMember4Employer1Name?: string | null;
  householdMember4Employer1YearsAtJob?: string | null;
  householdMember4Employer2Address?: string | null;
  householdMember4Employer2GrossAnnualIncome?: any | null;
  householdMember4Employer2Name?: string | null;
  householdMember4Employer2YearsAtJob?: string | null;
  householdMember4EthnicCategory?: string | null;
  householdMember4FirstName?: string | null;
  householdMember4Gender?: string | null;
  householdMember4GenderPronoun?: string | null;
  householdMember4GrossAnnualAlimonyIncome?: any | null;
  householdMember4GrossAnnualChildSupportIncome?: any | null;
  householdMember4GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember4GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember4GrossAnnualGiftIncome?: any | null;
  householdMember4GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember4GrossAnnualPensionIncome?: any | null;
  householdMember4GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember4GrossAnnualPropertyIncome?: any | null;
  householdMember4GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember4GrossAnnualSocialSecurityIncome?: any | null;
  householdMember4GrossAnnualSsiIncome?: any | null;
  householdMember4GrossAnnualUnemploymentIncome?: any | null;
  householdMember4GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember4GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember4GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember4GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember4GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember4GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember4GrossAnnualVetIncome?: any | null;
  householdMember4GrossAnnualWorkCompIncome?: any | null;
  householdMember4Income?: any | null;
  householdMember4Ira401kLumpPensionBalance?: any | null;
  householdMember4Ira401kLumpPensionBankName?: string | null;
  householdMember4Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember4Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember4IsDisabled?: boolean | null;
  householdMember4LastName?: string | null;
  householdMember4NetSelfIncome0?: any | null;
  householdMember4NetSelfIncome1?: any | null;
  householdMember4NetSelfIncome2?: any | null;
  householdMember4NoDob?: boolean | null;
  householdMember4NoEmail?: boolean | null;
  householdMember4NoPrimaryPhone?: boolean | null;
  householdMember4Occupation?: string | null;
  householdMember4PrimaryPhone?: string | null;
  householdMember4PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember4PrimaryPhoneType?: string | null;
  householdMember4RaceAfricanAmerican?: boolean | null;
  householdMember4RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember4RaceAsian?: boolean | null;
  householdMember4RaceDecline?: boolean | null;
  householdMember4RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember4RaceOther?: boolean | null;
  householdMember4RaceWhite?: boolean | null;
  householdMember4RealEstateValue?: any | null;
  householdMember4RelationToApp?: string | null;
  householdMember4RevokTrustValue?: any | null;
  householdMember4Savings0Balance?: any | null;
  householdMember4Savings0BankName?: string | null;
  householdMember4Savings0IsJointAccount?: boolean | null;
  householdMember4Savings0JointAccountHolderName?: string | null;
  householdMember4Savings1Balance?: any | null;
  householdMember4Savings1BankName?: string | null;
  householdMember4Savings1IsJointAccount?: boolean | null;
  householdMember4Savings1JointAccountHolderName?: string | null;
  householdMember4Savings2Balance?: any | null;
  householdMember4Savings2BankName?: string | null;
  householdMember4Savings2IsJointAccount?: boolean | null;
  householdMember4Savings2JointAccountHolderName?: string | null;
  householdMember4SecondaryPhoneExt?: string | null;
  householdMember4SignatureContactType?: string | null;
  householdMember4Social?: string | null;
  householdMember4SsnItinPendingExpectedDate?: any | null;
  householdMember4SsnItinPendingType?: string | null;
  householdMember4StockBondTreasuryValue?: any | null;
  householdMember4StudentType?: string | null;
  householdMember4TaxIdNumber?: string | null;
  householdMember4TotalGrossAnnualIncome?: any | null;
  householdMember4WholeLifeInsuranceValue?: any | null;
  householdMember5Age?: any | null;
  householdMember5AssetsNotListed0Source?: string | null;
  householdMember5AssetsNotListed0Value?: any | null;
  householdMember5AssetsNotListed1Source?: string | null;
  householdMember5AssetsNotListed1Value?: any | null;
  householdMember5AssetsNotListed2Source?: string | null;
  householdMember5AssetsNotListed2Value?: any | null;
  householdMember5BrokerageName?: string | null;
  householdMember5CashValue?: any | null;
  householdMember5CdMoneyMarketBankName?: string | null;
  householdMember5CdMoneyMarketIsJointAccount?: boolean | null;
  householdMember5CdMoneyMarketJointAccountHolderName?: string | null;
  householdMember5CdMoneyMarketValue?: any | null;
  householdMember5Checking0Balance?: any | null;
  householdMember5Checking0BankName?: string | null;
  householdMember5Checking0IsJointAccount?: boolean | null;
  householdMember5Checking0JointAccountHolderName?: string | null;
  householdMember5Checking1Balance?: any | null;
  householdMember5Checking1BankName?: string | null;
  householdMember5Checking1IsJointAccount?: boolean | null;
  householdMember5Checking1JointAccountHolderName?: string | null;
  householdMember5Checking2Balance?: any | null;
  householdMember5Checking2BankName?: string | null;
  householdMember5Checking2IsJointAccount?: boolean | null;
  householdMember5Checking2JointAccountHolderName?: string | null;
  householdMember5CitizenIdResult?: string | null;
  householdMember5CitizenIdType?: string | null;
  householdMember5DisposedAssetsValue?: any | null;
  householdMember5Dob?: any | null;
  householdMember5Email?: string | null;
  householdMember5Employer0Address?: string | null;
  householdMember5Employer0GrossAnnualIncome?: any | null;
  householdMember5Employer0Name?: string | null;
  householdMember5Employer0YearsAtJob?: string | null;
  householdMember5Employer1Address?: string | null;
  householdMember5Employer1GrossAnnualIncome?: any | null;
  householdMember5Employer1Name?: string | null;
  householdMember5Employer1YearsAtJob?: string | null;
  householdMember5Employer2Address?: string | null;
  householdMember5Employer2GrossAnnualIncome?: any | null;
  householdMember5Employer2Name?: string | null;
  householdMember5Employer2YearsAtJob?: string | null;
  householdMember5EthnicCategory?: string | null;
  householdMember5FirstName?: string | null;
  householdMember5Gender?: string | null;
  householdMember5GenderPronoun?: string | null;
  householdMember5GrossAnnualAlimonyIncome?: any | null;
  householdMember5GrossAnnualChildSupportIncome?: any | null;
  householdMember5GrossAnnualDisabilityBenefitsIncome?: any | null;
  householdMember5GrossAnnualEntitledToChildSupportIncome?: any | null;
  householdMember5GrossAnnualGiftIncome?: any | null;
  householdMember5GrossAnnualNonLoanFinancialAidIncome?: any | null;
  householdMember5GrossAnnualPensionIncome?: any | null;
  householdMember5GrossAnnualPeriodicPaymentsIncome?: any | null;
  householdMember5GrossAnnualPropertyIncome?: any | null;
  householdMember5GrossAnnualPublicAssistanceIncome?: any | null;
  householdMember5GrossAnnualSocialSecurityIncome?: any | null;
  householdMember5GrossAnnualSsiIncome?: any | null;
  householdMember5GrossAnnualUnemploymentIncome?: any | null;
  householdMember5GrossAnnualUnlistedIncome0Source?: string | null;
  householdMember5GrossAnnualUnlistedIncome0Value?: any | null;
  householdMember5GrossAnnualUnlistedIncome1Source?: string | null;
  householdMember5GrossAnnualUnlistedIncome1Value?: any | null;
  householdMember5GrossAnnualUnlistedIncome2Source?: string | null;
  householdMember5GrossAnnualUnlistedIncome2Value?: any | null;
  householdMember5GrossAnnualVetIncome?: any | null;
  householdMember5GrossAnnualWorkCompIncome?: any | null;
  householdMember5Income?: any | null;
  householdMember5Ira401kLumpPensionBalance?: any | null;
  householdMember5Ira401kLumpPensionBankName?: string | null;
  householdMember5Ira401kLumpPensionIsJointAccount?: boolean | null;
  householdMember5Ira401kLumpPensionJointAccountHolderName?: string | null;
  householdMember5IsDisabled?: boolean | null;
  householdMember5LastName?: string | null;
  householdMember5NetSelfIncome0?: any | null;
  householdMember5NetSelfIncome1?: any | null;
  householdMember5NetSelfIncome2?: any | null;
  householdMember5NoDob?: boolean | null;
  householdMember5NoEmail?: boolean | null;
  householdMember5NoPrimaryPhone?: boolean | null;
  householdMember5Occupation?: string | null;
  householdMember5PrimaryPhone?: string | null;
  householdMember5PrimaryPhoneOkToLeaveMessage?: boolean | null;
  householdMember5PrimaryPhoneType?: string | null;
  householdMember5RaceAfricanAmerican?: boolean | null;
  householdMember5RaceAmerIndianAlaskanNative?: boolean | null;
  householdMember5RaceAsian?: boolean | null;
  householdMember5RaceDecline?: boolean | null;
  householdMember5RaceNativeHawaiianOrOtherPacIslander?: boolean | null;
  householdMember5RaceOther?: boolean | null;
  householdMember5RaceWhite?: boolean | null;
  householdMember5RealEstateValue?: any | null;
  householdMember5RelationToApp?: string | null;
  householdMember5RevokTrustValue?: any | null;
  householdMember5Savings0Balance?: any | null;
  householdMember5Savings0BankName?: string | null;
  householdMember5Savings0IsJointAccount?: boolean | null;
  householdMember5Savings0JointAccountHolderName?: string | null;
  householdMember5Savings1Balance?: any | null;
  householdMember5Savings1BankName?: string | null;
  householdMember5Savings1IsJointAccount?: boolean | null;
  householdMember5Savings1JointAccountHolderName?: string | null;
  householdMember5Savings2Balance?: any | null;
  householdMember5Savings2BankName?: string | null;
  householdMember5Savings2IsJointAccount?: boolean | null;
  householdMember5Savings2JointAccountHolderName?: string | null;
  householdMember5SecondaryPhoneExt?: string | null;
  householdMember5SignatureContactType?: string | null;
  householdMember5Social?: string | null;
  householdMember5SsnItinPendingExpectedDate?: any | null;
  householdMember5SsnItinPendingType?: string | null;
  householdMember5StockBondTreasuryValue?: any | null;
  householdMember5StudentType?: string | null;
  householdMember5TaxIdNumber?: string | null;
  householdMember5TotalGrossAnnualIncome?: any | null;
  householdMember5WholeLifeInsuranceValue?: any | null;
  householdOwnsCar?: boolean | null;
  householdPetDescription?: string | null;
  householdReceivesOtherHousingAssistance?: boolean | null;
  householdReceivesOtherHousingAssistanceSubsidyType?: string | null;
  householdRequiresImpairmentHearing?: boolean | null;
  householdRequiresImpairmentMobility?: boolean | null;
  householdRequiresImpairmentVisual?: boolean | null;
  householdServedInArmedForces?: boolean | null;
  householdWorksInPaloAlto?: boolean | null;
  howDidApplicantHearAboutProperty?: string | null;
  income0Amount?: any | null;
  income0Source?: string | null;
  income1Amount?: any | null;
  income1Source?: string | null;
  income2Amount?: any | null;
  income2Source?: string | null;
  income3Amount?: any | null;
  income3Source?: string | null;
  isComplete?: boolean | null;
  isDuplicate?: boolean | null;
  isPaper?: boolean | null;
  isRentSubsidized?: boolean | null;
  landlordAddress1?: string | null;
  landlordCity?: string | null;
  landlordEmail?: string | null;
  landlordFirstName?: string | null;
  landlordHasUnknownAddress?: boolean | null;
  landlordHasUnknownPhone?: boolean | null;
  landlordLastName?: string | null;
  landlordOkToLeaveMessage?: boolean | null;
  landlordPrimaryPhone?: string | null;
  landlordPrimaryPhoneType?: string | null;
  landlordState?: string | null;
  landlordSteNumber?: string | null;
  landlordZip?: string | null;
  linkCode?: string | null;
  mailingAddress1?: string | null;
  mailingAddressType?: string | null;
  mailingCity?: string | null;
  mailingState?: string | null;
  mailingSteNumber?: string | null;
  mailingZip?: string | null;
  manuallyEntered?: boolean | null;
  prefLang?: string | null;
  prefMoveInDate?: string | null;
  reasonForMoving?: string | null;
  residenceAddress1?: string | null;
  residenceCity?: string | null;
  residenceHousingType?: string | null;
  residenceState?: string | null;
  residenceSteNumber?: string | null;
  residenceZip?: string | null;
  sendEmailReceiptToAdditionalEmail?: boolean | null;
  signatureId?: string | null;
  signupForHavenNewsletter?: boolean | null;
  submittedAt?: number | null;
  unitSize?: string | null;
  unitSize1br?: boolean | null;
  unitSize1brDen?: boolean | null;
  unitSize2br?: boolean | null;
  unitSize3br?: boolean | null;
  unitSize4br?: boolean | null;
  unitSize5br?: boolean | null;
  unitSizeShared?: boolean | null;
  unitSizeSro?: boolean | null;
  unitSizeStudio?: boolean | null;
  worksInPaloAltoSite?: string | null;
}

export interface InterestListInput {
  address?: AddressInput | null;
  br0Statement?: string | null;
  br1DenStatement?: string | null;
  br1Statement?: string | null;
  br2Statement?: string | null;
  br3Statement?: string | null;
  br4Statement?: string | null;
  br5Statement?: string | null;
  email?: string | null;
  hasPaperDisclaimer?: boolean | null;
  incomeStatement?: string | null;
  isArchived?: boolean | null;
  isOpen?: boolean | null;
  name?: string | null;
  organizationId?: string | null;
  phone?: string | null;
  sharedStatement?: string | null;
  type?: string | null;
  unitSizeStatement?: string | null;
}

export interface InvoicedCustomerInput {
  active: boolean;
  invoicedId?: string | null;
}

export interface InvoicedPlanIdsInput {
  annually?: string | null;
  quarterly?: string | null;
}

export interface ListItemInput {
  id?: string | null;
  name?: string | null;
}

/**
 * Input for manually creating or editing a property contract (no e-signature)
 */
export interface ManualPropertyContractInput {
  billingFrequency?: string | null;
  contractStartDate?: any;
  initialTermEndDate?: any;
  organizationId?: string | null;
  planId?: any;
  propertyAddress?: string | null;
  propertyAddressParts?: ContractAddressPartsInput | null;
  propertyEmail?: string | null;
  propertyId?: string | null;
  propertyLegalName?: string | null;
  propertyName?: string | null;
  propertyPhone?: string | null;
  runPostSignSetup?: boolean | null;
  signedAt?: any;
  signedPdfBase64?: string | null;
  signerUserId?: any | null;
  status: string;
  subscriptionId?: any | null;
  unitCount?: number | null;
}

export interface OrganizationInput {
  address1?: string | null;
  address2?: string | null;
  bccEmail?: string | null;
  city?: string | null;
  email?: string | null;
  invoicedCustomer?: InvoicedCustomerInput | null;
  logoFilename?: string | null;
  name?: string | null;
  phone?: string | null;
  pmVisibility?: string | null;
  state?: string | null;
  type?: string | null;
  whoCanAssign?: string | null;
  zip?: string | null;
}

export interface PlanInput {
  defaultPricingId?: string | null;
  description: string;
  invoicedPlanIds?: InvoicedPlanIdsInput | null;
  isPublic?: boolean | null;
  name: string;
}

export interface PlanUpdateInput {
  defaultPricingId?: string | null;
  description?: string | null;
  invoicedPlanIds?: InvoicedPlanIdsInput | null;
  isPublic?: boolean | null;
  name?: string | null;
}

export interface PricingCalculatorInput {
  minimumPrice?: any | null;
  monthlyPricePerUnit?: any | null;
  pricingTypeId?: number | null;
  tiers?: (PricingTierInput | null)[] | null;
  unitThreshold?: number | null;
}

export interface PricingInput {
  annualDiscountPercent?: number | null;
  minimumPrice?: any | null;
  monthlyPricePerUnit?: any | null;
  pricingTypeId?: string | null;
  thresholdTypeId?: string | null;
  tiers?: (PricingTierInput | null)[] | null;
  unitThreshold?: number | null;
}

export interface PricingTierInput {
  lowerThreshold: number;
  monthlyPrice: any;
}

export interface PricingUpdateInput {
  annualDiscountPercent?: number | null;
  minimumPrice?: any | null;
  monthlyPricePerUnit?: any | null;
  pricingTypeId?: number | null;
  thresholdTypeId?: number | null;
  tiers?: (PricingTierInput | null)[] | null;
  unitThreshold?: number | null;
}

export interface PropertyCreateInput {
  address?: AddressInput | null;
  email?: string | null;
  interestListId?: string | null;
  invoicedCustomer?: InvoicedCustomerInput | null;
  name?: string | null;
  organizationId?: string | null;
  phone?: string | null;
  phoneExt?: string | null;
  submissionDigestEnabled: boolean;
  timezone?: string | null;
  units?: number | null;
}

export interface PropertyUpdateInput {
  address?: AddressInput | null;
  email?: string | null;
  interestListId?: string | null;
  invoicedCustomer?: InvoicedCustomerInput | null;
  name?: string | null;
  organizationId?: string | null;
  phone?: string | null;
  phoneExt?: string | null;
  reinstatementEmail?: string | null;
  reinstatementEmailFrequency?: string | null;
  respondToEmail?: string | null;
  respondToEmailEnabled?: boolean | null;
  submissionDigestEnabled?: boolean | null;
  timezone?: string | null;
  units?: number | null;
}

export interface PropertyUseCaseInput {
  active: boolean;
  applicationId?: string | null;
  messageId: string;
  propertyId: string;
  smsPrefix?: string | null;
  useCaseId: number;
}

/**
 * Input for saving draft progress
 */
export interface SavePropertyContractProgressInput {
  stepIndex: number;
  submissionId?: any | null;
  valuesJson: string;
}

export interface SendPropertyQuoteEmailInput {
  billingCycle: string;
  planId: any;
  propertyName: string;
  recipientEmail?: string | null;
  unitCount: number;
}

export interface SkipInterestInput {
  note?: string | null;
  resourceId?: string | null;
}

export interface SubmissionDocumentInput {
  filename: string;
  size: number;
}

export interface SubscriptionInput {
  billingFrequencyId: number;
  endDate: any;
  interestListId: string;
  planId: string;
  pricingId: string;
  propertyId: string;
  renewalDate?: any | null;
  startDate: any;
}

export interface SubscriptionUpdateInput {
  billingFrequencyId?: number | null;
  endDate: any;
  interestListId?: string | null;
  planId?: string | null;
  pricingId?: string | null;
  propertyId?: string | null;
  renewalDate?: any | null;
  startDate: any;
}

export interface TemplateGroupCreateInput {
  orgTemplate?: boolean | null;
  propertyIds?: (string | null)[] | null;
  propertyTemplate?: boolean | null;
  template?: TemplateGroupInputs | null;
  templates?: (ChannelTemplate | null)[] | null;
}

export interface TemplateGroupInputs {
  name?: string | null;
}

export interface UpdateBuildingInput {
  address1?: string | null;
  address2?: string | null;
  bin?: string | null;
  city?: string | null;
  name?: string | null;
  phase?: string | null;
  state?: UsState | null;
  type?: BuildingType | null;
  zip?: string | null;
}

export interface UpdateBuildingUnitInput {
  accessibility?: (string | null)[] | null;
  bathrooms?: number | null;
  bedrooms?: string | null;
  buildingId?: string | null;
  floor?: number | null;
  fundingSource?: (string | null)[] | null;
  incomeDesignation?: string | null;
  isReferral?: boolean | null;
  name?: string | null;
  occupancyMax?: number | null;
  occupancyMin?: number | null;
  occupied?: string | null;
  preference?: (string | null)[] | null;
  referralOrg?: string | null;
  rentType?: string | null;
  rentValue?: number | null;
  sqft?: number | null;
}

export interface UserInput {
  directPhone?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  lists?: (ListItemInput | null)[] | null;
  organizationId?: string | null;
  password?: string | null;
  phone?: string | null;
  roles?: (UserRole | null)[] | null;
  title?: string | null;
}

export interface UserProfileAddressInput {
  address1: string;
  address2?: string | null;
  city: string;
  id?: string | null;
  state: string;
  zip: string;
}

export interface WaitlistUpdateOptions {
  enabled?: boolean | null;
  letterDelay?: boolean | null;
  letterMode?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
